import LangType from '@/languages/LangType'
const languageVersion = `drogbruk`
const lang = (new LangType(languageVersion)).get()

const pl_drogbruk = { // eslint-disable-line
  null: `brak`,
  notAssigned: `Nieprzypisany`,
  currency: 'zł',
  alerts: {
    loading: `Ładowanie`
  },
  roles: {
    roleSuperUser: `Superuser`,
    roleDispatcher: `${lang.roles.roleDispatcher}`,
    roleServiceman: `${lang.roles.roleServiceman}`,
    roleManager: `Menadżer`,
    roleClient: `Klient`,
    roleOwner: `Właściciel`,
    roleReception: 'Recepcja',
    roleOfficeUser: 'Pracownik biurowy',
    roleAccountant: 'Księgowy',
    roleWholesaler: 'Hurtownia',
    roleControlling: 'Controlling',
    roleFirm: 'Firma'
  },
  global: {
    processingRequest: 'Przetwarzanie',
    goToTask: 'Czy chcesz przejść do zadania ?',
    goToDailyPlan: 'Czy chcesz przejść do planu dziennego ?',
    dateFrom: 'Data od',
    dateTo: 'Data do',
    add: 'Dodaj',
    days: 'dni',
    daysAgo: 'dni temu',
    smFrom: 'od',
    smTo: 'do',
    new: `Nowy`,
    date: `Data`,
    started: `Rozpoczęto`,
    finished: `Zakończono`,
    from: `Od`,
    to: `Do`,
    allOptions: `wszystkie opcje`,
    no: `Nie`,
    yes: `Tak`,
    today: `Dziś`,
    day: `Dzień`,
    week: `Tydzień`,
    month: `Miesiąc`,
    list: `Lista`,
    noDevice: `Brak przypisanego urządzenia`,
    appLoading: `Ładowanie aplikacji...`,
    appLoadingError: `Wystąpił błąd podczas ładowania aplikacji.`,
    appLoadingErrorText: `Spróbuj ponownie za chwile lub skontaktuj się z serwisem jeśli problem nadal występuje.`,
    movedNotStarted: `Przeniesione (nierozpoczęte)`,
    movedStarted: `Przeniesione (rozpoczęte)`,
    movedToMainStarted: `Zwrócone do puli (rozpoczęte)`,
    movedToMainNotStarted: `Zwrócone do puli (nierozpoczęte)`,
    held: `Wstrzymane`,
    all: `Wszystko`,
    chooseImage: `Wybierz grafikę`,
    chooseDocument: 'Wybierz dokument',
    case: `Zgłoszenie`,
    processing: `W toku`,
    upcoming: `Nadchodzące`,
    over: `Zakończone`,
    notStarted: `Nierozpoczęte`,
    timeUnits: {
      shortcuts: {
        minutes: `min`,
        hours: `g`,
        days: `dni`
      }
    },
    requiredLowercase: `wymagane`,
    automaticLogout: `wylogowanie`,
    timeMeasures: {
      minutes: `minuty`,
      hours: `godziny`,
      days: `dni`,
      workDays: `dni robocze`,
      workHours: `godziny robocze`
    },
    notBusy: `Wolny`,
    busy: `W trasie`,
    noDailyPlan: `Brak planu`,
    hasDailyPlan: `Przypisany plan`,
    assigned: 'Przypisane',
    notAssigned: `Nieprzypisane`,
    assignTask: `Przypisz zlecenie`,
    noAssignedTasks: `Brak powiązanych zleceń`,
    unAsignTask: `Usuń przypisanie`,
    assignAll: `Przypisz wszystkie ${lang.menu.cases.list}`,
    notSet: `Nieokreślony/a`,
    nameAndSurname: 'Imię i nazwisko',
    value: 'Wartość',
    title: 'Tytuł',
    description: 'Opis',
    idName: 'Nazwa',
    select: 'wybierz',
    street: 'Ulica',
    buyerStreetNumber: 'Numer budynku',
    buyerLocalNumber: 'Numer lokalu',
    buyerStreetNumberShort: 'Numer',
    buyerLocalNumberShort: 'Lokal',
    selectBuyerDataOr: 'Wybierz odbiorcę lub wyszukaj po NIP',
    type: 'Typ',
    noPayment: 'Nie zapłacono',
    paymentFull: 'Zapłacono w całości',
    paymentPartial: 'Wpłata częściowa',
    settleDifference: 'Rozliczenie korekty',
    attachToEmail: 'Załącz do e-maila',
    attachToEmailHoverTrue: 'Kliknij aby ten dokument był dodawany jako załącznik do notyfikacji',
    attachToEmailHoverFalse: 'Kliknij aby ten dokument nie był dodawany jako załącznik do notyfikacji',
    totalItems: 'Liczba wyników',
    itemsPerPage: 'Liczba wierszy',
    accountMassCollect: `Konto MassCollect`,
    messageType: 'Typ wiadomości',
    filtersAreSet: 'Uwaga - Filtry są ustawione',
    allPosition: `Wszystkie pozycje`,
    ksefStatus: 'Status faktury KSeF',
    sentToStatus: 'Wysłano do KSeF',
    notSentToStatus: 'Nie wysłano do KSeF',
    errorSentToStatus: 'Nie wysłano do KSeF (błąd)'
  },
  tableHeadings: {
    operationType: `Typ operacji`,
    payer: `Płatnik`,
    agreement: `Dotyczy umowy`,
    idRelatedCorrespondenceMessage: 'Dotyczy wiadomości z korespondencji',
    valueSingle: `Wartość wpłaty`,
    dateOperation: `Data operacji`,
    delayDays: `Liczba dni zadłużenia`,
    interestValue: `Kwota odsetek`,
    paymentsMadeQuantity: `Suma powiązań dla wpłaty`,
    diffPayment: `Różnica`,
    addedRefund: 'Zwrócono',
    valueLeft: 'Pozostało'
  },
  buttons: {
    clear: 'Wyczyść',
    clearAgreementData: 'Wyczyść wszystkie dane umów w systemie',
    clearContractorData: 'Wyczyść dane kontrahentów wraz z umowami w systemie',
    duplicate: 'Duplikuj',
    resetPassword: 'Resetuj hasło',
    clearFilters: 'Wyczyść filtry',
    select: 'Wybierz',
    changeStatus: 'Zmień status',
    addCustomPosition: 'Dodaj własną pozycję',
    collectionOperations: 'Operacje masowe',
    addCustomField: 'Dodaj pole własne',
    addAddressToContractor: 'Dodaj adres do kontrahenta',
    addAddressToAgreement: 'Dodaj adres do umowy',
    addNewDevice: 'Dodaj nowe urządzenie',
    acceptInvoice: 'Zaakceptuj fakturę',
    sendMessage: 'Wyślij wiadomość do użytkownika',
    approveMessage: 'Zaakceptuj wiadomość',
    approveSelectedMessages: 'Zaakceptuj zaznaczone wiadomości',
    deleteSelectedMessages: 'Usuń zaznaczone wiadomości',
    showDailyPlan: 'Pokaż plan dzienny serwisanta',
    cyclicItem: 'Usługa cykliczna',
    promotion: 'Promocja',
    addItemsToVariant: 'Dodaj zaznaczone usługi do nowego wariantu',
    addVariant: 'Dodaj nowy pusty wariant',
    goToInvoice: 'Przejdź do faktury',
    generateDocument: 'Generuj dokument do faktury',
    createNewItem: 'Dodaj nowy towar/usługę',
    goBack: 'Wróć',
    generateKey: 'Generuj klucz',
    sign: 'Podpisz',
    sendSMS: 'Zaakceptuj i wyślij kod sms',
    send: 'Wyślij',
    acceptAndSign: 'Zaakceptuj i podpisz',
    rejectOffer: 'Odrzuć propozycję umowy',
    acceptOffer: 'Zaakceptuj propozycję umowy',
    acceptWithCommentOffer: 'Zaakceptuj propozycję z uwagami',
    downloadPDF: 'Pobierz PDF',
    downloadXLS: 'Pobierz XLS',
    downloadDocument: 'Pobierz dokument',
    downloadCasePdf: 'Pobierz dokument zlecenia w PDF',
    uploadDocument: 'Prześlij dokument',
    uploadPicture: 'Prześlij zdjęcie',
    setAsMain: 'Ustaw jako domyślne',
    agreementPreview: 'Podgląd umowy',
    goToAgreementOffer: 'Przejdź do oferty z której ta umowa pochodzi',
    accept: 'Akceptuj',
    options: 'Opcje',
    acceptAllConsents: 'Akceptuj wszystkie zgody',
    clearAllConsents: 'Wyczyść status zgód',
    showMap: `Pokaż na mapie`,
    gotoTask: `Przejdź do zadania`,
    gotoDailyPlan: `Przejdź do planu dziennego`,
    goNext: `Następny`,
    goPrev: `Poprzedni`,
    addRelationNote: `Dodaj spotkanie`,
    addPhoneNote: `Dodaj telefon`,
    backToCRM: `Powrót do panelu CRM`,
    goto: `Przejdź`,
    gotoCase: `Przejdź do ${lang.menu.cases.list}`,
    changePassword: `Zmień hasło`,
    expand: `Rozwiń`,
    fold: `Zwiń`,
    backToPanel: `Wróć do panelu`,
    duplicatesSubmit: `Wyślij mimo duplikatów`,
    unArchive: `Przywróć z archiwum`,
    openAgain: `Otwórz ponownie`,
    dispatchedTask: `Zadanie przydzielone`,
    goToDailyPlan: `Przejdź do planu`,
    hold: `Wstrzymaj`,
    move: `Przenieś`,
    goToOrder: `Przejdź do zamówienia`,
    generate: `Generuj`,
    cancelOrder: `Anuluj zamówienie`,
    acceptOrder: `Akceptuj zamówienie`,
    realizeOrder: `Realizuj zamówienie`,
    finishOrder: `Zamknij zamówienie`,
    createInvoice: `Wystaw fakturę`,
    generateInvoice: `Generuj fakturę dla zaznaczonych pozycji`,
    settle: `Rozlicz`,
    goToSettle: `Przejdź do rozliczenia`,
    assignCar: `Przypisz samochód`,
    changeDate: `Zmień datę`,
    go: `Przejdź`,
    start: `Rozpocznij`,
    stop: `Zakończ`,
    stopAndAutoCreateNew: 'Zakończ i utwórz zadanie o typie',
    stopAndClose: 'Zakończ zadanie i zamknij zlecenie',
    showOrEditPlan: `Pokaż/edytuj plan`,
    showProfile: `Pokaż profil`,
    backToFirm: lang.buttons.backToFirm,
    hidePassword: `Ukryj`,
    showPassword: `Pokaż`,
    backToShow: `Powróć do podglądu`,
    createAccount: `Utwórz konto`,
    goToAccountData: `Konto systemowe osoby`,
    dispatchTask: `Przydziel zadanie`,
    addAgreementSla: `Dodaj SLA`,
    addAgreementDevice: `Dodaj urządzenie`,
    addAgreementCyclicTask: `Dodaj zadanie cykliczne`,
    addCategory: `Dodaj kategorię`,
    addTask: `Dodaj zadanie`,
    addTaskWithoutFinishCurrent: `Dodaj zadanie bez zakończenia obecnego`,
    finishTaskAndClose: `Zakończ zadanie i dodaj nowe`,
    finishTask: `Zakończ zadanie`,
    finishLastTaskAndClose: 'Zakończ ostatnie zadanie i utwórz nowe',
    create: `Dodaj`,
    addNote: `Dodaj notatkę`,
    search: `Szukaj`,
    quickSearch: `Szybkie wyszukiwanie`,
    backToList: `Powróć do listy`,
    backToTaskList: `Powróć do listy zadań`,
    backToTask: 'Powróć do zadania',
    edit: `Edytuj`,
    editTaskParams: 'Edytuj parametry zadania',
    preview: 'Podgląd',
    submit: `Zapisz`,
    submitAndCloseTask: 'Zapisz i zamknij zadanie',
    submitAndCreateNew: 'Zapisz i utwórz nowe zadanie',
    revertItem: 'Przywróć do stanu przed wprowadzeniem zmian',
    delete: `Usuń`,
    deleteEntry: 'Usuń wpis',
    firstPage: `Pierwsza strona`,
    previousPage: `Poprzednia strona`,
    nextPage: `Następna strona`,
    lastPage: `Ostatnia strona`,
    no: `Nie`,
    yes: `Tak`,
    only: 'Tylko',
    generatePdf: 'Generuj PDF',
    goToCase: `Przejdź do ${lang.menu.cases.list}`,
    closeCase: `Zamknij zgłoszenie`,
    takeTask: `Pobierz zadanie`,
    addToMyCalendar: `Dodaj do mojego planu dziennego`,
    downloadReportZip: `Pobierz raport ZIP`,
    selectAll: 'Zaznacz wszystko',
    unSelectAll: 'Odznacz wszystko',
    takeTaskAndGoTo: `Pobierz zadanie i przejdź do niego`,
    returnTask: `Przenieś do puli ogólnej`,
    transferToAnotherUserDataTask: `Przekaż zadanie`,
    transferToAnotherUserDataDailyPlanItem: `Przekaż lub zmień termin zadania`,
    redoCollapse: `Zwiń`,
    collapse: `Rozwiń`,
    show: `Pokaż`,
    close: `Zamknij`,
    add: `Dodaj`,
    cancel: `Anuluj`,
    save: `Zapisz`,
    update: `Zaktualizuj`,
    archive: `Zarchiwizuj`,
    moveFromArchive: `Przywróć z archiwum`,
    blockApplication: 'Zablokuj aplikację',
    unblockApplication: 'Odblokuj aplikację',
    moreDetails: `Więcej szczegółów`,
    logout: `Wyloguj`,
    profile: `Profil`,
    backToCase: `Powróć do ${lang.menu.cases.list}`,
    backToAgreementList: `Powróć do listy umów`,
    backToDevice: `Powróć do urządzenia`,
    backToDashboard: `Powróć do pulpitu`,
    backToNoteList: `Powróć do listy notatek`,
    backToCalendar: `Powróć do kalendarza`,
    appconfiguration: `Konfiguracja aplikacji`,
    aclconfiguration: 'Konfiguracja uprawnień',
    clienttypesconfiguration: 'Konfiguracja ról systemowych',
    notifications: 'Konfiguracja powiadomień',
    goToTask: `Przejdź do zadania`,
    taskHistory: `Historia realizacji`,
    goToDevice: 'Przejdź do urządzenia',
    anonymize: 'Anonimizuj',
    extractOrder: 'Wyodrębnij do nowego zlecenia',
    getCompanyGus: 'Pobierz dane o firmie z GUS',
    gettingCompanyGus: 'Oczekiwanie na dne z systemu GUS',
    confirmRemoveFromMailerLite: `Na pewno chcesz usunąć osobę z grupy na platformie MailerLite?`,
    autoAddToAgreement: `Powiąż po symbolu umowy`,
    autoAddToInvoice: `Powiąż po symbolu faktury`,
    removeAgreementFromPayments: `Usuń powiązanie do umowy`,
    removeInvoiceFromPayments: `Usuń powiązanie do faktury`,
    selectUserAndAgreement: `Wybierz umowę i kontrahenta do powiązania z wpłatą bankową`,
    on: 'Włączony',
    off: 'Wyłączony',
    downloadBalancePdf: 'Pobierz potwierdzenie salda w PDF za wybrany okres',
    downloadBalancePdfSelected: 'Pobierz zaznaczone potwierdzenia salda w PDF za wybrany okres',
    downloadBalanceZipSelected: 'Pobierz zaznaczone potwierdzenia sald i spakuj do ZIP za wybrany okres',
    completeOrder: 'Zrealizuj',
    priceOrder: 'Wyceń',
    sendInvoiceToKsef: `Wyślij fakturę do KSeF i na adresy odbiorców`,
    downloadUpoXml: 'Pobierz UPO w XML',
    checkAndDownloadUpoXml: 'Sprawdź dostępność UPO i pobierz jeśli jest',
    checkInvoiceStatusOnKSeF: `Odśwież aktualny status faktury na KSeF`,
    addRefund: 'Dodaj zwrot',
    addQuestion: 'Dodaj pytanie',
    addTab: 'Dodaj zakładkę'
  },
  menu: {
    fileupload: {
      index: 'Utwórz z pliku'
    },
    exaborganizationleads: {
      list: 'Leady sprzedażowe'
    },
    exsbpriceuserdata: {
      list: 'Cenniki indywidualne'
    },
    financialreport: {
      list: 'Raport finansowy'
    },
    emptypaymentsmades: {
      list: 'Wpłaty nieprzypisane'
    },
    notfullbankpayments: {
      list: 'Wpłaty rozliczone częściowo'
    },
    contactdatareport: {
      list: 'Kontakt z kontrahentami'
    },
    customfieldsreport: {
      list: 'Raport pól własnych'
    },
    invoicesbalancereport: {
      list: 'Saldo faktur kontrahentów'
    },
    excmnotificationmessage: {
      list: 'Notyfikacje'
    },
    excmrelationcategory: {
      list: 'Kategorie relacji'
    },
    exsbbank: {
      index: 'Banki'
    },
    exsbbankpackages: {
      index: 'Paczki wpłat bankowych'
    },
    exsbpaymentsmade: {
      index: 'Wpłaty'
    },
    exsbrefund: {
      index: 'Zwroty'
    },
    excmagreements: {
      index: 'Umowy SLA'
    },
    excmcalllogs: {
      list: 'Rejestr połączeń',
      statistic: 'Statystyki połączeń'
    },
    excmchatbot: {
      list: 'Korespondencja z czatbotem'
    },
    excmcorrespondence: {
      list: 'Ewidencja korespondencji'
    },
    dashboardClient: {
      index: 'Pulpit Klienta'
    },
    internalannouncements: {
      list: 'Ogłoszenia wewnętrzne'
    },
    reports: {
      index: 'Raporty',
      permissions: 'Raport uprawnień'
    },
    userdataemployee: {
      index: 'Pracownicy'
    },
    finance: {
      index: `Finanse`
    },
    service: {
      index: lang.menu.service.index
    },
    salesopportunities: {
      list: `Szanse sprzedażowe`
    },
    ticket: {
      list: `Zgłoszenia zewnętrzne`
    },
    logs: {
      list: 'Logi aplikacji'
    },
    downloaddata: {
      list: 'Pobieranie danych z systemu'
    },
    application: {
      index: `Aplikacje`,
      // list: `Lista aplikacji`,
      runSQLScript: `Wykonanie Skryptu SQL`,
      create: `Dodaj aplikację`
    },
    database: {
      index: `Bazy danych`,
      // list: `Lista baz danych`,
      create: `Dodaj baze danych`
    },
    server: {
      index: `Serwery`,
      // list: `Lista serwerów`,
      create: `Dodaj serwer`
    },
    sqlscriptexecuted: {
      list: `Skrypty SQL`
    },
    timetable: {
      dashboard: `Panel CRM`,
      show: `Terminarz`
    },
    dailyplanoverview: {
      show: `Plan miesięczny`
    },
    userdatasalesopportunities: {
      list: `Szanse sprzedażowe`
    },
    userdatastatus: {
      list: `Statusy klientów`
    },
    userdataworkplace: {
      list: `Stanowiska pracy`
    },
    relations: {
      list: `Spotkania i telefony`,
      meetings: 'Spotkania',
      phones: 'Telefony',
      calendar: `Kalendarz spotkań`
    },
    aclconfiguration: {
      show: `Konfiguracja uprawnień`
    },
    appconfiguration: {
      show: `Konfiguracja aplikacji`
    },
    dailyplan: {
      show: `Plan dzienny`
    },
    orders: {
      index: `Zamówienia`,
      list: `Lista zamówień`,
      create: `Utwórz zamówienie`,
      complete: `Zrealizuj zamówienie`,
      price: `Wyceń zamówienie`
    },
    teams: {
      list: `Zespoły`
    },
    regions: {
      list: `Regiony`
    },
    cyclictask: {
      list: `Zadania cykliczne`,
      create: `Dodaj zadanie cykliczne`
    },
    cars: {
      list: `Samochody`,
      create: `Dodaj samochód`
    },
    client: {
      index: `Klienci`
    },
    servicemen: {
      index: `${lang.menu.serviceman.index}`,
      // list: `Lista serwisantów`,
      create: `Dodaj ${lang.menu.serviceman.create}`,
      itemspicking: `Wydawanie materiału`,
      itemsreturning: `Zdawanie materiału`
    },
    agreementdevices: {
      list: `Urządzenia w firmie`
    },
    user: {
      list: `Konta`
    },
    userdatas: {
      noUserdatas: `Brak wprowadzonych osób w systemie`,
      index: `Osoby w systemie`,
      list: `Osoby`,
      create: `Dodaj osobę`
    },
    slas: {
      list: `Lista SLA`,
      create: `Dodaj SLA`
    },
    customfields: {
      list: 'Pola własne'
    },
    consents: {
      create: `Dodaj zgodę`,
      list: `Zgody`
    },
    packages: {
      list: 'Pakiety'
    },
    promotions: {
      create: `Dodaj promocję`,
      list: `Promocje`
    },
    agreementtypes: {
      list: `Typy umów`,
      create: `Utwórz typ umowy`
    },
    agreements: {
      index: `Umowy`,
      listActive: 'Aktywne',
      listAll: 'Wszystkie',
      listOffers: 'Propozycje',
      listWaiting: 'Oczekujące',
      listAccepted: 'Zaakceptowane',
      listInProgress: 'W podpisie',
      listSigned: 'Podpisane',
      listRejected: 'Odrzucone',
      list: `Umowy`,
      create: `Dodaj umowę`
    },
    agreementsoffers: {
      index: 'Oferty',
      create: 'Dodaj ofertę'
    },
    technicians: {
      index: `${lang.menu.serviceman.index}`
    },
    firm: {
      index: lang.menu.firm.index,
      // list: `Lista firm`,
      create: lang.menu.firm.create
    },
    invoices: {
      listNotAccepted: 'Faktury niezaakceptowane',
      listVindication: 'Zaległości faktur',
      list: `Faktury`
    },
    messages: {
      list: 'Wiadomości w systemie'
    },
    warehouses: {
      list: `Magazyny`
    },
    measures: {
      list: `Jednostki miary`
    },
    items: {
      list: `Towary/usługi`
    },
    itembrands: {
      list: `Producenci towarów`
    },
    itemscategories: {
      list: `Kategorie towarów/usług`
    },
    pricegroups: {
      list: `Grupy cen/towarów`
    },
    batchnumbers: {
      list: `Serie numeracji`,
      create: `Utwórz serię numeracji`
    },
    documents: {
      list: `Dokumenty magazynowe`
    },
    dashboard: {
      index: `Pulpit`
    },
    delivery: {
      list: `Sposoby dostaw`
    },
    cases: {
      index: lang.menu.cases.index,
      list: `Wszystkie ${lang.menu.cases.list}`,
      listOpen: `${lang.menu.cases.index} otwarte`,
      listClose: `${lang.menu.cases.index} zamknięte`,
      create: `Dodaj ${lang.menu.cases.create}`,
      createToMessage: `Dodaj ${lang.menu.cases.create} dotyczące tej wiadomości`
    },
    casetypes: {
      list: `Typy ${lang.menu.casetypes.list}`,
      create: `Utwórz typ ${lang.menu.casetypes.create}`
    },
    contractors: {
      index: `Kontrahenci`,
      list: `Wszyscy kontrahenci`,
      create: `Dodaj kontrahenta`
    },
    wholesalers: {
      list: 'Hurtownie'
    },
    controlling: {
      list: 'Controlling'
    },
    devices: {
      index: `Urządzenia`,
      list: `Urządzenia`,
      create: `Dodaj urządzenie`
    },
    devicebrands: {
      list: `Producenci urządzeń`,
      create: `Dodaj producenta`
    },
    devicemodels: {
      list: `Modele urządzeń`,
      create: `Dodaj model urządzenia`
    },
    deviceperipherals: {
      list: `Urządzenia peryferyjne`,
      create: `Dodaj urządzenie peryferyjne`
    },
    devicestates: {
      index: `Stany urządzeń`,
      list: `Stany urządzeń`,
      create: `Dodaj stan urządzenia`
    },
    devicetypes: {
      list: `Typy urządzeń`,
      create: `Dodaj typ urządzenia`
    },
    documenttemplate: {
      list: 'Szablony dokumentów'
    },
    externalForms: {
      list: 'Formularze zewnętrzne'
    },
    notes: {
      index: `Notatki`,
      list: `Wszystkie notatki`,
      create: `Dodaj notatkę`
    },
    tasks: {
      index: lang.menu.cases.show,
      list: `Wszystkie zadania`,
      create: `Dodaj zadanie`
    },
    tasktypes: {
      list: `Typy zadań`,
      create: `Utwórz typ zadania`
    },
    configuration: {
      index: `Konfiguracja`
    },
    warehouse: {
      index: `Magazyn`
    },
    tags: {
      list: 'Tagi'
    },
    documenttype: {
      list: 'Lista typów dokumentów'
    },
    exsbmessagesperiodic: {
      index: 'Wiadomości okresowe'
    },
    surveys: {
      list: 'Ankiety'
    },
    surveyresults: {
      list: 'Wyniki ankiet'
    }
  },
  error: {
    allFieldsNotEmpty: `Wszystkie pola nie mogą być puste`,
    valueFieldNotEmpty: `Pole wartości nie może być puste`,
    timeStartLaterThanTimeStop: `Czas rozpoczęcia nie może być późniejszy niż czas zakończenia`
  },
  notifications: {
    dataUpload: {
      clearAgreementData: 'Czy na pewno chcesz wyczyścić z systemu wszystkie dane o umowach i usługach?',
      clearContractorData: 'Czy na pewno chcesz wyczyścić z systemu wszystkie dane o umowach i kontrahentach?'
    },
    agreement: {
      confirmSigningTitle: 'Czy chcesz oznaczyć umowę jako podpisana?'
    },
    invoice: {
      acceptTitle: 'Czy na pewno chcesz zaakceptować tą fakturę?',
      acceptedTitle: 'Faktura zaakceptowana',
      generateVindicationEventsTitle: 'Czy na pewno chcesz wygenerować zdarzenia i wiadomości windykacyjne?'
    },
    message: {
      approveMessageTitle: 'Czy na pewno chcesz zaakceptować tę wiadomość?',
      approveSelectedMessagesTitle: 'Czy na pewno chcesz zaakceptować te wiadomości?',
      deleteSelectedMessagesTitle: 'Czy na pewno chcesz usunąć te wiadomości? Spowoduje to również usunięcie zdarzeń windykacyjnych'
    },
    delete: {
      errorTitle: `Wystąpił błąd w trakcie usuwania`,
      deleteTitle: `Usuwanie zakończone powodzeniem`
    },
    update: {
      errorTitle: `Wystąpił błąd w trakcie edycji`,
      updatedTitle: `Edycja zakończona powodzeniem`
    },
    store: {
      savedTitle: `Dodawanie zakończone powodzeniem`,
      errorTitle: `Wystąpił błąd w trakcie dodawania`
    },
    operationDone: `Operacja wykonana pomyślnie`,
    deleted: ` został usunięty.`, // `item` ... was deleted
    created: ` został dodany.`,
    creating: `Dodawanie`,
    updated: ` został zaktualizowany.`,
    canceled: `Anulowano`,
    deleteTitle: `Czy na pewno chcesz usunąć?`,
    unArchiveTitle: 'Czy na pewno chcesz przywrócić z archiwum?',
    archiveTitle: `Czy na pewno chcesz zarchiwizować?`,
    deleteDescription: `Nie będziesz wstanie odwrócić tej operacji!`,
    deleteApplicationDescription: 'Nie będziesz wstanie odwrócić tej operacji! Ta operacja powoduje usunięcie jedynie wpisu z bazy o aplikacji. Wszelkie dane systemowe, które dotyczą tej aplikacji trzeba będzie usunąć ręcznie.',
    archiveDescription: `Nie będziesz wstanie odwrócić tej operacji!`,
    deletedTitle: `Usunięte!`,
    deleteCancel: `Usunięcie zostało anulowane`,
    loading: `Ładowanie`,
    excmcase: {
      titleCloseCase: `Czy chcesz zamknąć to zgłoszenie?`,
      titleOpenCase: `Czy chcesz otworzyć to zgłoszenie?`,
      textCloseCase: `Wszystkie zadania zostaną zamknięte i nie będziesz miał możliwości odwrócenia tej operacji!`,
      caseClosed: `Zgłoszenie zostało zamknięte`,
      caseNotClosed: `Zgłoszenie nie zostało zamknięte`
    },
    excmtask: {
      takeTask: 'Czy na pewno chcesz pobrać to zadanie do swojej puli ?',
      takeTaskAutomatically: 'Konfiguracja aplikacji zakłada, że wejście w zadanie spowoduje jego pobranie do własnej puli. Czy chcesz od razu pobrać zadanie?',
      active: `Aktywne`,
      finished: `Zakończone`,
      titleCloseTask: `Czy chcesz zamknąć to zadanie?`,
      textCloseTask: `Nie będziesz miał możliwości odwrócenia tej operacji!`,
      taskClosed: `Zadanie zostało zakończone`,
      taskNotClosed: `Zadanie nie zostało zamknięte`,
      taskReturn: 'Czy na pewno chcesz przekazać to zadanie do puli ogólnej ?',
      noCustomFields: 'W tym zadaniu nie ma żadnych pól własnych możliwych do edycji'
    },
    noData: 'Brak wprowadzonych danych',
    iamNewCase: 'W systemie pojawiło się nowe zgłoszenie z IAM. Aby do niego przejść kliknij na odnośnik poniżej',
    replacePaymentsFound: `Znaleziono powtórzone wpłaty. Ilość powtórzonych (i nie załadowanych wpłat)`
  },
  routes: {
    // user
    ClientTypeCreate: `Dodawanie ról systemowych`,
    ClientTypeList: `Lista ról systemowych`,
    ClientTypeUpdate: `Edycja roli systemowej`,
    ClientTypeShow: `Rola systemowa`,
    AgreementFileUploadCreate: 'Załaduj umowy z pliku',
    ContractorFileUploadCreate: 'Załaduj kontrahentów z pliku',
    ContractorShow: 'Kontrahent indywidualny',
    EXSBBankPackagesList: 'Paczki wpłat bankowych',
    EXSBBankPackagesShow: 'Paczka wpłat bankowych',
    EXSBPriceGroupList: `Grupy cen towarów/usług`,
    EXSBPriceGroupCreate: `Dodawanie grupy cen towarów/usług`,
    EXSBPriceGroupUpdate: `Edycja grupy cen towarów/usług`,
    EXSBPriceGroupShow: `Grupa cen towarów/usług`,
    EXSBPriceUserDataList: 'Cenniki indywidualne',
    EXSBPriceUserDataCreate: 'Dodawanie cennika indywidualnego',
    EXSBPriceUserDataUpdate: 'Edycja cennika indywidualnego',
    FinancialReportShow: 'Raport finansowy',
    FinancialReportList: 'Raporty finansowe',
    EXCMNotificationMessageList: 'Notyfikacje',
    EXCMNotificationMessageCreate: 'Dodawanie notyfikacji',
    EXCMNotificationMessageUpdate: 'Edycja notyfikacji',
    EXCMNotificationMessageShow: 'Notyfikacja',
    EXCMRelationCategoryList: 'Kategorie relacji',
    EXCMRelationCategoryCreate: 'Dodawanie kategorii relacji',
    EXCMRelationCategoryUpdate: 'Edycja kategorii relacji',
    EXCMRelationCategoryShow: 'Kategoria relacji',
    EXCMCallLogList: 'Rejestr połączeń',
    EXCMChatbotThreadsList: 'Korespondencja z czatbotem',
    EXCMChatbotThreadShow: 'Wiadomość z czatbota',
    EXCMCorrespondenceThreadsList: 'Ewidencja korespondencji',
    EXCMCorrespondenceThreadShow: 'Wiadomość korespondencyjna',
    EXSBBankUpdate: 'Edycja banku',
    EXSBBankCreate: 'Dodawanie banku',
    EXSBBankList: 'Banki',
    EXSBPaymentsMadeShow: 'Wpłata',
    EXSBPaymentsMadeUpdate: 'Edytowanie wpłaty',
    EXSBPaymentsMadeCreate: 'Dodawanie wpłaty',
    EXSBPaymentsMadeList: 'Wpłaty',
    EXSBRefundShow: 'Zwrot',
    EXSBRefundUpdate: 'Edycja zwrotu',
    EXSBRefundCreate: 'Dodawanie zwrotu',
    EXSBRefundList: 'Zwroty',
    // EXSBMessagesPeriodic
    EXSBMessagesPeriodicList: 'Wiadomości okresowe',
    EXSBMessagesPeriodicCreate: 'Dodawanie wiadomości okresowej',
    EXSBMessagesPeriodicUpdate: 'Edycja wiadomości okresowej',
    EXSBMessagesPeriodicShow: 'Wiadomość okresowa',
    // EXABConsents
    EXABConsentsList: 'Zgody',
    // EXABPromotions
    EXABPromotionsList: 'Promocje',
    // DashboardClient
    DashboardClient: lang.routes.DashboardClient,
    // Agreements
    EXABAgreementsUpdate: 'Edycja umowy',
    EXABAgreementsCreate: 'Dodawanie umowy',
    EXABAgreementsList: 'Umowy',
    EXABAgreementsMassEdit: 'Masowa edycja umów',
    EXABAgreementShow: 'Umowa',
    EXABAgreementsCreateOffers: 'Dodawanie oferty umowy',
    EXABAgreementsListSigned: 'Podpisane umowy',
    EXABAgreementsListOffers: 'Propozycje umów',
    EXABAgreementsListWaiting: 'Umowy oczekujące',
    EXABAgreementsListAccepted: 'Umowy zaakceptowane',
    EXABAgreementsListSignaturePending: 'Umowy w podpisie',
    EXABAgreementsListRejected: 'Umowy odrzucone',
    EXABExternalFormsList: 'Formularze zewnętrzne',
    EXABExternalFormsCreate: 'Tworzenie formularza zewnętrznego',
    EXABExternalFormsUpdate: 'Edycja formularza zewnętrznego',
    EXABPackagesShow: 'Pakiet',
    EXABPackagesList: 'Lista pakietów',
    EXABPackagesCreate: 'Tworzenie pakietu',
    EXABSurveysList: 'Ankiety',
    EXABSurveysCreate: 'Tworzenie ankiety',
    EXABSurveysUpdate: 'Edycja ankiety',
    EXABSurveyShow: 'Ankieta',
    EXABSurveyResultsList: 'Wyniki ankiet',
    EXABSurveyResultsShow: 'Wynik ankiety',
    EXABCustomFieldsList: 'Lista pól własnych',
    EXABCustomFieldsCreate: 'Tworzenie pola własnego',
    EXABCustomFieldsUpdate: 'Edycja pola własnego',
    EXABPackagesUpdate: 'Edycja pakietu',
    PermissionsReport: 'Raport Uprawnień',
    // Log
    LogList: `Logi aplikacji`,
    // Ticket
    TicketList: `Zgłoszenia zewnętrzne`,
    TicketShow: `Zgłoszenia z zewnętrznych aplikacji`,
    // Application
    ApplicationList: `Aplikacje`,
    ApplicationCreate: `Dodawanie aplikacji`,
    ApplicationUpdate: `Edycja aplikacji`,
    ApplicationSqlScriptRun: `Wykonanie skryptu SQL na wszystkich instancjach aplikacji`,
    ApplicationShow: `Aplikacja`,
    // Database
    DatabaseConnectionList: `Bazy danych`,
    DatabaseConnectionCreate: `Dodawanie bazy danych`,
    DatabaseConnectionUpdate: `Edycja danych bazy danych`,
    DatabaseConnectionShow: `Baza danych`,
    // InternalAnnouncement
    InternalAnnouncementList: `Ogłoszenia wewnętrzne`,
    InternalAnnouncementCreate: `Dodawanie ogłoszenia wewnętrznego`,
    InternalAnnouncementUpdate: `Edycja ogłoszenia wewnętrznego`,
    InternalAnnouncementShow: `Ogłoszenie wewnętrzne`,
    // Server
    ServerList: `Serwery`,
    ServerCreate: `Dodawanie serwera`,
    ServerUpdate: `Edycja danych serwera`,
    ServerShow: `Serwer`,
    // SqlScriptExecuted
    SqlScriptExecutedList: `Wykonane skrypty SQL`,
    SqlScriptExecutedShow: `Wykonany skrypt SQL`,
    // Dashboard
    404: `Nie znaleziono`,
    TimetableDashboard: `Panel CRM`,
    TimetableShow: `Terminarz`,
    ServicemanItemsReturning: `Zdawanie materiału`,
    ServicemanItemsPicking: `Wydawanie materiału`,
    Login: `Logowanie`,
    Overview: `Pulpit`,
    Technicians: `${lang.menu.serviceman.index}`,
    UserProfile: `Profil użytkownika`,
    AppConfiguration: `Konfiguracja aplikacji`,
    AclConfiguration: `Konfiguracja uprawnień`,
    // EXABOrganizationLead
    EXABOrganizationLeadList: `Lista leadów sprzedażowych`,
    EXABOrganizationLeadKanbanBoard: `Tablica leadów sprzedażowych`,
    EXABOrganizationLeadCreate: `Dodawanie leadu sprzedażowego`,
    EXABOrganizationLeadUpdate: `Edycja leadu sprzedażowego`,
    EXABOrganizationLeadShow: `Lead sprzedażowy`,
    // EXCMUserDataSalesOpportunity
    EXCMUserDataSalesOpportunityList: `Lista szans sprzedażowych`,
    EXCMUserDataSalesOpportunityCreate: `Dodawanie szansy sprzedażowej`,
    EXCMUserDataSalesOpportunityUpdate: `Edycja szansy sprzedażowej`,
    EXCMUserDataSalesOpportunityShow: `Szansa sprzedażowa`,
    // EXCMUserDataStatus
    EXCMUserDataStatusList: `Lista statusów klientów`,
    EXCMUserDataStatusCreate: `Dodawanie statusu klientów`,
    EXCMUserDataStatusUpdate: `Edycja statusu klientów`,
    EXCMUserDataStatusShow: `Status klientów`,
    // EXCMUserDataWorkplace
    EXCMUserDataWorkplaceList: `Lista stanowisk pracy`,
    EXCMUserDataWorkplaceCreate: `Dodawanie stanowiska pracy`,
    EXCMUserDataWorkplaceUpdate: `Edycja stanowiska pracy`,
    EXCMUserDataWorkplaceShow: `Stanowisko pracy`,
    // EXCMRelation
    EXCMRelationList: `Lista spotkań i telefonów`,
    EXCMRelationCreate: `Dodawanie spotkania`,
    EXCMRelationUpdate: `Edycja spotkania/telefonu`,
    EXCMRelationShow: `Spotkanie/telefon`,
    // EXCMMessage
    EXCMMessageList: 'Lista wiadomości w systemie',
    // EXCMOrder
    EXSBOrderList: `Zamówienia`,
    EXSBOrderCreate: `Dodawanie zamówienia`,
    EXSBOrderUpdate: `Edycja zamówienia`,
    EXSBOrderShow: `Zamówienie`,
    // EXCMSettlement
    EXCMSettlementList: `Lista rozliczeń`,
    EXCMSettlementCreate: `Dodawanie rozliczenia`,
    EXCMSettlementUpdate: `Edycja rozliczenia`,
    EXSBSettlementShow: `Rozliczenie`,
    // EXCMTeam
    EXCMTeamList: `Lista zespołów`,
    EXCMTeamCreate: `Dodawanie zespołu`,
    EXCMTeamUpdate: `Edycja zespołu`,
    EXCMTeamShow: `Zespół`,
    // EXCMRegion
    EXCMRegionList: `Lista regionów`,
    EXCMRegionCreate: `Dodawanie regionu`,
    EXCMRegionUpdate: `Edycja regionu`,
    EXCMRegionShow: `Region`,
    EXCMCustomFieldsReportList: `Raport pól własnych`,
    // EXCMCyclicTask
    EXCMCyclicTaskList: `Lista zadań cyklicznych`,
    EXCMCyclicTaskCreate: `Dodawanie zadania cyklicznego`,
    EXCMCyclicTaskUpdate: `Edycja zadania cyklicznego`,
    EXCMCyclicTaskShow: `Zadanie cykliczne`,
    // EXCMCar
    EXCMCarList: `Lista samochodów`,
    EXCMCarCreate: `Dodawanie samochodu`,
    EXCMCarUpdate: `Edycja samochodu`,
    EXCMCarShow: `Samochód`,
    // agreement
    EXCMAgreementDeviceList: `Urządzenie w umowie`,
    EXCMAgreementDeviceCreate: `Dodawanie urządzenia do umowy`,
    EXCMAgreementDeviceUpdate: `Edycja urządzenia w umowie`,
    EXCMAgreementDeviceShow: `Urządzenie w umowie`,
    // agreement
    EXCMAgreementList: `Umowy`,
    EXCMAgreementCreate: `Dodawanie umowy`,
    EXCMAgreementUpdate: `Edycja umowy`,
    EXCMAgreementShow: `Umowa`,
    // sla
    EXCMSlaList: `SLA`,
    EXCMSlaCreate: `Dodawanie SLA`,
    EXCMSlaUpdate: `Edycja SLA`,
    EXCMSlaShow: `SLA`,
    // agreement type
    EXCMAgreementTypeList: `Typ umowy`,
    EXCMAgreementTypeCreate: `Dodawanie typu umowy`,
    EXCMAgreementTypeUpdate: `Edycja typu umowy`,
    EXCMAgreementTypeShow: `Typ umowy`,
    // case
    EXCMCaseList: lang.menu.cases.list,
    EXCMCaseCreate: `Dodawanie ${lang.menu.cases.list}`,
    EXCMCaseUpdate: `Edycja ${lang.menu.cases.list}`,
    EXCMCaseShow: lang.menu.cases.show,
    // case type
    EXCMCaseTypeList: `Typy ${lang.menu.casetypes.list}`,
    EXCMCaseTypeCreate: `Dodawanie typu ${lang.menu.cases.index}`,
    EXCMCaseTypeUpdate: `Edycja typu ${lang.menu.cases.index}`,
    EXCMCaseTypeShow: `Typ ${lang.menu.cases.list}`,
    // contractor
    EXCMContractorList: `Kontrahenci`,
    EXCMContractorCreate: `Dodawanie kontrahenta`,
    EXCMContractorUpdate: `Edycja kontrahenta`,
    EXCMContractorShow: `Kontrahent`,
    // device
    EXCMDeviceList: `Urządzenia`,
    EXCMDeviceCreate: `Dodawanie urządzenia`,
    EXCMDeviceUpdate: `Edycja urządzenia`,
    EXCMDeviceShow: `Urządzenie`,
    // device brand
    EXCMDeviceBrandList: `Producenci urządzeń`,
    EXCMDeviceBrandCreate: `Dodawanie producenta urządzeń`,
    EXCMDeviceBrandUpdate: `Edycja producenta urządzeń`,
    EXCMDeviceBrandShow: `Producent urządzeń`,
    // device model
    EXCMDeviceModelList: `Modele urządzeń`,
    EXCMDeviceModelCreate: `Dodawanie modelu urządzeń`,
    EXCMDeviceModelUpdate: `Edycja modelu urządzeń`,
    EXCMDeviceModelShow: `Model urządzeń`,
    // device peripheral
    EXCMDevicePeripheralList: `Typy urządzenia`,
    EXCMDevicePeripheralCreate: `Dodawanie typu urządzenia`,
    EXCMDevicePeripheralUpdate: `Edycja typu urządzenia`,
    EXCMDevicePeripheralShow: `Typ urządzenia`,
    // device states
    EXCMDeviceStateList: `Stany urządzenia`,
    EXCMDeviceStateCreate: `Dodawanie stanu urządzenia`,
    EXCMDeviceStateUpdate: `Edycja stanu urządzenia`,
    EXCMDeviceStateShow: `Stan urządzenia`,
    // device type
    EXCMDeviceTypeList: `Typy urządzenia`,
    EXCMDeviceTypeCreate: `Dodawanie typu urządzenia`,
    EXCMDeviceTypeUpdate: `Edycja typu urządzenia`,
    EXCMDeviceTypeShow: `Typ urządzenia`,
    // note
    EXCMNoteList: `Notatki`,
    EXCMNoteCreate: `Dodawanie notatki`,
    EXCMNoteUpdate: `Edycja notatki`,
    EXCMNoteShow: `Notatka`,
    // task
    EXCMTaskList: `Zadania`,
    EXCMTaskCreate: `Dodawanie zadania`,
    EXCMTaskUpdate: `Edycja zadania`,
    EXCMTaskParamsUpdate: `Edycja parametrów zadania`,
    EXCMTaskShow: `Zadanie`,
    // task type
    EXCMTaskTypeList: `Typy zadań`,
    EXCMTaskTypeCreate: `Dodawanie typu zadania`,
    EXCMTaskTypeUpdate: `Edycja typu zadania`,
    EXCMTaskTypeShow: `Typ zadania`,
    // tags
    EXCMTagList: 'Tagi',
    EXCMTagCreate: 'Tworzenie tagów',
    EXCMTagUpdate: 'Edycja tagów',
    // batch number
    EXSBBatchNumberList: `Serie numeracji`,
    EXSBBatchNumberCreate: `Dodawanie serii numeracji`,
    EXSBBatchNumberUpdate: `Edycja serii numeracji`,
    EXSBBatchNumberShow: `Seria numeracji`,
    // delivery
    EXSBDeliveryList: `Sposoby dostaw`,
    EXSBDeliveryCreate: `Dodawanie sposobu dostawy`,
    EXSBDeliveryUpdate: `Edycja sposobu dostawy`,
    EXSBDeliveryShow: `Sposób dostawy`,
    // documents
    EXSBDocumentList: `Dokumenty magazynowe`,
    EXSBDocumentCreate: `Dodawanie dokumentu magazynowego`,
    EXSBDocumentUpdate: `Edycja dokumentu magazynowego`,
    EXSBDocumentShow: `Dokument magazynowy`,
    // items brand
    EXSBItemBrandList: `Producenci towarów`,
    EXSBItemBrandUpdate: `Edycja producenta towarów`,
    EXSBItemBrandCreate: `Dodawanie producenta towarów`,
    EXSBItemBrandShow: `Producent towarów`,
    // items category
    EXSBItemsCategoryList: `Kategorie towarów/usług`,
    EXSBItemsCategoryCreate: `Dodawanie kategorii towarów/usług`,
    EXSBItemsCategoryUpdate: `Edycja kategorii towarów/usług`,
    EXSBItemsCategoryShow: `Kategoria towarów/usług`,
    // items
    EXSBItemList: `Towary/usługi`,
    EXSBItemCreate: `Dodawanie towarów/usług`,
    EXSBItemUpdate: `Edycja towarów/usług`,
    EXSBItemShow: `Towar/usługa`,
    // measures
    EXSBMeasureList: `Jednostki`,
    EXSBMeasureCreate: `Dodawanie jednostek`,
    EXSBMeasureUpdate: `Edycja jednostek`,
    EXSBMeasureShow: `Jednostka`,
    // warehouses
    EXSBWarehouseList: `Magazyny`,
    EXSBWarehouseCreate: `Dodawanie magazynów`,
    EXSBWarehouseUpdate: `Edycja magazynów`,
    EXSBWarehouseShow: `Magazyn`,
    // invoices
    EXSBInvoiceList: `Faktury`,
    EXSBInvoiceCreate: `Dodawanie faktur`,
    EXSBInvoiceUpdate: `Edycja faktur`,
    EXSBInvoiceShow: `Faktura`,
    // not accepted invoices
    EXSBNotAcceptedInvoiceList: 'Faktury Niezaakceptowane',
    EXSBVindicationInvoiceList: 'Zaległości faktur',
    // firm
    FirmList: lang.routes.FirmList,
    FirmCreate: lang.routes.FirmCreate,
    FirmUpdate: lang.routes.FirmUpdate,
    FirmShow: lang.routes.FirmShow,
    // agreements consents
    EXCMConsentList: `Zgody do umów`,
    EXCMConsentCreate: `Dodawanie zgody`,
    EXCMConsentUpdate: `Edycja zgody`,
    EXCMConsentShow: `Zgoda do umów`,
    // userdata
    UserDataCreate: `Dodawanie osoby do systemu`,
    UserDataList: `Lista osób w systemie`,
    UserDataUpdate: `Edycja osoby w systemie`,
    UserDataShow: `Osoba w systemie`,
    // user
    UserCreate: `Dodawanie konta do systemu`,
    UserList: `Lista kont w systemie`,
    UserUpdate: `Edycja konta w systemie`,
    UserShow: `Konto w systemie`,
    // wholesalers
    WholesalerList: 'Lista hurtowni',
    WholesalerCreate: 'Dodawanie hurtowni',
    WholesalerUpdate: 'Edycja hurtowni',
    WholesalerShow: 'Hurtownia',
    // controlling
    ControllingList: 'Lista controllingu',
    ControllingCreate: 'Dodawanie controllingu',
    ControllingUpdate: 'Edycja controllingu',
    ControllingShow: 'Controlling',
    // servicemen
    ServicemenList: `Lista ${lang.routes.ServicemanList}`,
    ServicemenShow: `${lang.roles.roleServiceman}`,
    ServicemenCreate: `Dodawanie ${lang.routes.ServicemanShow}`,
    ServicemenUpdate: `Edycja ${lang.routes.ServicemanShow}`,
    // clients
    ClientList: `Lista klientów`,
    ClientShow: `Klient`,
    ClientCreate: `Dodawanie klienta`,
    ClientUpdate: `Edycja klienta`,
    ConfAclUpdate: `Zmiana poziomów dostępu`,
    ConfTypeShow: `Poziomy dostępu`,
    DocumentTemplateList: 'Szablony dokumentów',
    DocumentTemplateCreate: 'Tworzenie szablonu dokumentu',
    DocumentTemplateUpdate: 'Edycja szablonu dokumentu',
    DailyPlanShow: `Plan dzienny`,
    DailyPlanOverview: `Plan miesięczny`,
    // UserDataEmployee
    UserDataEmployeeList: 'Pracownicy',
    // DocumentType
    DocumentTypeList: 'Lista typów dokumentów',
    DocumentTypeShow: 'Podgląd',
    DocumentTypeCreate: 'Dodawanie typu dokumentu',
    DocumentTypeUpdate: 'Edycja typu dokumentu',
    ContactDataReportList: 'Raport kontaktu z kontrahentami',
    InvoiceBalanceReportList: 'Raport salda kontrahentów'
  },
  modals: {
    excmrelationuserdata: {
      createRelationUserDataHeader: `Dodawanie uczestnika spotkania`
    },
    exsborder: {
      generateDocumentForOrderModalHeader: `Tworzenie dokumentu na podstawie zamówienia`
    },
    finishedTaskDocument: {
      idDoneByUserData: `Przypisany wykonawca`,
      finishedTaskDocumentHeader: `Tworzenie dokumentu Wydania Zewnętrznego do zadania`,
      idCaseName: `Zgłoszenie`,
      idTaskType: `Zadanie`,
      idFinishByUserData: `Zakończone przez`,
      finishDate: `Data i czas zakończenia`,
      addNewPosition: `Dodaj towar`
    },
    excmteamuserdata: {
      createTeamUserDataModalHeader: `Dodawanie osoby do zespołu`,
      updateTeamUserDataModalHeader: `Edycja osoby w zespole`
    },
    excmregionuserdata: {
      createRegionUserDataModalHeader: `Dodawanie osoby do regionu`,
      updateRegionUserDataModalHeader: `Edycja osoby w regionie`
    },
    excmcyclictask: {
      createCyclicTaskModalHeader: `Dodaj zadanie cykliczne`,
      updateCyclicTaskModalHeader: `Edycja zadania cyklicznego`
    },
    excmcaruserdata: {
      createCarUserDataModalHeader: `Przypisywanie samochodu do serwisanta`,
      updateCarUserDataModalHeader: `Edycja przypisania samochodu do serwisanta`
    },
    dailyplan: {
      finishDate: `Data i czas zakończenia próby wykonania zadania`,
      holdHeader: `Wstrzymanie zadania`,
      redirectionHeader: `Zmień dzień planu pracy dla ${lang.routes.ServicemanShow}`,
      moveHeader: `Przeniesienie wykonania zadania`,
      date: `Data`,
      idUserData: `${lang.roles.roleServiceman}`,
      moveReason: `Powód przeniesienia`,
      task: {
        startDate: `Data i czas rozpoczęcia próby wykonania zadania`
      }
    },
    userdatafirm: {
      createUserDataFirmHeader: `Dodawanie nowej firmy do pracownika`,
      updateUserDataFirmHeader: `Edycja firmy pracownika`
    },
    userdataemployee: {
      createUserDataEmployeeHeader: `Dodawanie nowego pracownika do firmy`,
      updateUserDataEmployeeHeader: `Edycja pracownika firmy`
    },
    userdataaddress: {
      createUserDataAddressHeader: `Dodawanie nowego adresu`,
      updateUserDataAddressHeader: `Edycja adresu`
    },
    userdata: {
      changeUserDataAvatarHeader: `Zmień avatar użytkownika`,
      createUserDataHeader: `Utwórz nową osobę w systemie`
    },
    excmtask: {
      hourFrom: `Rozpoczęto o`,
      hourTo: `Zakończono o`,
      dispatchTaskModalHeader: `Przekaż zadanie do wykonania`,
      dispatchUserData: `Wybierz ${lang.menu.serviceman.create} któremu chcesz przydzielić zadanie`,
      date: `Dzień wykonania zadania`,
      timeStartOnCalendar: `Godzina wykonania zadania na kalendarzu (opcjonalnie)`,
      createTaskHeader: `Utwórz nowe zadanie`,
      taskCloseManuallyModalHeader: `Zamykanie zadania`,
      orderDate: 'Data zlecenia',
      startDate: `Data rozpoczęcia`,
      finishDate: `Data zakończenia`,
      minutes: `Czas trwania (w min.)`,
      timeOrDate: `Zakończenie na podstawie`,
      timeOrDateOptions: {
        time: `czas trwania`,
        date: `godzina zakończenia`
      }
    },
    excmagreementsla: {
      createAgreementSlaHeader: `Dodaj SLA do umowy`,
      updateAgreementSlaHeader: `Edycja SLA umowy`
    },
    excmagreementconsent: {
      updateAgreementConsentHeader: `Edycja zgody umowy`
    },
    excmagreementdevice: {
      createAgreementDeviceHeader: `Dodaj urządzenie do umowy`,
      updateAgreementDeviceHeader: `Edycja urządzenia w umowie`
    },
    excmagreement: {
      createAgreementHeader: `Dodawanie umowy`,
      updateAgreementHeader: `Edycja umowy`
    },
    excmdeviceperipheraldevice: {
      createDevicePeripheralDeviceHeader: `Dodawanie urządzenia peryferyjnego`,
      updateDevicePeripheralDeviceHeader: `Edycja urządzenia peryferyjnego`
    },
    profile: {
      editProfileHeader: `Edycja profilu`
    },
    customField: {
      create: {
        header: `Dodaj nowe pole własne`
      },
      update: {
        header: `Edytuj pole własne`
      }
    },
    employee: {
      updateEmployeeHeader: `Edycja pracownika`,
      createEmployeeHeader: `Dodawanie pracownika dla`
    },
    department: {
      createDepartmentHeader: `Dodawanie oddziału dla`,
      updateDepartmentHeader: `Edycja oddziału`
    },
    firm: {
      updateFirmHeader: lang.routes.FirmUpdate,
      createFirmHeader: lang.modals.firm.createFirmHeader
    },
    caseType: {
      edit: {
        header: `Edycja typu ${lang.menu.cases.index}`
      }
    }
  },
  views: {
    quill: {
      addImageFromComputer: 'Dodaj obraz z komputera',
      addImageFromURL: 'Dodaj obraz z adresu URL',
      imageURL: `Link do obrazu`,
      image: `Obraz`,
      addPhotoURL: `Dodanie obrazu`
    },
    clienttype: {
      form: {
        defaultRoute: 'Domyślny widok po zalogowaniu',
        defaultRouteDashboard: 'Pulpit pełny',
        defaultRouteClient: 'Pulpit uproszczony'
      }
    },
    owner: {
      ownerName: 'Nazwa właściciela',
      requireDailyPlanItem: 'Wymagaj planu dziennego',
      tasksAccessBasedOnRole: 'Dostęp do zadań na podstawie roli',
      allowSigningAgreementOffers: 'Podpisywanie umów',
      clearAgreementConsents: 'Czyść zgody umów'
    },
    customfields: {
      list: {
        noCustomFields: 'Brak pól własnych w systemie'
      }
    },
    exaborganizationlead: {
      list: {
        salesFunnel: 'Sprzedaż',
        leadCounterStatus: 'Liczba leadów w statusie',
        status: 'Stan leadu',
        statusActive: `Aktywny`,
        statusInactive: `Nieaktywny`,
        closeSuccessTooltip: `Zakończone z sukcesem`,
        closeFailedTooltip: `Zakończone z porażką`,
        orientation: 'Orientacja',
        horizontal: 'Poziomo',
        vertical: 'Pionowo',
        backgroundColorFunnel: 'Kolor tła'
      },
      form: {
        addNewLead: 'Dodaj nowy lead sprzedażowy',
        title: `Tytuł`,
        description: `Opis`,
        monthlyCost: `Prognozowany przychód miesięczny`,
        yearlyCost: `Prognozowany przychód roczny`,
        idSalesRepresentative: `Właściciel leadu`,
        idStatus: `Status leadu`,
        idSalesOpportunity: `Szanse sprzedażowe leadu`,
        idUserData: 'Dotyczy osoby/organizacji'
      },
      timeline: {
        newStatus: 'Zmiana statusu',
        newSalesOpportunity: 'Zmiana szansy sprzedażowej',
        newNote: 'Dodanie notatki',
        newMeeting: 'Dodanie spotkania',
        newPhone: 'Dodanie telefonu'
      }
    },
    exsbpriceuserdata: {
      form: {
        addPriceUserData: 'Dodaj cenę indywidualną'
      },
      list: {
        basePriceBrutto: 'Cena bazowa brutto',
        customPrice: 'Cena indywidualna',
        basePrice: 'Cena bazowa',
        noPrices: 'Brak wprowadzonych cenników'
      }
    },
    permissionsreport: {
      user: 'Użytkownik',
      accessToViews: 'Dostęp do widoków',
      permissionType: 'Typ uprawnień',
      searchPermissions: 'Wyszukaj uprawnienia',
      noPermissions: 'Brak uprawnień',
      types: {
        acl: 'Uprawnienia ACL',
        task: 'Uprawnienia dostępu do zadań',
        case: 'Uprawnienia dostępu do zgłoszeń'
      }
    },
    financialreport: {
      show: {
        sum: 'Suma',
        balance: 'Bilans',
        other: 'Inne'
      },
      list: {
        balanceBrutto: 'Bilans brutto',
        balanceNetto: 'Bilans netto',
        contractor: 'Kontrahent',
        agreements: 'Umowy',
        lastMonthPayments: 'Wpłaty za ostatni miesiąc'
      }
    },
    reports: {
      index: {
        diffPaymentInfo: `Uwaga. Jeśli wartość w kolumnie Różnica jest ujemna, nastąpiło przekroczenie ilości dowiązanych rozksięgowań wpłaty do jednej paczki bankowej. Aby poprawić dowiązania. należy usunąć taka dodatkową wpłatę.`,
        noRefundsAdded: 'Brak zwrotu'
      },
      notfullbankpayments: {
        showall: `Wpłaty bankowe rozliczone częściowo`
      },
      emptyPaymentsMades: {
        showall: `Wszystkie wpłaty nie przypisane do umów`
      },
      contactData: {
        showAll: 'Raport kontaktu z kontrahentami',
        list: {
          applicationData: 'Aplikacje',
          lastCorrespondenceMessage: 'Ostatnia wiadomość',
          lastCallLog: 'Najnowsze połączenie',
          lastNote: 'Najnowsza notatka',
          lastRelation: 'Najnowsze spotkanie',
          lastRelationPhone: 'Najnowszy telefon',
          applications: 'Aplikacje',
          activeAgreements: 'Liczba umów',
          activeGroupUserdata: 'Liczba uczniów',
          lastInvoices: 'Ostatnie faktury',
          sumToPay: 'Suma do zapłaty',
          sumPaid: 'Suma zapłacono',
          sumTotalValueBrutto: 'Suma'
        }
      },
      invoicesBalance: {
        showAll: 'Raport salda kontrahentów wg faktur',
        list: {
          applicationData: 'Aplikacje',
          sumToPay: 'Winien (do zapłaty)',
          sumPaid: 'Ma (zapłacono)',
          sumTotalValueBrutto: 'Suma wartości dokumentów',
          invoiceData: 'Faktury',
          invoicesCount: 'Liczba faktur'
        }
      }
    },
    excmnotificationmessage: {
      list: {
        noNotifications: 'Brak notyfikacji'
      },
      form: {
        recipientType: 'Grupa odbiorców DO',
        recipientTypeCc: 'Grupa odbiorców DW',
        customToUsers: 'Dodatkowe adresy e-mail DO (po przecinku)',
        customCcUsers: 'Dodatkowe adresy e-mail DW (po przecinku)',
        customToUsersFromCustomFields: `Dodatkowi odbiorcy z pól własnych (wprowadź nazwy pól po przecinku)`,
        customCcUsersFromCustomFields: `Dodatkowi odbiorcy DW z pól własnych (wprowadź nazwy pól po przecinku)`,
        servicemanInTeam: `${lang.roles.roleServiceman} w zespole`,
        ownerUserData: 'Właściciel zlecenia',
        userDataRegion: `Członek regionu`,
        userDataSalesRegion: `Handlowiec w regionie`,
        wholesalerEmployee: `Pracownik hurtowni`,
        firingThrough: {
          label: 'Wywoływany typ zdarzenia',
          createCase: `Utworzenie ${lang.menu.casetypes.create}`,
          closeCase: `Zamknięcie ${lang.menu.casetypes.create}`,
          createTask: 'Utworzenie zadania',
          returnTask: 'Zwrócenie zadania',
          startTask: 'Rozpoczęcie zadania',
          finishTask: 'Zakończenie zadania',
          assignTask: `Przypisanie ${lang.menu.casetypes.create}`,
          uploadDocumentCase: `Dodanie dokumentu do ${lang.menu.casetypes.create}`,
          uploadDocumentTask: `Dodanie dokumentu do zadania`,
          addAdditionalInfoInTask: `Wypełnienie szczegółów w zadaniu zlecenia zewnętrznego`,
          deadlineDateExceeded: `Przekroczenie terminu realizacji`
        },
        allowedDocumentTypes: `Wysyłaj tylko wtedy gdy dodano dokumenty niniejszego typu (pozostaw puste aby wysyłać zawsze)`,
        dayAfterStart: 'Wysyłaj dopiero gdy zadanie nie zostanie zamknięte przez X dni od rozpoczęcia zadania (0 spowoduje wysyłkę powiadomienia od razu)',
        repeatAgainCount: 'Liczba powtórnych powiadomień jeżeli zadanie nadal nie zostanie zamknięte',
        repeatAgainInterval: 'Czas pomiędzy powtórnymi powiadomieniami (w dniach)',
        title: 'Nazwa notyfikacji',
        description: 'Opis',
        mailTitle: 'Tytuł maila',
        mailBody: 'Treść maila',
        sendAttachmentsFromCase: 'Dołącz załączniki dodane do zlecenia, którego dotyczy zdarzenie (tylko wtedy gdy wyrażono na to zgodę w konkretnym załączniku)',
        sendAttachmentsFromTask: 'Dołącz załączniki dodane do zadania, którego dotyczy zdarzenie (tylko wtedy gdy wyrażono na to zgodę w konkretnym załączniku)',
        sendAttachmentsFromCaseInTask: 'Dołącz załączniki dodane do zlecenia, którego dotyczy zdarzenie dla zadania (tylko wtedy gdy wyrażono na to zgodę w konkretnym załączniku)',
        senderType: 'Domyślny nadawca wiadomości',
        customRole: `Rola własna`,
        documentTemplate: 'Użyj własnego szablonu wiadomości',
        emergencyEmail: 'Odbiorca e-mail dla alarmowej wiadomości o pustej liście materiałowej (jeżeli jest użyta). Pozostaw puste, aby nie generować alarmu',
        emergencyText: 'Treść alarmowej wiadomości o pustej liście materiałowej (jeżeli jest użyta)'
      },
      legend: {
        legend: 'Legenda dla tytułu i zawartości',
        customFieldLegend: `Pola własne`,
        forCase: `w zleceniu`,
        forTask: `w zadaniu`,
        id_case: 'Wpisz %id_case% , aby wstawić w to miejsce numer zlecenia',
        id_task: 'Wpisz %id_task% , aby wstawić w to miejsce numer zadania',
        project_date: 'Wpisz %project_date% , aby wstawić w to miejsce termin realizacji inwestycji podany w zleceniu projektowym',
        order_list: 'Wpisz %order_list% , aby wstawić w to miejsce ostatnią listę materiałową w zleceniu',
        warehouse: 'Wpisz %warehouse% , aby wstawić w to miejsce hurtownię przypisaną do zlecenia',
        case_type: 'Wpisz %case_type% , aby wstawić w to miejsce typ zlecenia',
        client_name: 'Wpisz %client_name% , aby wstawić w to miejsce nazwę klienta',
        client_address: 'Wpisz %client_address% , aby wstawić w to miejsce adres klienta',
        client_email: 'Wpisz %client_email% , aby wstawić w to miejsce adres e-mail klienta',
        client_phone: 'Wpisz %client_phone% , aby wstawić w to miejsce telefon klienta',
        singleCustomField: `Wpisz {fieldName}, aby wstawić w to miejsce wartość pola własnego "{fieldLabel}"`
      }
    },
    exsbmessagesperiodic: {
      list: {
        noMessages: 'Brak wprowadzonych wiadomości okresowych',
        state: {
          off: `Wyłączone`,
          on: `Włączone`
        }
      },
      form: {
        state: `Status:`,
        title: `Tytuł wiadomości`,
        subject: `Temat`,
        idSenderTypeMail: `Nadawca wiadomości E-mail`,
        idSenderTypeSms: `Nadawca wiadomości SMS`,
        messageType: `Typ`,
        shiftDateFromNow: `Przesuń datę wysyłki o liczbę dni`,
        agreementArrearsDays: `Ilości dni zaległości umowy`,
        messageTypes: {
          mail: `E-mail`,
          sms: `SMS`
        },
        sendByDateType: `Wyślij wg daty`,
        sendByDateTypes: {
          birthdays: `Data urodzin`,
          documentPaymentDate: `Data płatności dokumentu`,
          agreementArrearsDays: `Ilości dni zaległości umowy`
        },
        fromValue: `Minimalna wartość zaległości`,
        toValue: `Maksymalna wartość zaległości`,
        vindication: `Windykacja`,
        autoAccept: `Autoakceptacja`,
        sendingDays: `Wprowadź czas wysłania`,
        sendingDaysTooltip: `Wprowadź czas wysłania w formacie DD/MM, gdzie DD to dzień, a MM to miesiąc. Więcej niż jedną datę rozdziel średnikiem.`,
        sendingDaysOption: `Wybierz czas wysłania`,
        contentSms: `Treść wiadomości SMS`,
        contentEmail: `Treść wiadomości e-mail`,
        blockApplication: `Blokuj aplikację gdy wystąpi zaległość`,
        invoiceStatusTypes: `Typy statusów faktury`,
        invoiceStatuses: {
          notPaid: 'Niezapłacone',
          notFull: 'Zapłacone częściowo'
        }
      }
    },
    excmmessages: {
      list: {
        messagesApproved: 'Wiadomości zaakceptowane',
        messagesToApprove: 'Wiadomości do zaakceptowania',
        noMessages: 'Brak wiadomości',
        messageType: 'Typ nadawcy',
        createdAt: 'Utworzono',
        modifiedAt: 'Zmodyfikowano',
        plannedSending: `Zaplanowana wysyłka`,
        sender: 'Nadawca',
        recipient: 'Odbiorca DO',
        recipientCc: 'Odbiorca DW',
        recipientPhoneEmail: 'Odbiorca (numer lub e-mail)',
        subject: 'Tytuł',
        content: 'Treść',
        status: 'Status',
        sentStatus: 'Status wysyłki'
      }
    },
    excmtag: {
      noTags: `Brak wprowadzonych tagów`,
      title: 'Tytuł',
      consentTag: 'Przeznaczenie tagu',
      options: 'Opcje',
      tagOption: {
        tagTypeOption1: 'dla umowy',
        tagTypeOption2: 'dla użytkownika/kontrahenta',
        tagTypeOption3: 'dla zlecenia',
        tagTypeOption4: 'dla zamówienia',
        tagTypeOption5: 'dla towaru/usługi'
      }
    },
    exsbbank: {
      form: {
        title: 'Nazwa banku',
        description: 'Opis'
      },
      list: {
        title: 'Bank',
        description: 'Opis'
      }
    },
    exsbpaymentsmade: {
      edit: {
        missing: `Brakująca kwota`,
        edit: `Edycja wpłaty`,
        split: `Rozdzielenie wpłaty`,
        bankPayment: `Wpłata`,
        account: `Nr konta`,
        payer: `Płatnik`,
        description: `Tytuł wpłaty`,
        value: `Kwota z paczki bankowej`,
        valueTotal: `Kwota wszystkich powiązanych wpłat łącznie z niniejszą`,
        paymentDate: `Płatność z dnia`,
        operationType: `Typ operacji`,
        documentCashPaymentType: 'Wpłata ma dotyczyć',
        types: {
          toAgreement: `Wpłata do umowy`,
          toInvoice: `Wpłata do faktury`
        },
        paymentMadeToInvoice: {
          header: `Edycja wpłaty do faktury`
        }
      },
      form: {
        valueProvision: 'Wartość prowizji',
        paymentDate: 'Data wpłaty',
        paymentsType: 'Typ wpłaty',
        fromAccount: 'Konto z którego dokonano wpłatę',
        description: 'Opis',
        required: 'To pole jest wymagane',
        addAccountToAgreement: `Powiąż numer konta wpłaty z umową`,
        potencialRelationsList: `Znaleziono umowy potencjalne pasujące do wybranej wpłaty. Proszę kliknąć na strzałkę, aby wybrać umowę dla wpłaty:`,
        noPotencialRelationsOnList: `Jeśli umowa nie znajduje się na liście, proszę wybrać umowę ręcznie z listy umów poniżej`,
        paymentsTypes: {
          electronic: 'Przelew elektroniczny',
          bankPayment: 'Wpłata bankowa',
          cash: 'Gotówka',
          bank: 'Wpłata bankowa',
          card: 'Płatność kartą',
          voucher: 'Voucher',
          electronicPayment: 'Przelew internetowy/elektroniczny',
          transfer: 'Przelew',
          manualTransfer: 'Przelew ręczny',
          settlementOverpayment: 'Rozliczenie nadpłaty z okresów poprzednich',
          remission: 'Umorzenie'
        }
      },
      list: {
        agreement: 'Umowa',
        invoice: 'Faktura',
        contractor: 'Kontrahent',
        paymentDate: 'Data wpłaty',
        bank: 'Bank',
        value: 'Wartość',
        promotion: 'Promocja',
        idEXSBInvoice: 'Powiązanie z fakturą',
        idBankPackage: 'Powiązanie z paczką bankową',
        idUserDataToInvoice: 'Kontrahent w powiązanej fakturze'
      }
    },
    exsbrefund: {
      list: {
        idClient: 'Kontrahent',
        paymentDate: 'Data operacji',
        value: 'Wartość',
        idBankPayment: 'Wpłata bankowa nierozliczona lub rozliczona częściowo',
        noRefunds: 'Brak zwrotów'
      },
      form: {
        paymentDate: 'Data operacji',
        description: 'Opis operacji',
        bankPaymentDescription: 'Opis wpłaty bankowej'
      }
    },
    documents: {
      index: 'Dokumenty finansowe',
      list: {
        noDocuments: 'Brak wprowadzonych dokumentów'
      }
    },
    documentFiles: {
      index: 'Przesłane dokumenty',
      indexFirm: 'Dokumenty kontrahenta',
      list: {
        noDocuments: 'Brak przesłanych dokumentów'
      }
    },
    consents: {
      form: {
        title: 'Tytuł',
        description: 'Opis',
        require: 'Wymagana',
        showOnAgreement: 'Widok umowy',
        showOnAgreementSign: 'Podpisywanie online',
        showOnAgreementAccept: 'Akceptowanie online',
        showOnline: 'Formularz zapisu',
        consentType: 'Przeznaczenie zgody',
        forSla: 'Dla umowy SLA',
        forAgreement: 'Dla umowy na usługi'
      },
      create: {
        title: 'Dodawanie zgody'
      },
      list: {
        title: 'Zgoda',
        description: 'Opis',
        state: 'Stan',
        showOnAgreement: 'Widok umowy',
        showOnAgreementSign: 'Podpisywanie online',
        showOnAgreementAccept: 'Akceptowanie online',
        showOnline: 'Formularz zapisu',
        noConsents: 'Brak wprowadzonych zgód'
      }
    },
    packages: {
      list: {
        noPackages: 'Brak pakietów'
      },
      show: {
        package: 'Pakiet',
        promotions: 'Promocje',
        packagesDevices: 'Urządzenia przypisane do pakietu'
      }
    },
    promotions: {
      form: {
        limitStatus: 'Włącz limit w promocji procentowej',
        limitValue: 'Wielkość limitu',
        special: 'Specjalna',
        specialModelType: 'Rodzaj promocji specjalnej',
        specialModelTypeCancelLastQuantity: 'Bez ostatniej raty',
        cancelLastQuantity: 'Minimalna ilość rat od której promocja działa',
        select: 'Wybierz',
        title: 'Nazwa promocji',
        titleRequired: 'Nazwa promocji jest polem wymaganym',
        description: 'Opis promocji',
        descriptionRequired: 'Opis promocji jest polem wymaganym',
        value: 'Wartość',
        valueRequired: 'Wartość jest polem wymaganym',
        type: 'Typ promocji',
        typeRequired: 'Typ promocji jest polem wymaganym',
        amountvalue: 'Promocja kwotowa',
        percentvalue: 'Promocja procentowa',
        canjoin: 'Łączenie z innymi promocjami',
        canjoinRequired: 'Łączenie z innymi jest polem wymaganym',
        canjoinYes: 'Łącz z innymi promocjami',
        canjoinNo: 'Nie łącz z innymi promocjami',
        firstValue: 'Wartość obniżki dla pierwszej wpłaty',
        firstValueRequired: 'Wartość obniżki dla pierwszej wpłaty jest polem wymaganym',
        no: 'Nie',
        yes: 'Tak',
        importance: 'Ważność',
        importanceRequired: 'Ważność jest polem wymaganym',
        weight: 'Waga (jeżli ważność taka sama)',
        weightRequired: 'Waga jest polem wymaganym',
        dateFrom: 'Data i godzina rozpoczęcia',
        dateFromRequired: 'Data i godzina rozpoczęcia jest polem wymaganym',
        dateTo: 'Data i godzina zakończenia',
        dateToRequired: 'Data i godzina zakończenia jest polem wymaganym',
        hourlySettlement: 'Promocja dotyczy',
        coursesModel: 'Ceny kursu',
        hourlySettlementModel: 'Stawek godzinowych',
        hourlySettlementRequired: 'Rozliczenie godzinowe jest polem wymaganym',
        minusFrom: 'Sposób działania',
        minusFromRequired: 'Sposób działania jest polem wymaganym',
        distribute: 'Rozłóż równomiernie',
        countoff: 'Odlicz od ostatniej raty',
        fromFirstValue: 'Odlicz od wartości początkowej',
        fromLastValue: 'Odlicz od wartości końcowej',
        state: 'Stan',
        active: 'Promocja aktywna',
        inactive: 'Promocja nieaktywna',
        joinPromotions: 'Łączenie promocji',
        dividedType: 'Rodzaj podziału',
        percentMinusFrom: 'Kolejność działania',
        advancedParams: 'Rozwiń dodatkowe ustawienia promocji',
        importanceSelect: {
          null: '0 (Najważniejsza)',
          one: '1',
          two: '2',
          three: '3',
          four: '4',
          five: '5',
          six: '6',
          seven: '7',
          eight: '8',
          nine: '9 (Najmniej ważna)'
        },
        addOnlyIfPaidInvoices: 'Dołącz tylko wtedy gdy zapłacono faktury',
        itemAsPromotion: 'Pozycja, która pojawi się jako promocja na fakturze'
      },
      create: {
        title: 'Dodawanie promocji'
      },
      update: {
        title: 'Edycja promocji'
      },
      list: {
        showall: 'promocje',
        add: 'Dodaj promocje',
        update: 'Edycja promocji',
        closed: 'Pokaż ustawienia dodatkowe',
        opened: 'Zamknij ustawienia dodatkowe',
        noPromotions: 'Brak wprowadzonych promocji'
      }
    },
    notice: {
      index: 'Ogłoszenia',
      list: {
        noNotices: 'Brak ogłoszeń',
        title: 'Tytuł',
        description: 'Opis'
      }
    },
    log: {
      list: {
        table: {
          createdAt: `Data`,
          message: `Operacja`,
          userName: `Login`,
          userDataName: `Imię i nazwisko`
        }
      }
    },
    ticket: {
      show: {
        title: `Zgłoszenie z zewnętrznej aplikacji`,
        internalData: `Dane wewnętrzne`,
        sentToIam: `Wysłane to do systemu IAM`,
        state: `Stan`,
        createdAt: `Stworzone przez`,
        updatedAt: `Edytowane przez`,
        deletedBy: `Usuniętę przez`,
        message: `Wiadomość`,
        priority: `Prioritet`,
        status: `Status`,
        idTicketFromApplication: `ID Zgłoszenia`,
        application: `Aplikacja`,
        documents: `Dokumenty`
      },
      list: {
        noTickets: `Brak wprowadzonych zgłoszeń zewnętrznych aplikacji`,
        title: `Zgłoszenia z zewnętrznych aplikacji`,
        table: {
          date: `Data`,
          application: `Aplikacja`,
          title: `Tytuł`,
          description: `Treść`,
          userEmailFromApplication: `Tworzący ticket z aplikacji`
        }
      }
    },
    database: {
      list: {
        status: `Status`,
        desc: `Opis`,
        name: `Nazwa`,
        title: `Bazy danych`
      },
      create: {
        title: `Utwórz nową baze danych`
      },
      update: {
        title: `Edycja bazy danych`
      },
      form: {
        title: `Tytuł`,
        description: `Opis`,
        host: `Host`,
        server: `Serwer`,
        username: `Użytkownik bazy danych `,
        password: `Hasło do bazy danych`,
        port: `Port`
      },
      show: {
        title: `Baza danych`
      }
    },
    internalannouncement: {
      form: {
        title: `Tytuł`,
        internalDescription: `Opis wewnętrzny`,
        content: `Treść`,
        dateFrom: `Data widoczności od`,
        dateTo: `Data widoczności do`,
        dateFromTo: `Data widoczności od-do`,
        visibleNow: `Aktualnie widoczne`,
        applicationType: `Rodzaj aplikacji`,
        priority: `Priorytet`,
        priorityOptions: {
          LOW: `Niski`,
          HIGH: `Wysoki`
        },
        internalAnnouncementApplication: `Aplikacje`,
        recipientType: `Widoczność dla`,
        recipientTypeOptions: {
          ROLE_CHILD: `Uczniów`,
          ROLE_PARENT: `Rodziców`,
          ROLE_TEACHER: `Nauczycieli`,
          ROLE_OFFICE: `Biura`,
          ROLE_ADMIN: `Administratorów/właścicieli`
        },
        published: `Opublikowane`,
        publish: `Opublikuj`,
        addAllApplications: `Dodaj wszystkie aplikacje`,
        clearAllApplications: `Wyczyść wszystkie aplikacje`,
        addAllApplicationsFromTag: `Dodaj wg tagu`,
        addAllApplicationsFromWithoutTag: `Dodaj bez tagu`,
        addAllApplicationsFromStatus: `Dodaj wg statusu`,
        addAllApplicationsFromSalesOpportunity: `Dodaj wg szansy sprzedażowej`,
        storeAndPublish: `Zapisz i opublikuj`
      }
    },
    server: {
      list: {
        title: `Serwery`
      },
      create: {
        title: `Dodaj nowy serwer`
      },
      update: {
        title: `Edycja serwera`
      },
      form: {
        title: `Nazwa serwera`,
        host: `Host`,
        port: `Port`
      }
    },
    sqlscriptexecuted: {
      list: {
        title: `Skrypty SQL wykonane na aplikacjach`,
        scriptExecuted: `Skrypt wykonano`
      },
      show: {
        title: `Wykonany skrypt SQL`
      }
    },
    application: {
      list: {
        noApplications: 'Brak aplikacji',
        application: `Aplikacja`,
        status: `Status`,
        domain: `Domena`,
        server: `Server`,
        title: `Aplikacje`,
        connectionSuccess: `Połączono pomyślnie`,
        connectionFailure: `Brak połączenia`,
        blockStatus: `Zablokowano`
      },
      create: {
        title: `Utwórz nową aplikacje`
      },
      update: {
        title: `Edycja aplikacji`
      },
      form: {
        idUserData: `Kontrahent`,
        applicationType: `Rodzaj aplikacji`,
        domain: `Domena aplikacji (np. edusky.pl)`,
        subdomain: `Subdomena (np. demo)`,
        linkedApplicationNames: `Powiązane aplikacje (wprowadź nazwy aplikacji po przecinku)`,
        connectionKey: `Klucz do połączenia z aplikacją`,
        databaseConnection: `Baza danych`,
        databaseImportFile: `Baza konfiguracyjna do zaimportowania`,
        databaseName: `Nazwa bazy danych`,
        databaseUsername: `Nazwa użytkownika bazy danych`,
        databasePassword: `Hasło użytkownika bazy danych`,
        server: `Serwer`,
        databaseInfo: `Nazwa bazy danych oraz użytkownik zostaną wygenerowani automatycznie`,
        sshConnectionInfo: `Wprowadź login i hasło do zalogowania się po SSH (dane nie są przechowywane w bazie danych)`,
        pusherInfo: `Wprowadź dane aplikacji Pusher do konfiguracji`,
        pusherAppId: `App Id`,
        pusherAppKey: `App Key`,
        pusherAppSecret: `App Secret`,
        pusherCluster: `Cluster`,
        swiftmailerInfo: `Wprowadź dane do konfiguracji Swiftmailer`,
        SwiftmailerTransport: `Swiftmailer Transport`,
        SwiftmailerHost: `Host`,
        SwiftmailerUsername: `Username`,
        SwiftmailerPassword: `Password`,
        SwiftmailerSenderType: `Sender Type`,
        SwiftmailerPort: `Port`,
        SwiftmailerEncryption: `Encryption`,
        SSHUsername: `Login do SSH`,
        SSHPassword: `Hasło do SSH`,
        confirmationCreatingSubdomain: `Czy została utworzona subdomena i przekierowana na adres serwera?`,
        createNewInstance: `Czy chcesz uruchomić skrypt dodający nową instancję dla aplikacji na serwerze?`,
        sqlScript: `Skrypt MySQL do wykonania`
      },
      show: {
        title: `Aplikacja`,
        created: `Data dodania`,
        databaseConnection: `Baza danych`,
        server: `Serwer`,
        SSHReturn: `Informacja zwrotna podczas tworzenia aplikacji`,
        executedAt: `Data wykonania skryptu`,
        executeReturn: `Informacja zwrotna z serwera`,
        sqlScriptExecuted: `Wykonywany skrypt`,
        application: `Aplikacja`,
        activeUsersInGroup: `Aktywni uczniowie w grupach`,
        activeUsersInGroupAverage: `Średnia aktywnych uczniów w danym miesiącu`,
        activeagreements: `Aktywne umowy`,
        inactiveAgreements: `Nieaktywne umowy`,
        activeAgreementsAverage: `Średnia ilość aktywnych umów w danym miesiącu`,
        dateRange: 'Zakres wyświetlanych danych',
        last30days: 'Ostatnie 30 dni',
        last60days: 'Ostatnie 60 dni',
        last90days: 'Ostatnie 90 dni',
        last180days: 'Ostatnie 180 dni'
      },
      notifications: {
        block: {
          title: `Czy chcesz zablokować wybraną aplikacje?`,
          text: `Aplikacja zostanie zablokowana i klient nie będzie mógł z niej dalej korzystać.`
        },
        unblock: {
          title: `Czy chcesz odblokować wybraną aplikacje?`,
          text: `Aplikacja zostanie odblokowania i klient będzie mógł zacząć z niej korzystać.`
        }
      },
      sqlScriptRun: {
        title: `Wykonanie skryptu SQL`
      }
    },
    excmrelationuserdata: {
      form: {
        userData: `Uczestnik`
      }
    },
    timetable: {
      show: {
        header: `Terminarz zadań`,
        showOtherUsers: `Pokaż zadania innych pracowników`,
        showCalendars: `Pokazuj kalendarze`,
        myCalendar: `Mój kalendarz`
      },
      dashboard: {
        trasnferedBy: `Zlecono przez`,
        upcomingTasks: `Zaplanowane zadania`,
        poolCases: `Zlecenia do pobrania`,
        myCasesHeader: `Moje zlecenia`,
        upcomingMeetings: `Nadchodzące spotkania`,
        upcomingPhones: `Nadchodzące telefony`,
        salesOpportunities: {
          header: `Szanse sprzedaży`,
          new: `Nowe`,
          analysis: `Analiza`,
          saleOpportunity: `Szansa sprzedaży`
        },
        suggestedRelations: {
          header: `Sugerowane zadania`
        },
        statistics: {
          header: `Statystyki`
        }
      }
    },
    excmuserdatasalesopportunity: {
      create: {
        title: `Dodawanie szansy sprzedażowej`
      },
      update: {
        title: `Edycja szansy sprzedażowej`
      },
      list: {
        noSale: `Brak wprowadzonych szans sprzedażowych`,
        title: `Lista szans sprzedażowych`,
        name: `Nazwa`,
        color: `Kolor`,
        description: `Opis`
      },
      show: {
        title: `Szansa sprzedażowa`
      }
    },
    excmuserdatastatus: {
      create: {
        title: `Tworzenie statusu klientów`
      },
      form: {
        title: `Nazwa`,
        color: `Kolor`,
        description: `Opis`
      },
      list: {
        title: `Lista statusów klienta`,
        name: `Nazwa`,
        description: `Opis`,
        color: `Kolor`,
        noStatus: `Brak wprowadzonych statusów klienta`
      },
      show: {
        title: `Status klientów`,
        name: `Nazwa`,
        color: `Kolor`,
        description: `Opis`
      },
      update: {
        title: `Edycja statusu klienta`
      }
    },
    excmuserdataworkplace: {
      create: {
        title: `Tworzenie stanowiska pracy`
      },
      form: {
        title: `Nazwa`
      },
      list: {
        title: `Lista stanowisk pracy`,
        name: `Nazwa`,
        noworkplace: 'Brak stanowisk pracy'
      },
      show: {
        title: `Stanowiska pracy`,
        name: `Nazwa`
      },
      update: {
        title: `Edycja stanowiska pracy`
      }
    },
    excmrelation: {
      show: {
        title: `Spotkanie`,
        name: `Nazwa`,
        description: `Opis`,
        dateFrom: `Od`,
        dateTo: `Do`,
        userData: lang.routes.FirmShow,
        relationUserData: `Uczestnicy spotkania`,
        createRelationUserData: `Dodaj uczestnika`
      },
      update: {
        title: `Edycja spotkania`
      },
      create: {
        title: `Tworzenie spotkania`,
        title2: `Tworzenie telefonu`
      },
      form: {
        contractorMeeting: 'Dodaj spotkanie do kontrahenta',
        contractorCall: 'Dodaj telefon do kontrahenta',
        toggleDateTo: 'Dodaj datę zakończenia',
        changeHourTo: 'Zmień godzinę (do)',
        title: `Nazwa`,
        description: `Opis`,
        userData: lang.routes.FirmShow,
        date: `Dzień`,
        hourFrom: `Godzina (od)`,
        hourTo: `Godzina (do)`,
        addRelationUserData: `Dodaj uczestnika spotkania`,
        userData2: `Uczestnik spotkania`
      },
      list: {
        type: 'Rodzaj',
        relation: 'Spotkanie',
        phone: 'Telefon',
        noRelation: `Brak wprowadzonych spotkań`,
        noPhones: `Brak wprowadzonych telefonów`,
        title: `Lista spotkań i telefonów`,
        name: `Nazwa`,
        description: `Opis`,
        userData: lang.routes.FirmShow,
        dateFrom: `Od`,
        dateTo: `Do`,
        finished: `Zakończone`
      }
    },
    exsborder: {
      list: {
        title: 'Zamówienia',
        noOrders: `Brak wprowadzonych zamówień`,
        idCase: 'ID zlecenia',
        orderStatus: `Status zamówienia`,
        valueNetto: `Wartość netto`,
        valueBrutto: `Wartość brutto`,
        firm: lang.routes.FirmShow,
        client: `Osoba`,
        tags: 'Tagi',
        filters: {
          idOrderStatus: `Status zamówienia`,
          idFirm: `Klient (firma)`
        },
        completed: 'Zrealizowane',
        priced: `Wycenione`
      },
      show: {
        contractor: 'Kontrahent zamawiający',
        generateDocumentForOrder: `Generuj dokument WZ dla zamówienia`,
        showDocumentForOrder: 'Pokaż dokument WZ wygenerowany dla zamówienia',
        orderStatus: `Status zamówienia`,
        title: `Zamówienie`,
        firmname: `Firma zamawiająca`,
        orderPositions: `Zestawienie zamówienia`
      },
      form: {
        tags: 'Tagi zamówienia',
        firm: `Zamawiający (firma)`,
        addNewPosition: `Dodaj nowy towar`,
        addPositionsFromCsv: `Przygotuj listę towarów z pliku CSV`,
        addPositionsFromCsvAction: `Załaduj towary z pliku CSV`,
        positionsInCustomFieldsLoadedSuccess: `Pomyślnie załadowano towary do pola własnego z pliku CSV`,
        positions: {
          item: `Towar`,
          quantity: `Ilość`,
          quantityLocked: `Ilość pierwotna`,
          quantityCompleted: `Ilość zrealizowana`,
          pricePerUnitNetto: `Cena netto (jedn.)`,
          pricePerUnitBrutto: `Cena brutto (jedn.)`,
          valueNetto: `Wartość netto`,
          valueBrutto: `Wartość brutto`,
          measure: `Jednostka`,
          notes: 'Uwagi'
        },
        idExtractedOrderInfo: 'Zostanie utworzone nowe zlecenie z tym zamówieniem',
        orderLoadedFromFileInfo: 'Przy ładowaniu zamówienia z pliku CSV wszystkie poprzednie zamówienia w tym zleceniu zostaną zarchiwizowane'
      },
      create: {
        duplicateQuestion: 'Czy na pewno chcesz zarchiwizować to zamówienie i stworzyć jego duplikat ?',
        title: `Tworzenie zamówienia`,
        extractQuestion: 'Czy na pewno chcesz zarchiwizować to zamówienie i wyodrębnić je do nowego zlecenia?',
        completeQuestion: 'Czy na pewno chcesz zrealizować to zamówienie? Po jego zrealizowaniu pierwotne zamówienie zostanie zarchiwizowane.',
        priceQuestion: 'Czy na pewno chcesz wycenić to zamówienie? Po jego wycenie pierwotne zamówienie zostanie zarchiwizowane.'
      }
    },
    exsbsettlements: {
      show: {
        paymentDeadline: `Termin płatności`,
        selectedPositionsQuantity: `Liczba zaznaczonych pozycji`,
        modalHeader: `Generowanie faktury`,
        title: `Rozliczenie`,
        valueNetto: `Wartość całkowita netto`,
        valueBrutto: `Wartość całkowita brutto`,
        positions: `Pozycje`,
        invoiceType: `Typ faktury`,
        batchNumber: `Seria numeracji`,
        paymentWay: `Sposób płatności`,
        invoiceStatus: `Status faktury`,
        generateInvoiceQuestion: `Na pewno chcesz wygenerować fakturę dla wybranych ustawień`
      }
    },
    automats: {
      servicemanitemsreturning: {
        idUserData: `Serwisant któremu mają zostać odebrane towary`,
        title: `Odbieranie materiału serwisantowi`,
        addnewposition: `Dodaj nową pozycję`,
        position: {
          idExsbItem: `Towar`,
          idExsbWarehouse: `Magazyn na który trafi towar`,
          quantity: `Ilość`
        }
      },
      servicemanitemspicking: {
        idUserData: `Serwisant któremu mają zostać przydzielone towary`,
        title: `Wydawanie materiału serwisantowi`,
        addnewposition: `Dodaj nową pozycję`,
        position: {
          idExsbItem: `Towar`,
          idExsbWarehouse: `Magazyn z którego zostanie zabrany towar`,
          quantity: `Ilość`
        }
      }
    },
    excmregionuserdata: {
      form: {
        userData: `Osoba`
      }
    },
    excmregion: {
      create: {
        title: `Dodawanie regionu`
      },
      list: {
        noRegion: `Brak wprowadzonych regionów`,
        title: `Tytuł`,
        subtitle: `Podtytuł`
      },
      form: {
        title: `Tytuł regionu`,
        subtitle: `Podtytuł regionu`,
        userData: `Członek regionu`,
        addNewRegionUserData: `Dodaj członka regionu`,
        idCoordinator: `Koordynator regionu`
      },
      update: {
        title: `Edycja regionu`
      },
      show: {
        title: `Osoba`,
        addUserData: `Dodaj osobę`
      }
    },
    excmteamuserdata: {
      form: {
        userData: `${lang.roles.roleServiceman}`
      }
    },
    excmteam: {
      create: {
        title: `Dodawanie zespołu`
      },
      list: {
        noTeam: `Brak wprowadzonych zespołów`,
        title: `Lista zespołów`,
        name: `Nazwa`
      },
      form: {
        name: `Nazwa zespołu`,
        userData: `Członek zespołu`,
        addNewTeamUserData: `Dodaj członka zespołu`
      },
      update: {
        title: `Edycja zespołu`
      },
      show: {
        title: `Zespół`,
        name: `Nazwa`,
        addUserData: `Dodaj osobę`
      }
    },
    excmcyclictask: {
      list: {
        title: `Zadania cykliczne`,
        noTasks: `Brak wprowadzonych zadań cyklicznych`,
        agreement: 'Umowa',
        contractor: `${lang.routes.FirmShow}`,
        taskType: 'Typ zadania',
        taskTypeId: 'ID typu zadania',
        taskId: 'ID zadania',
        daysInterval: 'Interwał [dni]',
        dateFrom: 'Od',
        dateTo: 'Do'
      },
      create: {
        title: `Dodawanie zadania cyklicznego`
      },
      update: {
        title: `Edycja zadania cyklicznego`
      },
      show: {
        title: `Zadanie cykliczne`
      },
      form: {
        caseType: `Typ ${lang.menu.cases.list}`,
        caseTypeId: `ID Typu ${lang.menu.cases.list}`,
        caseNumber: `Numer ${lang.menu.cases.list}`,
        caseGenre: `Rodzaj ${lang.menu.cases.list}`,
        taskType: `Typ zadania`,
        frequency: `Częstotliwość (w dniach)`,
        dateFrom: `Obowiązuje od`,
        dateTo: `Obowiązuje do`,
        agreement: 'Umowa'
      }
    },
    excmcaruserdata: {
      form: {
        car: `Samochód`,
        dateFrom: `Od`,
        dateTo: `Do`,
        routePoints: 'Punkty na trasie',
        route: 'Punkt',
        distance: 'Pokonany dystans (w km)',
        removeField: 'Usuń punkt',
        addNewField: 'Dodaj nowy punkt trasy'
      }
    },
    dailyPlan: {
      show: {
        plannedRoute: 'Zaplanowana trasa',
        totalDistance: 'Długość całkowita',
        legDistance: 'Długość odcinka',
        noNotAssignedTasks: `Brak nieprzypisanych zajęć`,
        wouldYouLikeToCreateNextTask: `Chcesz utworzyć nowe zadanie do tego ${lang.menu.cases.list} ?`,
        cars: 'Aktywne przypisania samochodów na dany dzień'
      }
    },
    excmcar: {
      list: {
        title: `Lista samochodów`,
        name: `Marka`,
        model: `Model`,
        noCars: `Brak wprowadzonych samochodów`,
        registrationNumber: `Nr rejestracyjny`
      },
      create: {
        title: `Dodawanie samochodu`
      },
      update: {
        title: `Edycja samochodu`
      },
      form: {
        name: `Marka`,
        model: `Model`,
        registrationNumber: `Nr rejestracyjny`,
        type: `Typ`
      }
    },
    excmdailyplan: {
      overview: {
        title: `Plan miesięczny`
      },
      create: {
        title: `Plan prac na dzień`,
        notConfirmed: `Niezatwierdzony`,
        confirmed: `Zatwierdzony do realizacji`,
        confirmedBy: `Zatwierdzony przez`,
        settled: `Rozliczony`,
        settledBy: `Rozliczony przez`,
        finished: `Zakończony`,
        confirmPlan: `Zatwierdź plan`,
        restartPlan: `Restartuj plan`,
        finishPlan: `Zamknij plan`,
        heldTaskConfirmation: `Na pewno chcesz wstrzymać wykonywanie zadania? Jest to operacja nieodwracalna!`,
        restartDailyPlanConfirmation: `Na pewno chcesz zrestartować kolejność wykonywania zadań? Jest to operacja nieodwracalna!`,
        confirmDailyPlanConfirmation: `Na pewno chcesz zatwierdzić ten plan? Po zatwierdzeniu nie będziesz mógł dodawać nowych zadań! Jest to operacja nieodwracalna!`,
        finishDailyPlanConfirmation: `Na pewno chcesz rozliczyć ten plan? Po zatwierdzeniu nie będzie można edytować stanów zadań! Jest to operacja nieodwracalna!`
      },
      update: {
        title: `Plan prac na dzień`
      }
    },
    client: {
      list: {
        title: `Klienic`
      },
      update: {
        title: `Edycja klienta`
      },
      create: {
        title: `Tworzenie klienta`
      },
      show: {
        title: `Klient`
      }
    },
    servicemen: {
      list: {
        noServicemen: `Brak wprowadzonych ${lang.routes.ServicemanList}`,
        title: `${lang.menu.serviceman.index}`,
        nameAndSurname: `Imię i nazwisko`,
        status: `Status`,
        tasks: `Zadania`,
        dailyWayLength: `Trasa na dziś`,
        presentInWorkSince: `Rozpoczęcie`,
        overAt: `Zakończenie`,
        car: `Samochód`
      },
      update: {
        title: `Edycja ${lang.menu.serviceman.create}`
      },
      create: {
        title: `Tworzenie ${lang.routes.ServicemanShow}`
      },
      show: {
        title: `${lang.roles.roleServiceman}`
      }
    },
    userdatafirm: {
      list: {
        index: 'Pracownicy'
      },
      form: {
        firm: `Firma`,
        isContactPerson: `Jest osobą kontaktową`,
        vatInvoiceRecipient: `Jest odbiorcą faktury (e-mail)`,
        employeePosition: 'Stanowisko'
      }
    },
    userdataemployee: {
      list: {
        index: 'Pracownicy'
      },
      form: {
        employee: `Osoba`,
        isContactPerson: `Jest osobą kontaktową`,
        vatInvoiceRecipient: `Jest odbiorcą faktury (e-mail)`,
        employeePosition: 'Stanowisko',
        caseTypesAllowedForNotification: 'Typy zleceń dla powiadomień'
      }
    },
    user: {
      list: {
        enable: 'Aktywuj konto',
        disable: 'Dezaktywuj konto',
        enableInfo: 'Czy na pewno chcesz aktywować konto użytkownika ',
        disableInfo: 'Czy na pewno chcesz dezaktywować konto użytkownika ',
        resetPassword: 'Czy na pewno chcesz zresetować hasło użytkownika ',
        resetPasswordInfo: 'Nowe hasło zostanie wysłane na e-mail przypisany do konta użytkownika',
        noUser: `Brak wprowadzonych użytkowników`,
        title: `Użytkownicy w systemie`,
        username: `Nazwa użytkownika`,
        enabled: `Konto aktywne`,
        email: `Adres e-mail`,
        role: `Rola`
      },
      show: {
        title: `Użytkownik`,
        accountData: `Dane użytkownika`,
        userData: `Osoba powiązana z kontem`,
        username: `Nazwa`,
        email: `E-mail`,
        userdata: {
          name: `Imię`,
          surname: `Nazwisko`
        }
      },
      update: {
        title: `Edycja użytkownika`
      },
      form: {
        selectUserRole: 'Wybierz rolę dla użytkownika',
        username: `Nazwa`,
        email: `E-mail`,
        oldPassword: `Stare hasło`,
        password: `Nowe hasło`,
        confirmPassword: `Potwierdź nowe hasło`,
        enabled: `Aktywny`,
        roles: `Poziomy dostępu`
      }
    },
    excmagreementssla: {
      form: {
        sla: `SLA`
      }
    },
    excmagreementconsent: {
      form: {
        agree: `Wyrażona zgoda`
      }
    },
    excmagreementdevice: {
      form: {
        device: `Urządzenie`
      },
      list: {
        title: `Urządzenia zawarte w umowach firmy`,
        brand: `Marka`,
        model: `Model`,
        serialNumber: `Numer seryjny`
      },
      show: {
        title: `Urządzenie`,
        deviceDetails: `Szczegóły urządzenia`,
        linkedCases: `Powiązane ${lang.menu.cases.list}`
      }
    },
    excmsla: {
      create: {
        title: `Utwórz nowe SLA`,
        noSla: `brak wprowadzonych SLA`
      },
      form: {
        title: `Nazwa`,
        symbol: `Symbol`,
        description: `Opis`,
        reactionTime: `Czas reakcji`,
        bypassTime: `Czas obejścia`,
        repairTime: `Czas naprawy`,
        timeUnit: `Jednostka czasu`
      },
      list: {
        title: `Lista SLA`,
        name: `Nazwa`,
        noSla: `Brak wprowadzonych SLA`
      },
      show: {
        title: `Edycja SLA`,
        name: `Nazwa`,
        symbol: `Symbol`,
        description: `Opis`,
        reactionTime: `Czas reakcji`,
        bypassTime: `Czas obejścia`,
        repairTime: `Czas naprawy`
      },
      update: {
        title: `Edycja SLA`
      }
    },
    appconfiguration: {
      index: {
        title: `Konfiguracja aplikacji`
      },
      generalConfiguration: {
        activeTaskColor: 'Kolor aktywnych zadań',
        cancelTaskColor: 'Kolor anulowanych zadań',
        movedTaskColor: 'Kolor przeniesionych zadań',
        returnedTaskColor: 'Kolor zwróconych zadań',
        taskInfo: 'Wejście w zadanie spowoduje jego pobranie',
        roleUserForContractor: 'Rola użytkownika dla widoku "kontrahenci"',
        isHeadquartersTypeForContractor: 'Typ firmy dla widoku "kontrahenci"',
        clientTypesForPartnerUserData: 'Typy użytkowników dostępne dla listy "partner handlowy" w zleceniu'
      },
      tabs: {
        ownerConfiguration: 'Ustawienia właściciela',
        invoiceConfiguration: 'Ustawienia faktur',
        mailerLiteOptions: 'Opcje integracji z MailerLite',
        autoReportingOptions: 'Automatyczne raportowanie'
      },
      ownerConfiguration: {
        companyData: 'Dane firmy',
        companyAddress: 'Adres firmy',
        titlePartOne: 'Nazwa firmy cz.1',
        titlePartTwo: 'Nazwa firmy cz.2',
        nip: 'Nip',
        phone: 'Numer telefonu',
        email: 'E-mail',
        street: 'Ulica',
        city: 'Miasto',
        postcode: 'Kod pocztowy',
        province: 'Województwo',
        country: 'Kraj',
        bankName: 'Nazwa banku',
        number: 'Numer lokalu',
        place: 'Lokal',
        county: 'Powiat',
        numberBankAccount: 'Numer konta',
        contactPerson: 'Osoba kontaktowa',
        companyContactPersonName: 'Imię osoby do kontaktu',
        companyContactPersonSurname: 'Nazwisko osoby do kontaktu',
        companyContactPersonPhone: 'Telefon osoby do kontaktu',
        companyContactPersonPosition: 'Stanowisko',
        companyRepresentativePersonName: 'Imie osoby reprezentującej',
        companyRepresentativePersonSurname: 'Nazwisko osoby reprezentującej',
        companyRepresentativePersonPhone: 'Telefon osoby reprezentującej',
        companyRepresentativePersonPosition: 'Stanowisko',
        representativePerson: 'Osoba reprezentująca',
        extraInfo: 'Dodatkowe informacje',
        vatPayer: 'Płatnik vat',
        regon: 'Regon',
        mailerLiteConnect: 'Połącz z MailerLite',
        mailerLiteApiKey: 'Klucz API MailerLite',
        autoReporting: `Włącz automatyczne raportowanie`,
        autoReportingFtpAddress: `Adres FTP`,
        autoReportingFtpPort: `Port FTP`,
        autoReportingFtpConType: `Połączenie`,
        autoReportingFtpUser: `Użytkownik`,
        autoReportingFtpPass: `Hasło`,
        autoReportingFtp: `FTP`,
        autoReportingFtpDirectory: `Katalog docelowy FTP`,
        ksefEnabled: `Status integracji z KSeF`,
        ksefDisabled: 'Wyłączony',
        ksefTest: `Testowy`,
        ksefDemo: `Demo`,
        ksefProd: `Produkcyjny`,
        ksefAccessToken: `Token dostępu KSeF (pamiętaj, że musi być zgodny z NIP firmy oraz ze środowiskiem)`,
        sendAllToKsef: 'Wysyłaj do KSeF wszystkie dokumenty',
        ksefUnavailableMode: `Tryb awarii całkowitej KSeF`,
        ksefUnavaliableModeInfo: `W przypadku wystąpienia awarii całkowitej KSeF, uniemożliwiającej przesyłanie faktur, możesz tymczasowo przełączyć integrację z KSeF w tryb awarii całkowitej. W tym trybie faktury będą generowane i zapisywane w eduSky, bez podejmowania próby ich wysłania do KSeF. Po przywróceniu działania systemu KSeF, faktury wystawione w trybie awarii całkowitej będzie można ręcznie przesłać do KSeF.`,
        ksefAccessTokenSelection: `Token dostępu KSeF`,
        ksefAuthorizationType: 'Sposób autoryzacji do KSeF',
        ksefAuthorizationCertificate: `Certyfikat uwierzytelnienia do KSeF`,
        ksefAuthorizationPrivateKey: `Klucz prywatny do uwierzytelnienia do KSeF`,
        ksefAuthorizationPassphrase: `Hasło do klucza prywatnego do uwierzytelnienia do KSeF`,
        ksefSigningCertificate: `Certyfikat do podpisu faktur KSeF`,
        ksefSigningPrivateKey: `Klucz prywatny do podpisu faktur KSeF`,
        ksefSigningPassphrase: `Hasło do klucza prywatnego do podpisu faktur KSeF`,
        ksefOfflineCertificateNeeded: `Aby umożliwić generowanie faktur w trybie offline, konieczne jest korzystanie z certyfikatu. Uwierzytelnianie wyłącznie za pomocą tokena nie jest w tym trybie wystarczające.`,
        ksefAuthorizationCertificates: 'Autoryzacja KSeF',
        ksefAuthorizationKeyPresent: 'Certyfikat już zapisany - wybierz nowy, aby go zmienić',
        ksefSigningCertificates: 'Podpisywanie faktur offline'
      },
      invoiceConfiguration: {
        documentType: 'Rodzaj faktury',
        invoiceType: 'Typ faktury',
        batchNumber: 'Seria numeracji',
        issuePlace: 'Miejsce wystawienia faktury',
        salesInvoice: 'Faktura sprzedażowa',
        purchaseInvoice: 'Faktura zakupowa',
        vatInvoice: 'Faktura VAT',
        notVatInvoice: 'Faktura bez vat',
        measure: 'Jednostka miary',
        measureOptions: {
          kg: 'kg'
        },
        invoiceComment: 'Komentarz',
        interestStatus: `Odsetki włączone`,
        interest: `Roczna wartość odsetek (%)`,
        invoiceVindicationMailTitle: 'Domyślny tytuł maila windykacyjnego',
        customVindicationEmail: 'Domyślna treść maila windykacyjnego',
        customVindicationSms: 'Domyślna treść SMS windykacyjnego',
        invoiceLegend: {
          agreement_balance: 'Wpisz %agreement_balance% , aby wstawić w to saldo umowy przypisanej do faktury',
          debt_delay: 'Wpisz %debt_delay% , aby wstawić w to miejsce liczbę dni zadłużenia',
          buyer_name: 'Wpisz %buyer_name% , aby wstawić w to miejsce nazwę odbiorcy na fakturze',
          to_pay: 'Wpisz %to_pay% , aby wstawić w to miejsce kwotę do zapłaty na fakturze',
          number: 'Wpisz %number% , aby wstawić w to miejsce numer faktury'
        },
        ksefEmail: 'Treść maila wysyłanego z fakturą KSeF',
        externalSurveyEmailContent: 'Treść maila wysyłanego z przygotowaną ankietą'
      }
    },
    confacl: {
      update: {
        title: `Zmiana poziomów dostępu`
      }
    },
    documenttemplates: {
      list: {
        showall: 'Szablony dokumentów',
        add: 'Dodaj szablon',
        update: 'Edytuj szablon',
        archive: 'Archiwum',
        title: 'Tytuł',
        noDocumentTemplates: 'Brak szablonów dokumentów w systemie'
      },
      notifications: {
        edit: {
          title: 'Czy jesteś pewien, że chcesz edytować?',
          text: 'Jeśli niepoprawnie przeedytujesz szablon, może on ulec uszkodzeniu i umowy lub faktury mogą się nie generować!'
        },
        update: {
          title: 'Czy jesteś pewien, że chcesz zapisać?',
          text: 'Jeśli zapiszesz niepoprawnie przeedytowany szablon umowy lub faktury mogą się nie generować!'
        }
      },
      form: {
        title: 'Tytuł',
        description: 'Opis',
        header: 'Nagłówek',
        subheader: 'Opis do nagłówka',
        type: 'Przeznaczenie szablonu',
        forAgreement: 'Dla umowy',
        forInvoice: 'Dla faktury',
        forCase: 'Dla zlecenia',
        forTask: 'Dla zadania',
        forMessage: 'Dla wiadomości',
        idDefaultBatchNumber: 'Domyślna seria numeracji'
      }
    },
    externalform: {
      list: {
        showall: 'Formularze zewnętrzne',
        noExternalForms: 'Brak formularzy zewnętrznych',
        title: 'Tytuł',
        linkToPage: 'Skrypt do umieszczenia na stronie',
        requirmentInformation: 'Skrypt do poprawnego działania wymaga biblioteki jQuery'
      },
      form: {
        allowedDomain: 'Dozwolona domena',
        offerExternalAddress: 'Adres docelowy ze skryptem dla oferty umowy',
        librarySettings: 'Ustawienia osadzania bibliotek własnych JavaScript oraz Bootstrap',
        embedBootstrapCSS: 'Osadź w formularzu Bootstrap CSS',
        embedBootstrapJS: 'Osadź w formularzu bibliotekę Bootstrap JS',
        mailFormSetting: 'Ustawienia powiadomień',
        sendEmailToOwner: 'Wyślij wiadomość o nowym wpisie do właściciela',
        sendEmailToOffice: 'Wyślij wiadomość o nowym wpisie do pracowników biura',
        sendEmailAfter: 'Wyślij wiadomość po zatwierdzeniu',
        smsBefore: 'Autoryzacja SMSem przed wypełnianiem',
        smsAfter: 'Potwierdzenie wysyłki formularza SMSem',
        smsAfterInfo: 'Dla opcji zdalnego podpisu umowy zawsze wymagane jest potwierdzenie wysyłki formularza kodem SMS',
        actionForExistingAgreement: 'Akcja dla umowy',
        externalFormType: 'Przeznaczenie formularza',
        isExternalOffer: 'Decyzja o istniejącej ofercie',
        interestedForm: 'Formularz klienta zainteresowanego',
        isNotExternalOffer: 'Zapis nowej umowy',
        onlyProposition: 'Tylko utworzenie propozycji',
        onlyAccept: 'Tylko akceptacja',
        signAndAccept: 'Akceptacja i podpis',
        customEmail: 'Własna treść wiadomości',
        emailContent: 'Treść wiadomości',
        advancedFormSetting: 'Zaawansowane ustawienia formularza',
        infoScriptData: 'Wprowadzenie niepoprawnych danych może skutkować niepoprawnym działaniem lub brakiem działania formularza na stronie internetowej',
        afterLoaded: 'Skrypt JavaScript uruchamiany po załadowaniu formularza (wraz ze standardowymi tagami script, do 2000 znaków)',
        afterPost: 'Skrypt JavaScript uruchamiany kliknięciu przycisku wyślij (wraz ze standardowymi tagami script, do 2000 znaków)',
        customCss: 'Własny motyw CSS ładowany do szablonu formularza. Należy wkleić tu styl już gotowy do użycia (nie może być to URL do stylu).',
        agreementSetting: 'Ustawienia umów',
        documentTemplate: 'Wzór umowy',
        addTab: 'Dodaj zakładkę',
        tab: 'Zakładka',
        element: 'Element',
        addElement: 'Dodaj element',
        addCustomField: 'Dodaj pole własne',
        addNewFieldToCustomField: 'Dodaj opcję do pola własnego',
        customFieldValues: 'Tekst/identyfikator pola własnego',
        tooltip: 'Podpowiedź',
        displayField: 'Wyświetlaj',
        requiredField: 'Pole wymagane',
        orderField: 'Kolejność',
        fieldType: 'Typ pola',
        nameField: 'Nazwa pola',
        keyField: 'Identyfikator pola',
        showOnExternalForm: 'Pokaż na formularzu zewnętrznym',
        showOnAgreement: 'Pokaż na formularzu umowy',
        elementOptions: {
          packageForm: 'Pakiety',
          userDataForm: 'Dane osobowe',
          consentForm: 'Zgody',
          customFieldsForm: 'Pola własne',
          employeesForm: 'Dane o pracownikach',
          addressesForm: 'Dane o adresach',
          agreementItemsForm: 'Dane o usługach i promocjach w zapisanych umowie',
          customForm: 'Element własny',
          summaryForm: 'Podsumowanie usług'
        },
        customFieldTypeOptions: {
          input: 'Pole z nazwą',
          label: 'Tekst tylko do odczytu',
          date: 'Data',
          select: 'Lista wyboru'
        },
        groupName: 'Nazwa grupy pól',
        hasCustomHtmlContent: 'Zastąp własnym kodem HTML',
        afterSignHtml: 'Wiadomość na formularzu po zapisie'
      }
    },
    excmconsent: {
      create: {
        title: `Utwórz nową zgodę do umowy`
      },
      update: {
        title: `Edycja zgody do umów`
      },
      form: {
        title: `Nazwa`,
        description: `Opis`,
        agreementType: `Typ umowy`,
        requireConsent: `Zgoda wymagana`,
        orderConsent: `Kolejność`
      },
      list: {
        title: `Zgody do umów`,
        name: `Nazwa`,
        noConsents: `Brak zgód`
      },
      show: {
        agreementType: `Typ umowy`,
        title: `Zgoda do umów`,
        name: `Nazwa`,
        description: `Opis`,
        orderConsent: `Kolejność`,
        requireConsent: `Wymagana`
      }
    },
    excmagreementtypes: {
      list: {
        title: `Typy umów`,
        noTypes: `Brak wprowadzonych typów umów`
      },
      create: {
        title: `Utwórz typ umowy`
      },
      form: {
        title: `Nazwa`
      },
      update: {
        header: `Edytuj typ umowy`,
        title: `Nazwa`
      }
    },
    userdata: {
      create: {
        title: `Utwórz osobę`
      },
      form: {
        firmname1: 'Nazwa firmy',
        startTyping: 'Zacznij wpisywać...',
        streetNumber: 'Numer ulicy',
        placeNumber: 'Numer lokalu',
        name: `Imię`,
        surname: `Nazwisko`,
        street: `Ulica`,
        city: `Miasto`,
        postcode: `Kod pocztowy`,
        mobilePhone: `Numer telefonu komórkowego`,
        phone: 'Number telefonu',
        userEmail: `Adres e-mail`,
        contactEmail: `Adres e-mail kontaktowy`,
        avatar: `Avatar`,
        extraInfo: `Informacje dodatkowe`,
        birthday: `Data urodzenia`,
        birthplace: `Miejsce urodzenia`,
        province: `Województwo`,
        country: `Państwo`,
        pesel: `PESEL`,
        idClientType: `Typ użytkownika`,
        nip: `NIP`,
        userDataColor: `Kolor`,
        addNewAddress: 'Dodaj nowy adres',
        editAddress: 'Edytuj adres',
        deleteAddress: 'Usuń adres',
        addressType: 'Typ adresu',
        customSymbol: 'Symbol własny',
        idSalesRepresentative: 'Opiekun wdrożeniowy'
      },
      list: {
        noUserdatas: 'Brak wprowadzonych osób',
        mobilePhone: `Telefon kontaktowy`,
        userEmail: `Adres e-mail`,
        title: `Lista osób zapisanych w systemie`,
        nameAndSurname: `Imię i nazwisko`,
        addMultipleUsers: 'Dodaj konta systemowe dla zaznaczonych użytkowników',
        autoAddMailerLiteSubscribers: `Dodaj zaznaczone osoby do subskrypcji MailerLite`,
        autoAddMailerLiteSubscriber: `Dodaj do listy subskrypcji MailerLite`,
        mailerLiteAddInfo: `Niniejsza czynność spowoduje dodanie adresu e-mail do listy subskrybentów na platformie MailerLite. Należy się upewnić, że adres e-mail odbiorcy jest wprowadzony do systemu.`,
        mailerLiteAddToGroupInfo: `Wybierz grupę na platformie MailerLite, do której zapisać subskrybentów`,
        mailerLiteNoAddToGroup: `Nie dodawaj subskrybentów do żadnej grupy`,
        addMultipleUsersQuestion: 'Czy chcesz utworzyć konta zaznaczonym użytkownikom?',
        anonymize: 'Czy chcesz zanonimizować tego użytkownika? Tej operacji nie można odwrócić!',
        filters: {
          name: `Imię`,
          surname: `Nazwisko`,
          state: `Zarchiwizowane`,
          userdata: 'Szybkie wyszukanie'
        }
      },
      show: {
        adress: `Adres`,
        changeAvatar: `Zmień avatar`,
        hiredIn: `Zatrudniony w`,
        title: `Dane osoby w systemie`,
        nameAndSurname: `Imię i nazwisko`,
        idClientType: `Typ użytkownika`,
        city: `Miasto`,
        street: `Ulica i nr`,
        postcode: `Kod pocztowy`,
        province: `Województwo`,
        mobilePhone: `Telefon`,
        nip: `NIP`,
        userEmail: `Adres e-mail`,
        birthplace: `Miejsce urodzenia`,
        birthday: `Data urodzenia`,
        userDataFirm: {
          firmname: `Nazwa firmy`,
          city: `Miasto`,
          street: `Ulica`,
          postcode: `Kod pocztowy`,
          province: `Województwo`,
          country: `Kraj`,
          options: {
            goToFirm: `Dane firmy`,
            editFirm: `Edytuj przypisanie firmy`,
            deleteFirm: `Usuń przypisanie firmy`,
            addNewFirm: `Dodaj nową firmę`
          }
        },
        servicemancars: {
          car: `Samochód`,
          dateFrom: `Od`,
          dateTo: `Do`
        },
        addresses: 'Adresy',
        mailerLiteStatusInfo: `MailerLite`,
        mailerLiteStatusNotAdded: `Osoba nie jest dodana na platformie MailerLite`,
        deleteFromGroup: `Usuń z grupy`,
        mailerLiteId: `ID na platformie`,
        mailerLiteDateSubscribe: `Data dodania subskrypcji`,
        mailerLiteSent: `Liczba wiadomości wysłanych`,
        mailerLiteOpened: `Liczba wiadomości otwartych`,
        mailerLiteClicked: `Liczba kliknięć w wiadomościach`,
        mailerLiteStatus: `Status`,
        mailerLiteStatusActive: `Aktywny`,
        mailerLiteStatusBounced: `Brak akceptacji/odrzucono`,
        mailerLiteStatusUnsubscribed: `Brak subskrypcji`,
        mailerLiteStatusJunk: `Oznaczono jako niechciane`,
        mailerLiteStatusUnconfirmed: `Niepotwierdzony`,
        mailerLiteGroups: `Grupy subskrypcji, do których jest zapisany`,
        inGroupsMembers: `Ilość członków`,
        inGroupsMembersTotal: `Ilość wszystkich subskrybentów`,
        inGroupsMembersActive: `Ilość aktywnych subskrybentów`,
        groupName: 'Nazwa grupy',
        emailsInGroup: 'Adresy email przypisane do grupy w MailerLite'
      },
      update: {
        title: `Aktualizacja danych osobowych`
      }
    },
    userdataaddress: {
      form: {
        addressType0: 'Adres główny',
        addressType1: 'Siedziba',
        addressType2: 'Korespondencyjny',
        addressType3: 'Rozliczenia',
        addressType4: 'Świadczenie usług',
        addressType5: 'Inwestycji',
        addressType6: 'Pozostałe'
      }
    },
    profile: {
      index: {
        tabs: {
          info: `Dane`,
          configuration: `Konfiguracja`
        },
        info: {
          name: `Imię`,
          surname: `Nazwisko`,
          mobilePhone: `Telefon`,
          userEmail: `Adres e-mail`
        }
      }
    },
    technicians: {
      index: {
        header: `Lista ${lang.routes.ServicemanList}`,
        filtering: `Filtrowanie`,
        filters: {
          status: `Status`,
          activeOnly: `Tylko aktywni`,
          businessNumber: `Numer służbowy`,
          name: `Imię`,
          surname: `Nazwisko`,
          todayPlan: `Przypisany plan na dziś`,
          carRegistrationNumber: `Numer rej. samochodu`
        },
        showProfile: `Pokaż profil`,
        showOrEditPlan: `Pokaż/edytuj plan`
      }
    },
    dashboard: {
      client: {
        header: `Moje ${lang.menu.cases.list}`
      },
      dispatcher: {
        assigned: {
          expandRows: `Rozwiń wiersze`,
          collapseRows: `Zwiń wiersze`,
          number: lang.menu.cases.index,
          type: `Typ ${lang.menu.cases.list}`,
          task: `Zadanie`,
          company: lang.routes.FirmShow,
          device: `Urządzenie`,
          form: lang.menu.cases.show
        },
        tasks: {
          header: `Zadania`,
          assignedTasks: `Przypisane`,
          notAssignedTasks: `Nieprzypisane`,
          myTasks: 'Moje zadania',
          tasksInPool: 'Zadania do pobrania'
        },
        technicians: {
          header: `${lang.menu.serviceman.index}`,
          availableTechnicians: `Wolni`,
          notAvailableTechnicians: `W trasie`
        },
        calendar: {
          header: `Kalendarz przypisanych zadań`
        }
      }
    },
    login: {
      index: {
        wrongData: `Niepoprawny login lub hasło`,
        login: `Logowanie`,
        forgotPassword: 'Nie pamiętam hasła',
        registration: 'Rejestracja',
        enterEmail: 'Podaj adres e-mail należący do konta'
      },
      form: {
        password: `Hasło`,
        username: `Login`,
        login: `Zaloguj się`
      }
    },
    firm: {
      list: {
        noDepartments: 'Brak oddziałów',
        contact: `Kontakt`,
        title: lang.routes.FirmList,
        noFirms: `Brak wprowadzonych ${lang.views.firm.list.noFirm}`,
        firmname1: `Nazwa`,
        address: `Adres`,
        nip: `NIP`,
        filters: {
          firmname1: `Nazwa`,
          country: `Państwo`,
          city: `Miasto`,
          nip: `NIP`,
          street: `Ulica`,
          postcode: `Kod pocztowy`,
          state: `Zarchiwizowane`
        }
      },
      create: {
        title: `Utwórz ${lang.views.firm.create.title}`,
        type: `Rodzaj ${lang.views.firm.create.type}`,
        company: lang.routes.FirmShow,
        person: `Osoba fizyczna`
      },
      form: {
        regon: 'Numer REGON',
        krs: 'Numer KRS',
        idRegion: 'Region',
        customSymbol: 'Symbol własny',
        maxOpenCasesForPartnerAllowed: 'Maksymalna liczba otwartych projektów stacjonarnych',
        tags: 'Tagi',
        withoutTags: 'Bez tagów',
        isCompany: `Firma`,
        idStatus: `Status klienta`,
        idOpportunity: `Szanse sprzedażowe`,
        idWorkplace: `Stanowisko`,
        types: {
          department: `oddział`,
          headquarters: `siedziba główna`
        },
        contact: {
          isNotContactPerson: `nie jest osobą kontaktową`,
          isContactPerson: `jest osobą kontaktową`
        },
        supplier: `Dostawca`,
        recipient: `Odbiorca`,
        idHeadquarters: `Siedziba główna`,
        isHeadquarters: `Typ firmy`,
        idClientType: `Rola w systemie`,
        country: `Kraj`,
        extraInfo: `Informacje dodatkowe`,
        nip: `NIP`,
        firmname1: `Pełna nazwa firmy`,
        firmname2: `Skrócona nazwa firmy`,
        street: `Nazwa ulicy`,
        streetNumber: 'Numer',
        placeNumber: 'Numer lokalu',
        city: `Miasto`,
        postcode: `Kod pocztowy`,
        province: `Województwo`,
        downloadData: `Pobierz`,
        downloadDataTooltip: `Pobierz dane firmy na podstawie numeru NIP`,
        headquartersAndItsEmployees: `Siedziba główna i jej pracownicy`,
        addNewPerson: `Dodaj nową osobę do systemu`,
        employees: `Pracownicy`,
        addNewEmployee: `Dodaj nowego pracownika`,
        employee: {
          name: `Imię`,
          surname: `Nazwisko`,
          mobilePhone: `Telefon kom.`,
          userEmail: `Adres e-mail`,
          isContactPerson: `osoba kontaktowa`,
          newHeader: `Nowy pracownik`,
          editHeader: `Edycja pracownika`
        },
        addNewDepartment: `Dodaj oddział`,
        department: {
          header: `Oddział`,
          newHeader: `Nowy oddział`,
          editHeader: `Edycja oddziału`,
          firmname1: `Nazwa`,
          adress: `Adres`,
          employeesNumber: `Liczba wprowadzonych pracowników`,
          nip: `NIP`
        },
        firmDepartments: `Oddziały firmy`,
        doNotVindicate: 'Nie windykuj'
      },
      show: {
        applicationsList: `Aplikacje`,
        title: `Dane firmy`,
        firmname1: `Nazwa firmy`,
        firmname2: `Skrócona nazwa`,
        city: `Miasto`,
        status: `Status`,
        isHeadquarters: `siedziba główna`,
        isNotHeadquarters: `oddział`,
        nip: `NIP`,
        street: `Nazwa ulicy`,
        streetNumber: 'Numer',
        placeNumber: 'Numer lokalu',
        postcode: `Kod pocztowy`,
        province: `Województwo`,
        userDataEmployees: `Pracownicy`,
        userDataEmployee: {
          index: `Index`,
          nameAndSurname: `Imię i nazwisko`,
          mobilePhone: `Telefon kontaktowy`,
          userEmail: `Adres e-mail`,
          isContactPerson: `Osoba kontaktowa`,
          vatInvoiceRecipient: `Jest odbiorcą faktury (e-mail)`,
          options: {
            userDataShow: `Dane osobowe`,
            userShow: `Konto systemowe`,
            userCreate: `Utwórz konto`
          }
        },
        firmDepartments: `Oddziały`,
        firmDepartment: {
          firmname1: `Nazwa pełna`,
          firmname2: `Nazwa skrócona`,
          nip: `NIP`,
          adress: `Adres`,
          firmEmployees: `Pracownicy oddziału`,
          noFirmEmployees: `Brak pracowników`
        },
        addNewEmployee: `Dodaj pracownika`,
        addNewDepartment: `Dodaj oddział`,
        addresses: 'Adresy'
      },
      update: {
        title: `Edycja firmy`
      }
    },
    agreements: {
      create: {
        title: `Utwórz umowę`
      },
      list: {
        createAgreementItemsCollection: 'Usługi do umowy zostaną dodane następującym klientom',
        sendEmailPropositionCollection: 'Propozycja umowy zostanie przedstawiona następującym klientom',
        decisionUser: {
          rejected: 'Odrzucona',
          offer: 'Propozycja',
          waiting: 'Oczekuje',
          accepted: 'Zaakceptowano',
          signed: 'Podpisano',
          signaturePending: 'W podpisie'
        },
        options: {
          sendOfferToAcceptCollection: 'Wyślij propozycję e-mailem do zaznaczonych klientów',
          sendOfferToAccept: 'Przedstaw propozycję do akceptacji',
          sendEmailProposition: 'Wyślij propozycję do klienta e-mailem',
          confirmAgreementSigning: 'Zmień status na podpisana',
          acceptOffer: 'Zaakceptuj propozycję umowy',
          rejectOffer: 'Odrzuć propozycję umowy',
          acceptWithCommentOffer: 'Zaakceptuj propozycję z uwagami',
          massEditAgreements: 'Edytuj masowo zaznaczone umowy',
          createAgreementItems: 'Dodaj usługi lub warianty do wielu umów',
          createAgreementAdditionalItems: 'Dodaj usługi dodatkowe do wielu umów',
          generateInvoicesFromAgreements: 'Wygeneruj faktury dla wszystkich umów',
          updateDebtInfoInAgreements: 'Zregeneruj wartości zadłużenia we wszystkich umowach',
          generateInvoicesFromAgreementsSelected: 'Wygeneruj faktury dla zaznaczonych umów',
          generateInvoiceFromAgreementAgain: 'Przelicz ponownie tę fakturę'
        },
        noNumber: 'Brak numeru',
        noAgreements: `Brak wprowadzonych umów do systemu`,
        noSelectedAgreements: `Brak wybranych umów do masowej edycji. Należy powrócić do widoku listy umów i stamtąd wybrać umowy do masowej edycji.`,
        massEditModified: `Wprowadzono zmiany`,
        dateFrom: 'Data obowiązywania (od)',
        date: 'Czy obowiązuje',
        created: 'Utworzono',
        agreementNumber: 'Numer umowy',
        paymentPlan: 'Model płatności',
        status: 'Status umowy',
        userData: 'Kontrahent',
        priceUserDataFrom: 'Cena własna usługi od',
        priceUserDataTo: 'Cena własna usługi do',
        currentStatuses: {
          notOpened: 'Oferta jeszcze nieotwarta',
          opened: 'Otworzenie oferty',
          currentStep: 'Odbiorca przegląda sekcję formularza',
          agreementSaved: 'Umowa zapisana',
          smsCodeSent: 'Wysłano kod SMS',
          signedBySmsCode: 'Umowa podpisana kodem SMS'
        },
        statuses: {
          newAgreement: 'nowa umowa',
          acceptedAgreement: 'zaakceptowana umowa',
          signedAgreement: 'podpisana umowa',
          signingAgreement: 'umowa w trakcie podpisu'
        },
        types: {
          agreementOffer: 'Propozycja umowy',
          contract: 'Umowa'
        }
      },
      form: {
        serviceDateFrom: 'Data rozpoczęcia świadczenia usługi',
        '12months': '12 miesięcy',
        '24months': '24 miesiące',
        other: 'inny',
        agreementLength: 'Czas trwania umowy',
        dayNextPayments: 'Dzień miesiąca fakturowania',
        offerDescription: 'Komentarz do propozycji umowy',
        autoInvoicing: 'Fakturowanie automatyczne',
        invoiceSettings: 'Parametry faktur',
        timelessCyclicItem: 'Bez daty zakończenia',
        isCyclic: 'Usługa jest cykliczna',
        alwaysSettleInFull: 'Zawsze rozliczaj usługę w całości',
        basePriceWithoutPromotion: 'Cena brutto bez promocji',
        additionalDocumentTemplate: 'Dodatkowy szablon umowy',
        paymentPeriod: 'Okres rozliczeniowy',
        paymentFrequency: {
          annual: 'Roczny',
          semiAnnual: 'Półroczny',
          quarterly: 'Kwartalny',
          monthly: 'Miesięczny'
        },
        dates: 'Daty',
        SMSMessage: 'Wpisz poniżej kod, który otrzymałeś w wiadomości SMS. Możesz wysłać kod ponownie wybierając opcję poniżej. Jeśli nie otrzymałeś kodu, skontaktuj się ze wsparciem. Numer kodu potwierdzającego:',
        accept: {
          consentRequired: 'Co najmniej jedna zgoda nie została zaznaczona',
          isRequired: 'jest wyamagana'
        },
        agreementOffer: 'Propozycja umowy',
        agreeRequired: 'Zgoda wymagana',
        noagree: 'Brak zgody',
        agree: 'Zgoda',
        agreementsConsents: 'Zgody',
        advanceValueRequired: '\'Kwota\' jest polem wymaganym',
        advanceDescription: 'Opis zaliczki',
        advanceDate: 'Data zaliczki',
        advanceValue: 'Kwota',
        advancePayment: 'Zaliczka',
        additionalInfo: 'Parametry dodatkowe umów',
        documentTemplateRequired: '\'Wzrór umowy\' jest polem wymaganym',
        documentTemplate: 'Wzór umowy',
        package: 'Pakiet',
        invoices: 'Parametry dla faktur',
        addCoursePriceCostToPayment: 'Wygeneruj płatność dla kosztów materiałów kursu',
        otherSetting: 'Pozostałe ustawienia',
        idDefaultElectronicPayment: 'Domyślna płatność elektroniczna',
        electronicPayments: 'Płatności elektroniczne',
        electronicPaymentsHeader: 'Parametry dla płatności elektronicznych',
        invoiceAppendAgreementComment: 'Dodawaj komentarz do generowanych faktur',
        invoiceComment: 'Komentarz do generowanych faktur',
        paymentDaysInvoice: 'Ilość dni na zapłatę (Wyliczany na fakturze termin płatności)',
        idEXSBPaymentWay: 'Rodzaj płatności',
        vatInvoice: 'Faktura VAT',
        monthlyInvoice: 'Fakturowanie miesięczne',
        serviceRequired: 'Pole \'usługa\' jest wymagane',
        toPay: 'Do zapłaty',
        total: 'Razem',
        signedDate: 'Data podpisania',
        dateFrom: 'Data obowiązywania od',
        dateTo: 'Data obowiązywania do',
        timelessAgreement: 'Umowa bez daty zakończenia',
        customSymbol: 'Symbol własny umowy',
        idUserDataRequired: 'Pole \'Kontrahent\' jest wymagane',
        select: 'Wybierz',
        tags: 'Tagi umowy',
        contractor: 'Kontrahent',
        addContractor: 'Dodaj nowego kontrahenta',
        editContractor: 'Edytuj kontrahenta',
        agreementsPromotions: 'Promocje',
        addNewPromotion: 'Dodaj promocję',
        agreementsDevices: 'Urządzenia',
        addNewDevice: 'Dodaj urządzenie',
        items: 'Usługi',
        additionalItems: 'Dodatkowe usługi',
        offerExternalForm: 'Wzór formularza do zdalnej decyzji',
        customFields: 'Pola własne',
        customField: 'Pole',
        customValue: 'Wartość'
      },
      show: {
        signedAgreement: 'Umowa podpisana',
        decisionUser: 'Decyzja użytkownika',
        signedBy: 'Decyzja podjęta przez',
        confirmationPin: 'Kod potwierdzający',
        confirmationPhone: 'Telefon na który wysłano kod potwierdzający',
        messageNumber: 'Liczba wysłanych wiadomości SMS z kodem',
        sendMessageDate: 'Data wysłania ostatniej wiadomości z kodem',
        clientIp: 'Adres IP komputera',
        isSigned: 'Data zdalnego podpisania umowy',
        isNotSigned: 'Umowa nie została podpisana zdalnie',
        offerDescriptionInformation: 'Informacje o propozycji umowy',
        inSignedAgreementsOffers: 'W podpisie',
        acceptedAgreementsOffers: 'Zaakceptowane',
        acceptedWithCommentsAgreementsOffers: 'Warunkowo',
        pendingSms: 'Wysłano SMS potwierdzający, jeszcze nie podpisano',
        rejectedAgreementsOffers: 'Odrzucone',
        preparedAgreementsOffers: 'Przygotowane',
        noDecisionAgreementsOffers: 'Oczekuje',
        propositionAgreementsOffers: 'Propozycja',
        downloadAgreementSignedCertificate: `Pobierz informacje o podpisie umowy`,
        decisionClient: 'Decyzja użytkownika',
        dateFirstPayment: 'Data pierwszej płatności',
        firmname: 'Nazwa firmy',
        nameAndSurname: 'Imię i nazwisko',
        email: 'Adres e-mail',
        mobilePhone: 'Numer telefonu',
        address: 'Adres',
        street: 'Ulica',
        postcode: 'Kod pocztowy',
        city: 'Miasto',
        agreement: 'Umowa',
        clientEmail: 'E-mail',
        idClient: 'Klient',
        sourceAccount: 'Powiązany numer konta z umową',
        noSourceAccount: 'Brak powiązanego numeru konta z umową',
        consents: 'Zgody',
        agree: 'Zgoda',
        noAgree: 'Brak zgody',
        noDecision: 'Brak decyzji',
        backAgree: 'Wycofano zgodę',
        agreeRequired: 'Zgoda (Wymagane)',
        dateFromExist: 'Data rozpoczęcia obowiązywania',
        dateToExist: 'Data zakończenia obowiązywania',
        dateFromPayment: 'Data pierwszej płatności',
        dateToPayment: 'Data drugiej i kolejnych płatności',
        promotions: 'Promocje',
        variants: 'Warianty umowy',
        promotionTitle: 'Promocja',
        dateAgreement: 'Data zawarcia umowy',
        agreementNumber: 'Numer umowy',
        items: 'Usługi',
        itemTitle: 'Nazwa usługi',
        basePrice: 'Suma wartości usług w umowie',
        customPrice: 'Suma rzeczywistych wartości usług w umowie',
        advantageValue: 'Suma wartości korzyści dla klienta',
        agreementsFromOffer: 'Umowy, które pochodzą z tej oferty',
        ageOfReceivables: `Wiekowanie należności`,
        ageOfReceivablesInfo: `Uwaga. Przedstawione wiekowanie należności oraz kalkulacja odsetek oparta jest o założenie (zgodnie z Art. 451. § 1 Kodeksu cywilnego), że wpłaty zawsze pokrywają najstarsze zaległości.`,
        payments: `Płatności wymagane`,
        paymentsMades: `Wpłaty dokonane`,
        debt: `Zadłużenie`
      }
    },
    excmagreements: {
      update: {
        title: `Edycja umowy`
      },
      list: {
        terminated: 'Umowa zakończyła się',
        terminationIn: 'Umowa zakończy się za',
        title: `Lista umów`,
        noAgreements: `Brak wprowadzonych umów do systemu`,
        agreementNumber: `Numer`,
        dateFrom: `Obowiązująca od`,
        dateTo: `Obowiązująca do`,
        company: `Firma`,
        agreementCyclicTasks: `Zgłoszenie cykliczne`,
        filters: {
          company: `Firma`,
          agreementNumber: `Numer umowy`,
          state: `Zarchiwizowane`
        }
      },
      create: {
        title: `Utwórz umowę`
      },
      form: {
        isDeviceAddressBasedOnAgreement: `lokalizacja urządzenia wynika z umowy (adres firmy)`,
        agreementType: `Typ umowy`,
        dateFrom: `Obowiązująca od`,
        dateTo: `Obowiązująca do`,
        company: `Firma`,
        agreementDevices: `Urządzenia`,
        addAgreementCyclicTask: `Dodaj zadanie cykliczne do umowy`,
        addAgreementDevice: `Dodaj urządzenie do umowy`,
        addAgreementConsent: `Dodaj zgodę do umowy`,
        addAgreementSla: `Dodaj SLA do umowy`,
        device: `Urządzenie`,
        consent: `Zgoda`,
        sla: `SLA`,
        contactPerson: `Osoba kontaktowa`,
        agreementCyclicTask: {
          caseType: `Typ ${lang.menu.cases.list}`,
          caseGenre: `Rodzaj ${lang.menu.cases.list}`,
          daysQuanity: `Ilość dni`,
          taskType: `Rodzaj zadania`,
          frequency: `Częstotliwość`,
          dateFrom: `Obowiązuje w przedziale od`,
          dateTo: `Obowiązuje w przedziale do`,
          frequencyOptions: {
            ownValue: `wartość własna`,
            byDay: `co dzień`,
            byWeek: `co tydzień`,
            byMonth: `co miesiąc`,
            byThreeMonths: `co trzy miesiące`,
            bySixMonths: `co pół roku`,
            byYear: `co rok`
          }
        }
      },
      show: {
        agreementCyclicTasks: `Zadania cykliczne`,
        agreementDevices: `Urządzenia`,
        agreementConsents: `Zgody`,
        agreementSlas: `SLA`,
        title: `Umowa`,
        agreementNumber: `Numer`,
        dateFrom: `Obowiązująca od`,
        dateTo: `Obowiązująca do`,
        company: `Klient`,
        agreementSla: {
          title: `Nazwa`,
          noSlas: `Brak SLA powiązanych z tą umową`
        },
        agreementDevice: {
          deviceName: `Model`,
          deviceBrand: `Marka`,
          deviceType: `Typ`,
          serialNumber: `Numer seryjny`,
          noDevices: `Brak urządzeń powiązanych z tą umową`
        },
        agreementConsent: {
          title: `Treść`,
          agree: `Wyrażona zgoda`,
          noConsents: `Brak zgód powiązanych z tą umową`
        },
        agreementCyclicTask: {
          taskType: `Typ`,
          daysInterval: `Odstępy czasu w dniach`,
          dateFrom: `Obowiązuje od`,
          dateTo: `Obowiązuje do`,
          noCyclicTasks: `Brak przypisanych zadań cyklicznych`
        }
      }
    },
    exsbbankpackages: {
      index: {
        sendPackage: `Dodaj paczkę wpłat`,
        showAll: `Paczki wpłat`
      },
      show: {
        package: `Paczka wpłat`,
        packagelist: `Lista wpłat z paczki`,
        packagelistToDo: `Lista wpłat do wiązania`,
        packagelistDone: `Lista powiązanych wpłat do umów`,
        backtobankpackages: `Powrót do wszystkich paczek`,
        description: `Opis`,
        value: `Wartość wpłat w paczce`,
        count: `Liczba wpłat`,
        unlinkCount: `Liczba wpłat niepowiązanych`,
        bankTitle: `Bank`,
        packagelistDoneInvoices: `Lista powiązanych wpłat do faktur`
      },
      form: {
        idBank: `Bank / typ pliku z wpłatą`,
        idBankRequired: `Bank jest polem wymaganym`,
        description: `Opis`,
        descriptionRequired: `Opis jest polem wymaganym`,
        skipFirst: `Plik posiada wiersz nagłówków`,
        skipFirstRequired: `Plik posiada wiersz nagłówków jest polem wymaganym`,
        no: `Nie`,
        yes: `Tak`,
        selectFile: `Wybierz plik`,
        selectedFile: `Wybrany plik`,
        dataHasBeenProcessedAndGetIt: `Dane zostały przetworzone. Aby pobrać raport wyników kliknij przycisk "Pobierz"`,
        dataClear: `Formularz został wyczyszczony`
      }
    },
    exsbinvoices: {
      list: {
        accepted: 'Zaakceptowana',
        title: `Faktury`,
        noInvoices: `Brak wprowadzonych faktur`,
        invoiceType: `Nazwa`,
        sellDate: `Data sprzedaży`,
        valueNetto: `Wartość Netto`,
        valueBrutto: `Wartość Brutto`,
        buyer: `Kupujący`,
        buyerTags: 'Tagi kupującego',
        agreementTags: 'Tagi umowy',
        seller: `Sprzedający`,
        number: `Numer`,
        issueDate: `Data wystawienia`,
        sent: 'Faktura została wysłana',
        hasDiscountFilter: 'Faktura posiada rabat',
        totalValueNetto: `Wartość Netto`,
        totalPurchaseValueNetto: `Wartość netto ceny zakupu`,
        selectedSumTotalValueBrutto: 'Suma wartości brutto w zaznaczonych fakturach',
        selectedSumTotalValueNetto: 'Suma wartości netto w zaznaczonych fakturach',
        selectedSumToPay: 'Suma wartości do zapłaty w zaznaczonych fakturach',
        sumTotalValueBrutto: 'Suma wartości brutto dla wybranych filtrów',
        sumTotalValueNetto: 'Suma wartości netto dla wybranych filtrów',
        sumToPay: 'Suma wartości do zapłaty dla wybranych filtrów',
        totalValueBrutto: `Wartość Brutto`,
        paymentDeadline: `Termin zapłaty`,
        acceptSelectedInvoices: 'Zaakceptuj zaznaczone faktury, nadaj im numer oraz datę wystawienia',
        removeSelectedInvoices: 'Usuń zaznaczone faktury',
        generateInvoiceFromAgreementAgain: `Przelicz ponownie zaznaczone faktury`,
        sendVindicationEvents: 'Utwórz wiadomości windykacyjne dla zaznaczonych faktur',
        type: 'Typ',
        contactor: 'Kontrahent',
        priceBrutto: 'Cena brutto',
        priceNetto: 'Cena netto',
        promotion: 'Promocja',
        notSelectedCompany: 'Nie wybrano firmy!',
        priceUserDataList: 'Cenniki indywidualne',
        invoicesFilter: {
          correction: 'Uwzględnij korekty',
          noFilterResultsForInvoices: 'Brak faktur dla podanych filtrów',
          buyer: 'Nabywca',
          seller: 'Wystawca',
          status: 'Status',
          dateClear: 'Wyczyść pole daty',
          sellDateFrom: 'Data sprzedaży (od)',
          sellDateTo: 'Data sprzedaży (do)',
          issueDateFrom: 'Data wystawienia (od)',
          issueDateTo: 'Data wystawienia (do)',
          number: 'Numer',
          type: 'Typ',
          sort: 'Sortowanie',
          department: 'Oddział',
          sortWay: {
            sortByNumber: 'po numerze',
            createOrder: 'po dacie utworzenia',
            sortByIssueDate: 'po dacie wystawienia',
            sortBySellDate: 'po dacie sprzedaży'
          },
          correctionFilter: {
            allDocuments: `Dokumenty razem (faktury i korekty)`,
            onlyInvoices: `Tylko faktury`,
            onlyCorrections: `Tylko korekty`,
            onlyInvoicesWithCorrections: `Tylko faktury posiadające korekty`,
            onlyInvoicesWithoutCorrections: `Tylko faktury nieposiadające korekt`
          },
          dateType: 'Typ daty'
        },
        beforeCorrection: 'Wartość oryginalna',
        correctionDifference: 'Wartość korekty/faktury',
        toPay: 'Do zapłaty',
        lastContractorInvoice: `Ostatnia faktura kupującego`,
        ksefProcessingDescription: `Status KSeF`,
        ksefProcessingDescriptionShort: 'KSeF',
        ksefReferenceNumber: `Nr KSeF`
      },
      create: {
        title: `Utwórz fakturę`
      },
      form: {
        correctionState: 'Dokument jest korektą',
        correctionOf: 'Dokument korygowany',
        quantityActiveAgreements: 'Ilość aktywnych umów wynosi: ',
        quantityActiveStudents: 'Ilość aktywnych uczniów wynosi: ',
        total: 'Razem',
        totalSums: 'Razem dla wybranych filtrów',
        accountNumber: 'Numer konta do wpłat',
        discount: 'Rabat',
        addDiscount: 'Dodaj rabat',
        discountDescription: 'Opis rabatu',
        togglePriceNetto: 'Zmieniaj cenę netto',
        togglePriceBrutto: 'Zmieniaj cenę brutto',
        gtu: 'Kod GTU',
        pkwiu: 'Kod PKWiU',
        invoiceNotAccepted: 'Faktura niezaakceptowana',
        buyer: 'Kupujący',
        seller: 'Sprzedający',
        salesInvoice: 'Faktura sprzedażowa',
        purchaseInvoice: 'Faktura zakupowa',
        documentType: 'Rodzaj faktury',
        saveNewInvoicePosition: `Zapisz nową pozycję`,
        buyerData: `Dane kupującego`,
        sellerData: `Dane sprzedającego`,
        invoiceType: `Typ faktury`,
        number: `Numer`,
        batchNumber: `Seria numeracji`,
        ownNumber: 'Numer własny',
        receiverEMail: 'E-mail odbiorcy',
        issueDate: `Data wystawienia`,
        issuePlace: `Miejsce wystawienia`,
        sellDate: `Data sprzedaży`,
        firm: `Firma`,
        sellerNip: `NIP`,
        sellerName: `Nazwa`,
        sellerStreet: `Ulica`,
        sellerStreetNumber: 'Numer budynku',
        sellerPlaceNumber: 'Numer lokalu',
        sellerCity: `Miasto`,
        sellerPostcode: `Kod pocztowy`,
        buyerNip: `NIP`,
        buyerName: `Nazwa`,
        buyerStreet: `Ulica`,
        buyerStreetNumber: 'Numer budynku',
        buyerPlaceNumber: 'Numer lokalu',
        buyerCity: `Miasto`,
        buyerPostcode: `Kod pocztowy`,
        invoiceStatus: `Status`,
        toPay: `Do zapłaty (zł)`,
        paid: `Zapłacono (zł)`,
        paymentWay: `Sposób płatności`,
        paymentDeadline: `Termin płatności`,
        savePositions: `Zapisz nowe pozycje`,
        addNewInvoicePosition: `Dodaj nową pozycję`,
        copyPrice: 'Kopiuj ceny',
        invoicePositionHeaders: {
          lp: `Lp.`,
          item: `Towar/usługa`,
          additionalItem: 'Dodatkowy towar/usługa',
          measure: `Jednostka`,
          quantity: `Ilość`,
          priceNettoPerUnit: `Cena jednostkowa netto`,
          valueNetto: `Wartość sprzedaży netto`,
          vatRate: `Stawka VAT`,
          priceBruttoPerUnit: `Cena brutto`,
          valueBrutto: `Wartość sprzedaży brutto`,
          vatAmount: `Wartość VAT`,
          promotionDifference: 'Różnica ceny promocyjnej',
          promotion: 'Promocja',
          hasPriceGroup: 'Rozliczaj jako grupę usług z zakresem cen określonym w danym towarze'
        },
        noReceiverEmailOne: 'Brak określonego',
        noReceiverEmailTwo: 'adresu e-mail',
        noReceiverEmailThree: 'odbiorcy faktury',
        gtuOptions: {
          GTU_01: 'sprzedaż alkoholu - kod GTU 1',
          GTU_02: 'handel paliwem - kod GTU 2',
          GTU_03: 'sprzedaż oleju opałowego i olejów smarowych - kod GTU 3',
          GTU_04: 'wyroby tytoniowe - kod GTU 4',
          GTU_05: 'handel odpadami, surowcami wtórnymi itp. - kod GTU 5',
          GTU_06: 'urządzenia elektroniczne - kod GTU 6',
          GTU_07: 'sprzedaż pojazdów i części - kod GTU 7',
          GTU_08: 'wyroby z metali szlachetnych i nieszlachetnych, jubilerskie - kod GTU 8',
          GTU_09: 'handel lekami - kod GTU 9',
          GTU_10: 'budynki i budowle - kod GTU 10',
          GTU_11: 'usługi w zakresie przenoszenia uprawnień do emisji gazów cieplarnianych - kod GTU 11',
          GTU_12: 'usługi o charakterze niematerialnym , m.in. doradcze, księgowe, prawne, zarządcze, szkoleniowe, marketingowe, firm centralnych (head offices), reklamowe, badania rynku i opinii publicznej, w zakresie badań naukowych i prac rozwojowych. - kod GTU 12',
          GTU_13: 'usługi transportowe i gospodarki magazynowej - kod GTU 13'
        },
        vatSum: `Zestawienie VAT`,
        comments: `Komentarze`,
        correctionComment: 'Powód korekty',
        idUserData: 'Odbiorca faktury (e-mail)',
        idUserDataTooltip: 'Wskaż osobę na której adres e-mail zostanie wysłana faktura w przypadku wysyłki faktury',
        idUserDataEmail: 'Faktura zostanie wysłana następującym użytkownikom',
        invoiceValue: 'wartość faktury',
        corOf: 'korekta fak. nr',
        corection: 'korekta',
        noBatchNumber: 'nieprzypisana',
        buyerDataModalHeader: 'Szybkie uzupełnianie danych kupującego',
        buyerUserData: 'Osoba fizyczna / organizacja',
        setBuyerData: 'wybierz odbiorcę faktury',
        sendSelectedInvoices: 'Wyślij zaznaczone faktury na adresy odbiorców',
        sendInvoice: 'Wyślij fakturę na adresy odbiorców',
        pdfSelectedInvoices: 'Wygeneruj zaznaczone faktury w formacie PDF',
        zipSelectedInvoices: 'Wygeneruj zaznaczone faktury i spakuj do ZIP',
        fa3SelectedInvoices: 'Wygeneruj zaznaczone faktury w formacie FA (3)',
        sendSelectedInvoicesToKSeF: 'Wyślij zaznaczone faktury do KSeF i na adresy odbiorców',
        sendSelectedInvoicesToKSeFOnlyMessage: 'Wyślij ponownie zaznaczone faktury KSeF na adresy odbiorców',
        sentDate: 'Termin wysyłki wiadomości (pozostaw puste, aby wysłać natychmiast)',
        idAgreementInfo: 'Znaleziono umowy przypisane do wybranego kontrahenta. Przy dodawaniu faktury powinieneś wybrać umowę, której dotyczy niniejsza faktura'
      },
      show: {
        menageData: `Edytuj dane faktury`,
        menagePositions: `Zarządzaj pozycjami`,
        title: `Faktura`,
        buyerData: `Dane kupującego`,
        sellerData: `Dane sprzedającego`,
        invoiceType: `Typ faktury`,
        number: `Numer`,
        batchNumber: `Seria numeracji`,
        issueDate: `Data wystawienia`,
        issuePlace: `Miejsce wystawienia`,
        sellDate: `Data sprzedaży`,
        firm: `Firma`,
        sellerNip: `NIP`,
        sellerName: `Nazwa`,
        sellerStreet: `Ulica`,
        sellerCity: `Miasto`,
        sellerPostcode: `Kod pocztowy`,
        buyerNip: `NIP`,
        buyerName: `Nazwa`,
        buyerStreet: `Ulica`,
        buyerCity: `Miasto`,
        buyerPostcode: `Kod pocztowy`,
        invoiceStatus: `Status`,
        toPay: `Do zapłaty`,
        paid: `Zapłacono`,
        paymentWay: `Sposób płatności`,
        paymentDeadline: `Termin płatności`,
        addNewInvoicePosition: `Dodaj nową pozycję`,
        invoicePositionHeaders: {
          lp: `Lp.`,
          item: `Towar/usługa`,
          measure: `Jednostka`,
          quantity: `Ilość`,
          priceNettoPerUnit: `Cena netto`,
          valueNetto: `Wartość netto`,
          vatRate: `Stawka VAT`,
          priceBruttoPerUnit: `Cena brutto`,
          valueBrutto: `Wartość brutto`,
          vatAmount: `Wartość VAT`
        },
        vatSum: `Suma`,
        comments: `Komentarze`
      },
      invoicePositionEditModal: {
        header: `Zarządzanie pozycjami faktury`
      },
      invoiceDataEditModal: {
        header: `Edycja danych faktury`
      },
      modal: {
        modalHeader: 'Generowanie faktury',
        acceptThoseInvoices: 'zaakceptuj tworzoną fakturę i nadaj jej numer',
        prepareMailWithInvoice: 'utwórz maila dla tworzonej faktury',
        sendToKSeF: 'wyślij zaznaczone faktury do KSeF'
      }
    },
    exsbvindicationevents: {
      index: {
        showall: `Zaległości faktur`,
        showSummaryData: `Dane sumaryczne`,
        sumCashDebt: `Wybrane zaległości`,
        sumAgreementsDebt: `Wybrane umowy z zaległościami`,
        sumInvoicesDebt: `Wybrane faktury z zaległościami`,
        totalCashDebt: `Wszystkie zaległości`,
        totalAgreementsDebt: `Wszystkie umowy z zaległościami`,
        vindicationEvents: `Zdarzenia windykacyjne`,
        vindicationMessages: `Wiadomości windykacyjne`,
        youSelectAgreements: `Zaznaczone umowy z zaległościami`,
        vindicateModalTitle: `Wysłanie wiadomości do umowy z zaległościami oraz dodanie zdarzenia windykacyjnego`,
        eventType: `Rodzaj zdarzenia`,
        eventTypeOne: `Wiadomość e-mail`,
        eventTypeTwo: `Wiadomość SMS`,
        eventDate: 'Data zdarzenia',
        eventBalanceValue: `Zaległość na dzień zdarzenia`,
        generateVindicationEventsFromPeriodicMessages: `Wygeneruj zdarzenia i wiadomości windykacyjne na dziś na podstawie wiadomości okresowych`
      }
    },
    exsbwarehouses: {
      list: {
        title: `Magazyny`,
        type: `Typ`,
        name: `Nazwa`,
        idCustom: `Identyfikator`,
        noWarehouses: `Brak wprowadzonych magazynów`
      },
      create: {
        title: `Utwórz magazyn`
      },
      update: {
        title: `Edytuj magazyn`
      },
      form: {
        type: `Typ`,
        name: `Nazwa`,
        idCustom: `Identyfikator`
      },
      show: {
        title: `Magazyn`,
        type: `Typ`,
        idCustom: `Identyfikator`,
        name: `Nazwa`,
        documents: 'Dokumenty związane z magazynem',
        itemsStates: `Towary/usługi w magazynie`,
        itemsStatesTable: {
          item: `Towar/usługa`,
          quantity: `Ilość`
        }
      }
    },
    exsbmeasures: {
      list: {
        title: `Jednostki`,
        name: `nazwa`,
        noMeasures: `Brak wprowadzonych jednostek`
      },
      create: {
        title: `Utwórz jednostkę`,
        name: `Nazwa`
      },
      update: {
        title: `Edytuj jednostkę`
      }
    },
    exsbitems: {
      list: {
        title: `Towary/usługi`,
        itemType: `Typ`,
        name: `Nazwa`,
        vatRate: `VAT`,
        measure: `Jednostka`,
        category: `Kategoria`,
        brand: 'Producent',
        priceBrutto: `Cena brutto`,
        priceNetto: `Cena netto`,
        basePrice: 'Wartość usługi w umowie',
        customPrice: 'Rzeczywista wartość usługi w umowie',
        advantageValue: 'Wartość korzyści dla klienta',
        noItems: `Brak dodanych towarów/usług`,
        titleAdditional: 'Dodatkowe towary/usługi',
        promotion: 'Promocje'
      },
      create: {
        title: `Utwórz towar/usługę`
      },
      update: {
        title: `Edycja towaru/usługi`
      },
      form: {
        basicParameters: 'Parametry podstawowe',
        advancedParameters: 'Parametry zaawansowane',
        isCyclic: 'Może być cykliczne/cykliczna',
        joinWithPreviousItemFromPriceGroup: 'Przy przekroczeniu zakresu, cenę tej usługi potraktuj jak cenę jednostkową i zsumuj z poprzednią.',
        treatQuantityAsSingleFromPriceGroup: 'Przy wystawianiu faktury potraktuj liczbę sztuk towaru jako pojedynczą',
        purchasePriceNetto: 'Cena zakupu netto',
        itemType: `Typ`,
        name: `Nazwa`,
        category: `Kategoria`,
        brand: 'Producent',
        measure: `Jednostka`,
        receiptName: `Identyfikator`,
        catalogNumber: `Numer katalogowy`,
        vatRate: `Stawka VAT`,
        priceNetto: `Cena netto`,
        priceBrutto: `Cena brutto`,
        warningAvailability: 'Ostrzegawczy stan magazynowy',
        minimumAvailability: 'Krytyczny stan magazynowy',
        weight: 'Waga',
        width: 'Szerokość',
        height: 'Wysokość',
        color: 'Kolor',
        tags: 'Tagi towaru',
        advantage: 'Korzyść',
        rangeFrom: 'Zakres od',
        rangeTo: 'Zakres do',
        customSymbol: 'Symbol usługi',
        priceGroup: 'Grupa cen usługi'
      },
      show: {
        title: `Towar/usługa`,
        name: `Nazwa`,
        itemType: `Typ`,
        measure: `Jednostka miary`,
        category: `Kategoria`,
        priceNetto: `Cena netto`,
        vatRate: `Stawka VAT`,
        priceBrutto: `Cena brutto`,
        documents: 'Dokumenty związane z towarem',
        warehouseStates: `Stany magazynowe towaru`,
        warehouseStatesTable: {
          quantity: `Ilość`,
          warehouse: `Magazyn`
        },
        itemPictures: 'Zdjęcia towaru',
        isMainPicture: 'Domyślne zdjęcie'
      }
    },
    exsbitembrand: {
      list: {
        brandTitle: `Nazwa producenta`,
        noBrands: `Brak wprowadzonych producentów towarów`
      },
      create: {
        title: `Utwórz producenta towarów`
      },
      update: {
        title: `Edytuj producenta towarów`
      },
      form: {
        title: `Nazwa`
      }
    },
    exsbitemscategories: {
      list: {
        title: `Kategorie towarów/usług`,
        noItemsCategories: `Brak wprowadzonych kategorii towarów/usług`,
        name: `Nazwa`,
        description: `Opis`
      },
      create: {
        title: `Utwórz kategorię towarów/usług`
      },
      form: {
        name: `Nazwa`,
        description: `Opis`,
        customSymbol: 'Symbol kategorii'
      },
      show: {
        title: `Kategoria towarów/usług`,
        name: `Nazwa`,
        description: `Opis`
      }
    },
    exsbdocument: {
      list: {
        invoiceNumber: 'Numer faktury',
        dateOfIssueFrom: 'Data wystwienia od',
        dateOfIssueTo: 'Data wystawienia do',
        title: `Dokumenty magazynowe`,
        noDocuments: `Brak wprowadzonych dokumentów magazynowych`,
        documentType: `Typ`,
        number: `Numer`,
        dateOfIssue: `Data wystawienia`
      },
      create: {
        title: `Utwórz nowy dokument`
      },
      form: {
        defaultExtensions: '.jpg, .jpeg, .png, .gif, .pdf, .doc, .docx, .txt, .odt, .ods, .odp',
        allowedExtensions: 'Dozwolone formaty',
        allowedExtensionsForm: 'Dozwolone typy: gdy puste to domyślnie .jpg, .jpeg, .png, .gif, .pdf, .doc, .docx, .txt, .odt, .ods, .odp',
        allowedMaxSize: 'Maksymalny rozmiar przesyłanego pliku',
        addNewFilePosition: 'Dodaj nowy dokument',
        receiverData: 'Dane odbiorcy',
        exhibitorData: 'Dane wystawcy',
        receiver: 'Odbiorca',
        exhibitor: 'Wystawca',
        exhibitorNip: 'NIP',
        exhibitorStreet: 'Ulica',
        exhibitorCity: 'Miasto',
        exhibitorPostcode: 'Kod pocztowy',
        documentType: `Typ dokumentu`,
        batchNumber: `Seria numeracji`,
        number: `Numer`,
        dateOfIssue: `Data wystawienia`,
        placeOfIssue: 'Miejsce wystawienia',
        delivery: `Sposób dostawy`,
        receiverNip: `NIP`,
        receiverStreet: `Ulica`,
        receiverPostcode: `Kod pocztowy`,
        receiverCity: `Miasto`,
        protocolPeriodStart: `Początek okresu`,
        protocolPeriodEnd: `Koniec okresu`,
        comments: `Komentarze`,
        addNewPosition: `Dodaj pozycję magazynową`,
        addNewPositionTooltip: `Wybierz typ dokumentu zanim zaczniesz dodawać pozycje magazynowe`,
        positions: {
          item: `Towar/usługa`,
          warehouse: `Magazyn`,
          warehouseQuantity: `Stan magazynowy`,
          newWarehouse: `Nowy magazyn`,
          newWarehouseQuantity: `Stan magazynowy`,
          quantity: `Ilość`,
          discount: `Rabat`,
          discountTooltip: `%`,
          pricePerUnitNetto: `Cena netto`,
          pricePerUnitBrutto: `Cena brutto`,
          vatRate: `Stawka VAT`,
          valueNetto: `Wartość netto`,
          valueBrutto: `Wartość brutto`,
          reason: `Powód`,
          reasonComment: `Komentarz do powodu`
        }
      },
      show: {
        delivery: `Sposób dostawy`,
        title: `Dokument`,
        documentType: `Typ`,
        number: `Numer`,
        relatedNumber: `Powiązany numer`,
        valueNetto: `Wartość netto`,
        valueBrutto: `Wartość brutto`,
        dateOfIssue: `Data wystawienia`,
        placeOfIssue: `Miejsce wystawienia`,
        receiver: 'Odbiorca',
        receiverNip: `NIP`,
        receiverStreet: `Ulica`,
        receiverCity: `Miasto`,
        receiverPostcode: `Kod pocztowy`,
        receiverData: `Dane odbiorcy`,
        exhibitorData: 'Dane wystawcy',
        exhibitor: 'Wystawca',
        exhibitorNip: 'NIP',
        exhibitorStreet: 'Ulica',
        exhibitorCity: 'Miasto',
        exhibitorPostcode: 'Kod pocztowy',
        documentPositions: `Pozycje magazynowe`,
        documentPosition: {
          item: `Towar/usługa`,
          quantity: `Ilość`,
          measure: `Jm.`,
          warehouse: `Magazyn`,
          newWarehouse: `Nowy mag.`,
          discount: `Rabat`,
          pricePerUnitNetto: `Cena netto`,
          pricePerUnitBrutto: `Cena brutto`,
          vatRate: `Stawka VAT`,
          lp: `Lp.`
        },
        comments: `Komentarz`,
        protocolPeriod: `Okres protokołu`
      }
    },
    exsbdelivery: {
      list: {
        title: `Sposoby dostaw`,
        noDeliveries: `Brak wprowadzonych sposobów dostawy`,
        name: `Nazwa`
      },
      create: {
        title: `Utwórz sposób dostawy`
      },
      form: {
        name: `Nazwa`
      },
      show: {
        title: `Sposób dostawy`,
        name: `Nazwa`
      },
      update: {
        title: `Edycja sposobu dostawy`
      }
    },
    exsbbatchnumber: {
      list: {
        title: `Serie numeracji`,
        noBatchNumbers: `Brak wprowadzonych serii numeracji`,
        name: `Nazwa`,
        periodType: `Okres czasu`
      },
      create: {
        title: `Utwórz serię numeracji`
      },
      update: {
        title: `Edycja serii numeracji`
      },
      form: {
        documentsAllowedDocuments: `Numery dla dokumentów`,
        documentsAllowedInvoices: `Numery dla faktur`,
        documentsAllowedCases: `Numery dla zleceń`,
        name: `Nazwa`,
        pattern: `Wzór`,
        firstNumber: `Pierwszy numer`,
        periodType: `Typ okresu`,
        documentsAllowed: `Typ dokumentu`,
        agreementsAllowed: 'Umowa',
        instruction: {
          lineOne: `Dla rocznego typu okresu należy wprowadzić wzór zawierający numer (%N) oraz rok (%Y), np.: %N/%Y.`,
          lineTwo: `Dla miesięcznego typu okresu należy wprowadzić wzór zawierający numer (%N), miesiąc (%M) oraz rok (%Y), np.: %N/%M/%Y.`,
          lineThree: `W przypadku obu wzorów działanie jest takie samo. Można tworzyć różne kombinacje, a program będzie wstawiał numer, miesiąc i rok w odpowiednie miejsce.`,
          lineFour: `Przykładowe wzory:`,
          lineFifth: `Legenda:`,
          firstMenu: {
            firstPosition: `%Y/%M/%N, w wyniku czego powstanie np.: \`2018/04/1\``,
            secondPosition: `%Y-%m-%N, w wyniku czego powstanie np.: \`2018-4-1\``,
            thirdPosition: `%N/%M/%y, w wyniku czego powstanie np.: \`1/4/18\``,
            fourthPosition: `Rok: %Y, Miesiąc: %M, Numer: %N, w wyniku czego powstanie np.: \`Rok: 2018, Miesiąc: 04, Numer: 1\``
          },
          secondMenu: {
            firstPosition: `%Y - wpisuje rok w pełnym formacie, np. 2018`,
            secondPosition: `%y - wpisuje rok w niepełnym formacie, np. 18`,
            thirdPosition: `%M - wpisuje numer miesiąca dopisując 0 z przodu w przypadku miesięcy których numer jest jednocyfrowy, np. 04`,
            fourthPosition: `%m - wpisuje numer miesiąca, np. 4`,
            fifthPosition: `%N - wpisuje numer dokumentu począwszy od wprowadzonej liczby pierwszej, który będzie rósł równolegle z liczbą dokumentów w danym miesiącu lub roku`
          }
        }
      },
      show: {
        title: `Seria numeracji`,
        name: `Nazwa`,
        pattern: `Wzór`,
        firstNumber: `Pierwszy numer`,
        periodType: `Okres czasu`,
        documentsAllowed: `Typy dokumentów`
      }
    },
    excmcalllog: {
      list: {
        noItems: 'Brak telefonów w rejestrze',
        callDateTime: 'Data i godzina połączenia',
        phoneNumber: 'Numer telefonu',
        description: 'Opis',
        callDirection: 'Kierunek',
        callDirectionOutbound: 'Wychodzące',
        callDirectionInbound: 'Przychodzące',
        answered: 'Odebrano',
        duration: 'Czas rozmowy',
        idHandlingUserData: 'Osoba obsługująca',
        idRelatedUserData: 'Osoba obsługiwana',
        setRelatedUserData: 'Ustaw osobę obsługiwaną',
        createPhoneRelation: 'Utwórz relację z telefonem',
        setDescription: 'Ustaw opis'
      },
      lastMonthReport: {
        durationSum: 'Całkowity czas'
      }
    },
    excmchatbot: {
      list: {
        createdAt: 'Utworzono',
        idContractor: 'Kontrahent',
        emails: 'Korespondent',
        messageQuantity: 'Liczba wiadomości',
        lastMessageDate: 'Data ostatniej wiadomości',
        messageDateTime: 'Data i godzina początku rozmowy',
        noItems: 'Brak rozmów',
        subject: 'Podsumowanie rozmowy'
      },
      show: {
        messages: 'Wiadomości',
        isChatbotMessage: 'Chatbot'
      }
    },
    excmcorrespondence: {
      list: {
        noItems: 'Brak korespondencji',
        messageDateTime: 'Data i godzina początku wątku',
        idContractor: 'Powiązany kontrahent',
        subject: 'Temat',
        messageQuantity: 'Liczba wiadomości',
        lastMessageDate: 'Data ostatniej wiadomości',
        setContractor: 'Ustaw kontrahenta w korespondencji',
        relatedCases: 'Powiązane zlecenia',
        emails: 'Korespondenci'
      },
      show: {
        messages: 'Wiadomości',
        noContractor: `Aby dodać ${lang.menu.cases.create} należy najpierw określić powiązanego kontrahenta`,
        contractorIsNotCompany: `Aby dodać ${lang.menu.cases.create} należy najpierw określić powiązanego kontrahenta, który jest firmą, a nie osobą. ${lang.menu.cases.index} można dodawać tylko do firm`
      }
    },
    excmcase: {
      list: {
        noDeadlineDate: 'Brak terminu realizacji',
        id: 'ID',
        noCases: `Brak wprowadzonych ${lang.menu.casetypes.list}`,
        cyclicTask: `Zgłoszenie cykliczne`,
        createMultipleTasks: 'Utwórz zadania masowo do zaznaczonych zleceń',
        takeMultipleTasks: `Pobierz masowo zadania ze zleceń do swojej puli`,
        title: lang.menu.cases.index,
        titleClosed: `${lang.menu.cases.index} zamknięte`,
        titleOpened: `${lang.menu.cases.index} otwarte`,
        noTasks: `Brak zadań`,
        searchParams: {
          status: `Status`,
          statusPlaceholder: `Wybierz status`,
          highPriority: `Pilne`,
          activeOnly: `Tylko aktywne`,
          inactiveOnly: `Tylko nieaktywne`,
          disableRolesFiltering: 'Pokaż zlecenia wszystkich',
          firm: `Firma`,
          firmPlaceholder: `Nazwa firmy z umowy`,
          contractor: `Kontrahent`,
          agreement: `Umowa`,
          agreementPlaceholder: `Umowa`,
          city: `Miasto`,
          cityPlaceholder: `Wybierz miasto`,
          street: `Ulica`,
          streetPlaceholder: `Wprowadź ulicę`,
          deviceType: `Typ urządzenia`,
          deviceTypePlaceholder: `Wybierz typ urządzenia`,
          device: `Urządzenie`,
          devicePlaceholder: `Wprowadź nazwę urządzenia`,
          serialNumber: `Numer seryjny`,
          serialNumberPlaceholder: `Wprowadź numer seryjny urządzenia`,
          id: `Numer ${lang.menu.cases.list}`,
          idPlaceholder: `Wprowadź numer ${lang.menu.cases.list}`,
          description: `Opis ${lang.menu.cases.list}`,
          descriptionPlaceholder: `Wprowadź opis ${lang.menu.cases.list}`,
          filterTaskByCustomField: 'Pola własne w zadaniach',
          filterCaseByCustomField: 'Pola własne w zgłoszeniach',
          keyUserData: `Kluczowy wykonawca`,
          keyTask: `Kluczowe zadanie`
        }
      },
      create: {
        title: `Utwórz nowe ${lang.menu.cases.create}`,
        titleToMessage: `Utwórz nowe ${lang.menu.cases.create} dotyczące wiadomości korespondencyjnej`
      },
      show: {
        currentTask: `Bieżące zadanie`,
        keyTask: `Kluczowe zadanie`,
        deadline: `Termin`,
        createdByUserData: `Przez`,
        caseDetails: `Szczegóły ${lang.menu.cases.list}`,
        suggestedSolutions: `Sugerowane rozwiązania`,
        implementationAndSettlement: `Realizacja i rozliczenie`,
        caseCreated: `Utworzenie ${lang.menu.cases.list}`,
        caseClosed: `Zamknięcie ${lang.menu.cases.list}`,
        title: `Zgłoszenie`,
        created: `Utworzono`,
        finished: `Ukończono`,
        device: `Urządzenie`,
        urgent: `Pilne`,
        closeTask: `Zamknij zadanie`,
        goToDevice: `Przejdź do urządzenia`,
        categorization: `Kategoryzacja`,
        categorizationDescription: `Obszary i kategorie problemów`,
        addCaseProblemToCaseModal: `Dodawanie kategorii`,
        addNoteToCaseModal: `Dodawanie notatki`,
        timeline: `Timeline`,
        notes: `Notatki`,
        verificationAndAcceptation: `Weryfikacja i akceptacja`,
        relatedCases: `Powiązane zadania`,
        phone: 'Telefon',
        mobilePhone: 'Telefon komórkowy'
      },
      update: {
        title: `Edycja ${lang.menu.cases.list}`
      },
      form: {
        ticket: `${lang.menu.cases.show} z zewnętrznej aplikacji`,
        sla: `SLA`,
        idPriority: `Priorytet`,
        caseTags: `Tagi`,
        addNewCaseTags: `Dodaj nowy tag`,
        caseGenre: `Rodzaj`,
        title: `Tytuł`,
        description: `Opis ${lang.menu.cases.list}`,
        deadlineDate: `Termin realizacji ${lang.menu.cases.list}`,
        status: `Status`,
        caseType: `Typ`,
        ownerUserData: `Utworzone przez`,
        substitutionUserData: `Zastępca`,
        partnerUserData: `Partner handlowy`,
        contractorUserData: `Kontrahent`,
        idDevice: `Urządzenie`,
        idDeviceSearch: `Wyszukaj urządzenie po numerze seryjnym`,
        agreement: `Umowa`,
        agreementSearch: `Wyszukaj umowę po numerze`,
        onlyToDevice: 'Wybierz urządzenie do zlecenia bez wybierania umowy',
        keyTaskTypes: 'Kluczowe zadania',
        keyRoles: 'Kluczowe role'
      }
    },
    excmcaseproblem: {
      list: {
        category: `Kategoria`,
        problem: `Problem`
      },
      form: {
        idProblem: `Problem`
      }
    },
    excmcasetype: {
      list: {
        noCaseType: `Brak wprowadzonych typów zgłoszeń`,
        title: `Typy zgłoszeń`,
        table: {
          title: `Typ ${lang.menu.cases.list}`,
          options: `Opcje`
        }
      },
      create: {
        title: `Utwórz nowy typ ${lang.menu.cases.list}`,
        titleRoles: `Konfiguracja uprawnień typu ${lang.menu.cases.list}`
      },
      show: {
        header: `Dane typu ${lang.menu.cases.list}`,
        title: `Tytuł`,
        subtitle: `Podtytuł`,
        defaultTask: `Domyślne pierwsze zadanie`,
        accessCaseParams: `Dostęp do elementów z kartoteki Pozycje`,
        emailEnable: `Powiadomienie mailowe o nowym zgłoszeniu`,
        emailTitle: `Tytuł maila powiadomienia`,
        emailContent: `Zawartość maila powiadomienia`,
        specialString: `Łańcuch specjalny`,
        customFields: `Pola własne`,
        addNewCustomField: `Dodaj nowe pole własne`,
        noCustomFields: `Brak pól własnych`
      },
      update: {
        title: `Edycja typu ${lang.menu.cases.list}`
      },
      form: {
        title: `Tytuł`,
        subtitle: `Podtytuł`,
        defaultTask: `Domyślne pierwsze zadanie`,
        accessCaseParams: `Dostęp do elementów z kartoteki Pozycje`,
        emailEnable: `Powiadomienie mailowe o nowym zgłoszeniu`,
        emailTitle: `Tytuł maila powiadomienia`,
        emailContent: `Zawartość maila powiadomienia`,
        specialString: `Łańcuch specjalny`,
        addNewField: `Dodaj pole własne`,
        customFields: `Pola własne`,
        customField: {
          fieldName: `Nazwa`,
          fieldType: `Typ`,
          fieldDefaultValue: `Wartość domyślna`,
          fieldLabel: `Nagłówek`,
          fieldDescription: `Opis/tooltip`,
          fieldRequired: `Wymagane`,
          fieldReadonly: `Tylko do odczytu`,
          onlyNumbersAllowed: 'Dopuszczalne tylko wartości numeryczne',
          allowedDaysAhead: 'Minimalna ilość dni w przód od daty utworzenia zlecenia',
          allowedDaysBack: 'Minimalna ilość dni w tył od daty utworzenia zlecenia',
          minValue: 'Minimalna wartość',
          maxValue: 'Maksymalna wartość',
          addNewCustomFieldValue: `Dodaj nową wartość do listy`,
          disabledRoles: 'Role, dla których to pole ma być ukryte',
          idUserDataClientTypes: `Role użytkowników, które mają się wyświetlać w tym polu`,
          showInTable: 'Pokaż wartość pola w tabeli',
          customFieldValue: {
            value: `Wartość`,
            defaultValue: `Wartość domyślna`
          }
        },
        enableNotes: `Notatki`,
        enableCategorization: `Kategoryzacja problemów`,
        enableTimeline: `Oś czasu`,
        enableTicket: `${lang.menu.cases.show} z zewnętrznej aplikacji`,
        enableDevice: `Urzadzenie`,
        enableAgreement: `Umowa`,
        enableSLA: `SLA`,
        enableClient: `Kontrahent`,
        enablePartner: 'Partner handlowy'
      }
    },
    excmcontractor: {
      list: {
        title: `Kontrahenci`
      },
      create: {
        title: `Utwórz nowego kontrahenta`
      },
      show: {
        title: `Kontrahent`
      },
      update: {
        title: `Edycja kontrahenta`
      }
    },
    excmdevice: {
      list: {
        title: `Urządzenia`,
        noDevices: `Brak wprowadzonych urządzeń`,
        filters: {
          serialNumber: `Numer seryjny`,
          idDeviceBrand: `Marka urządzenia`,
          idDeviceType: `Typ urządzenia`
        }
      },
      create: {
        title: `Dodaj nowe urządzenie`
      },
      show: {
        downloadPDF: `Pobierz PDF`,
        id: `Id`,
        type: `Typ`,
        brand: `Producent`,
        model: `Model`,
        serialNumber: `Numer seryjny`,
        title: `Urządzenie`,
        deviceState: `Stan urządzenia`,
        deviceActive: `Status`,
        counterBlack: `Licznik mono`,
        counterColor: `Licznik kolor`,
        active: `Urządzenie aktywne`,
        notActive: `Urządzenie nieaktywne`,
        deviceCreated: `Dodanie urządzenia do bazy`,
        created: `Utworzono`,
        localization: `Lokalizacja`,
        displayDeviceStatesModal: `Historia stanów`,
        deviceStateCreatedAt: `Data odczytu stanu`,
        clientSection: {
          deviceAgreement: {
            title: `Umowy związane z urządzeniem`,
            number: `Numer`,
            dateFrom: `Obowiązuje od`,
            dateTo: `Obowiązuje do`,
            moveToAgreement: `Przejdź do umowy`
          },
          noPeripheralDevices: 'Brak urządzeń peryferyjnych',
          peripheralDevice: 'Urządzenie peryferyjne'
        }
      },
      update: {
        title: `Edycja urządzenia`
      },
      form: {
        addNewDeviceModel: `Dodaj nowy model urządzenia`,
        idDeviceModel: `Model urządzenia`,
        serialNumber: `Numer seryjny`,
        street: `Ulica`,
        city: `Miasto`,
        postcode: `Kod pocztowy`,
        room: `Pokój`,
        building: `Budynek`,
        floor: `Piętro`,
        longitude: `Długość geograficzna`,
        latitude: `Szerokość geograficzna`,
        addressNotTheSameInfo: 'Adres określony u kontrahenta i w urządzeniu różnią się. Jeśli chcesz, możesz wypełnić adres w urządzeniu korzystając z przycisku po prawej stronie',
        fillAddressFromContractor: 'Wypełnij adres urządzenia danymi kontrahenta'
      }
    },
    excmdevicebrand: {
      list: {
        title: `Producenci urządzeń`,
        noBrands: `Brak wprowadzonych producentów`,
        brandTitle: `Producent`
      },
      create: {
        title: `Dodaj nowego producenta urządzeń`
      },
      update: {
        title: `Edycja producenta urządzeń`
      },
      form: {
        title: `Producent`
      }
    },
    excmdevicemodel: {
      list: {
        title: `Modele urządzeń`,
        model: `Model`,
        noDeviceModel: `Brak wprowadzonych modeli urządzeń`,
        deviceBrand: `Producent`,
        deviceType: `Typ urządzenia`,
        filters: {
          model: `Model`,
          idDeviceBrand: `Producent`,
          idDeviceType: `Typ urządzenia`
        }
      },
      create: {
        title: `Dodaj nowy model urządzenia`
      },
      update: {
        title: `Edycja modelu urządzenia`
      },
      form: {
        model: `Model`,
        idDeviceBrand: `Producent`,
        idDeviceType: `Typ urządzenia`,
        addNewDeviceBrand: `Dodaj nowego producenta`,
        addNewDeviceType: `Dodaj nowy typ urządzenia`
      },
      show: {
        devices: 'Urządzenia w systemie',
        documentFiles: 'Dokumenty dla tego modelu urządzenia'
      }
    },
    excmdeviceperipheral: {
      list: {
        title: `Urządzenia peryferyjne`,
        titleSingle: `Urządzenie`
      },
      create: {
        title: `Dodaj nowe urządzenie peryferyjne`
      },
      update: {
        title: `Edycja urządzenia peryferyjnego`
      },
      form: {
        title: `Urządzenie`,
        duplicates: `Znalezione duplikaty`
      }
    },
    excmdevicestate: {
      list: {
        title: `Stany urządzeń`,
        noexcmdevicestates: `Brak wprowadzonych stanów urządzeń`,
        brandTitle: `Producent`,
        table: {
          date: 'Data',
          time: 'Czas',
          totalCounter: 'Całkowity',
          monoCounter: 'Mono',
          colorCounter: 'Kolor',
          copy: 'Kopia',
          printout: 'Wydruk',
          a3: 'A3',
          a4: 'A4',
          monoA3: 'Mono A3',
          monoA4: 'Mono A4',
          colorA3: 'Kolor A3',
          colorA4: 'Kolor A4',
          bkToner: 'Toner BK',
          cToner: 'Toner C',
          mToner: 'Toner M',
          yToner: 'Toner Y',
          message: 'Pora na przegląd',
          notes: 'Notatki',
          plug: 'Wtyczka'
        }
      },
      create: {
        title: `Dodaj nowy stan`
      },
      update: {
        title: `Edycja stanu`
      },
      form: {
        title: `Stan`
      }
    },
    excmdevicetype: {
      list: {
        title: `Typy urządzeń`,
        titleSingle: `Typ urządzenia`
      },
      create: {
        title: `Dodaj nowy typ urządzenia`
      },
      update: {
        title: `Edycja typu urządzenia`
      },
      form: {
        title: `Typ urządzenia`,
        duplicates: `Znalezione duplikaty`
      }
    },
    excmnote: {
      list: {
        noNotes: `Brak wprowadzonych notatek`,
        title: `Notatki`,
        table: {
          title: `Notatka`,
          options: `Opcje`,
          goToCase: `Przejdź do ${lang.menu.cases.list}`
        },
        filters: {
          idCase: `${lang.menu.cases.index}`,
          title: `Tytuł`,
          state: `Zarchiwizowane`
        }
      },
      create: {
        title: `Utwórz nową notatkę`
      },
      show: {
        title: `Notatka`,
        created: `Utworzono`
      },
      update: {
        title: `Edycja notatki`
      },
      form: {
        contractorNote: 'Dodaj notatkę do kontrahenta',
        empty: `Brak`,
        title: `Tytuł notatki`,
        description: `Notatka`,
        idCase: `${lang.menu.cases.show}`,
        idUserData: `Firma`,
        idOrganizationLead: 'Lead sprzedażowy'
      }
    },
    excmtask: {
      list: {
        deadlineExceeded: 'Przekroczony czas realizacji',
        progress: 'Postęp',
        NoTask: `Brak wprowadzonych zadań`,
        takeMultipleTasks: `Pobierz masowo zadania do swojej puli`,
        title: `Zadania`,
        table: {
          task: `Zadanie`,
          state: `Stan`,
          createdAt: `Utworzono`
        },
        filters: {
          idTaskType: `Typ zadania`,
          finish: `Tylko skończone`,
          started: `Tylko rozpoczęte`,
          state: `Stan`,
          active: `Tylko aktywne`,
          archive: `Tylko zarchiwizowane`
        }
      },
      create: {
        title: `Utwórz nowe zadanie`
      },
      show: {
        deadlineDate: 'Przewidziana data realizacji',
        inProgress: 'W trakcie',
        plannedAt: `Zaplanowane na`,
        plannedBy: `do wykonania przez`,
        dailyPlanItem: `Zaplanowane wykonanie`,
        dailyPlanItemStatus: `Status wykonania`,
        dailyPlanItemStatuses: {
          held: `Wstrzymane`,
          moved: `Przesunięte`,
          started: 'Rozpoczęte',
          notOver: `Nieukończone`,
          finished: `Ukończone`
        },
        moveReason: `Powód przeniesienia`,
        holdReason: `Powód wstrzymania`,
        createTaskDocument: `Stwórz dokument WZ dla tego zadania`,
        generateTaskDocument: `Wygeneruj dokument z szablonu dla tego zadania`,
        addTaskToCaseModal: `Dodawanie zadania`,
        addMultipleTaskToCaseModal: `Masowe dodawanie zadania do zleceń`,
        infoAboutClosingTask: `Uwaga! Utworzenie zadania spowoduje zamknięcie poprzedniego, jeśli nie zostało zakończone.`,
        title: `Zadanie`,
        createTask: `Utworzenie zadania`,
        closeTask: `Zamknięcie zadania`,
        returnTask: `Oddanie zadania`,
        returnedTask: `Zadanie przeniesione do puli ogólnej`,
        takeTask: `Pobranie zadania`,
        transferTask: `Przekazanie zadania`,
        trasnferTaskToUser: `Przekazanie zadania do`
      },
      update: {
        title: `Edycja zadania`
      },
      updateParams: {
        title: 'Edycja parametrów zadania'
      },
      form: {
        addToPool: 'Dodaj zadanie do puli ogólnej',
        finished: `Zakończony`,
        finishDate: `Data zakończenia`,
        idFinishByUserData: `Zakończono przez`,
        idTaskType: `Typ zadania`,
        idCase: `${lang.menu.cases.show}`,
        idLastOperationTask: `Poprzednie zadanie`,
        addTaskWithoutFinishInfo: `Dodając zadanie bez zakończenia poprzedniego, należy pamiętać o tym, że wymogiem zamknięcia zlecenia będzie ręczne zamknięcie wszystkich zadań w nim zawartych.`
      }
    },
    excmtasktype: {
      list: {
        noTaskType: `Brak wprowadzonych typów zadań`,
        title: `Typy zadań`,
        table: {
          title: `Nazwa`,
          options: `Opcje`,
          duplicateQuestion: 'Czy na pewno chcesz utworzyć duplikat zadania'
        }
      },
      create: {
        title: `Utwórz nowy typ zadania`,
        titleRoles: `Konfiguracja uprawnień typu zadania`
      },
      show: {
        title: `Typ zadania`
      },
      update: {
        title: `Edycja typu zadania`
      },
      form: {
        hiddenCaseForRoles: 'Role dla których zlecenie z tym zadaniem ma być ukryte',
        autoDispatch: 'Automatycznie przypisz osobie tworzącej nowe zadanie',
        autoStartAfterTake: 'Pobranie zadania spowoduje jego automatyczne rozpoczęcie',
        canBeDailyPlanItem: 'Czy może być przypisane do planu dziennego',
        autoCloseCase: 'Ukończenie tego zadania spowoduje zamknięcie zlecenia',
        canHaveDocument: 'Czy można dołączyć załącznik',
        creatingTaskWillAskCustomerInTicket: `Utworzenie zadania spowoduje pytanie o szczegóły w zleceniu zewnętrznym`,
        cannotBeConcurrent: `Nie można utworzyć równolegle z innym zadaniem`,
        cost: `Koszt`,
        title: `Tytuł`,
        subtitle: `Podtytuł`,
        desc2tooltip: `Opis do tooltip`,
        duration: `Szacowany czas realizacji`,
        durationUnit: `Jednostka czasu`,
        groups: `Grupy`,
        notification: `Powiadomienie (dni)`,
        notificationEnable: `Powiadomienia`,
        notificationTitle: `Tytuł maila powiadomienia`,
        notificationContent: `Zawartość maila powiadomienia`,
        alarm: `Alarm (dni)`,
        alarmEnable: `Alarm`,
        alarmTitle: `Tytuł maila alarmu`,
        alarmContent: `Zawartość maila alarmu`,
        alarmNotFinishedEnable: `Alarm o przekroczonym terminie`,
        alarmNotFinishedTitle: `Tytuł maila alarmu o przekroczonym terminie`,
        alarmNotFinishedContent: `Zawartość maila alarmu o przekroczonym terminie`,
        idDefaultNextTask: `Domyślne następnie zadanie`,
        idCasesType: `Przypisanie do Typu ${lang.menu.cases.list}`,
        conditionsAdd: `Warunki rozpoczęcia zadania`,
        fieldReadonly: `Tylko do odczytu`,
        dfeCase: `Zakończenie blokuje edycję ${lang.menu.cases.list}`,
        dfeReason: `Powód blokady edycji`,
        runCustom: `Uruchom własną funkcję`,
        infoaboutnew: `Powiadomienie o zadaniu`,
        infoaboutnewContent: `Treść powiadomienia`,
        role: `Rola`,
        create: `Tworzenie`,
        read: `Podgląd`,
        read2: `Podgląd szczegółowy`,
        update: `Aktualizacja`,
        take: `Pobranie`,
        delete: `Usuwanie`,
        accessFirm: `Widoczność: tylko firmowe`,
        accessGroup: `Widoczność: tylko zespołu`,
        accessSelf: `Widoczność: tylko swoje`,
        accessAll: `Widoczność: wszystko`,
        defaultNextTask: `Domyślne kolejne zadanie`,
        color: 'Kolor zadania',
        actionTakenAfterDeadlineExceeded: 'Akcja po przekroczeniu planowanego terminu realizacji',
        actionTakenAfterDeadlineExceededOptions: {
          doNothing: 'Nic nie rób',
          closeTaskWithoutCreatingNew: 'Zamknij zadanie i nie twórz nowego',
          closeTaskWithDefaultNextTask: 'Zamknij zadanie i utwórz domyślne kolejne zadanie',
          closeTaskWithCustomNextTask: 'Zamknij zadanie i utwórz wybrane kolejne zadanie',
          doNotCloseTaskWithCustomNextTask: 'Nie zamykaj zadania i utwórz wybrane kolejne zadanie'
        },
        tasksToCreateAfterDeadlineExceeded: 'Zadania do utworzenia po przekroczeniu planowanego terminu realizacji',
        daysToCreateTaskAfterDeadlineExceeded: 'Liczba dni do utworzenia zadania po przekroczeniu planowanego terminu realizacji (0 - utwórz od razu)',
        poolTaskRecipientOptions: {
          returned: 'Umieść w puli ogólnej',
          regionCoordinator: 'Koordynator regionu zlecenia',
          currentUserData: `Osoba, która miała zadanie w puli`
        },
        poolTaskRecipient: 'Odbiorca nowych zadań tworzonych po przekroczeniu planowanego terminu realizacji',
        poolTaskRecipientDuringCreating: `Komu przydzielić zadanie podczas tworzenia`,
        poolTaskRecipientDuringCreatingOptions: {
          defaultAction: `Wybierz z listy albo dodaj do puli ogólnej (domyślnie)`,
          returned: `Nie, umieść w puli ogólnej`,
          currentUserData: `Tak, przypisz do osoby która tworzy`,
          previousPoolTask: `Przypisz poprzednikowi (jeżeli nie ma uprawnień, to umieść w puli ogólnej)`
        }
      }
    },
    downloaddata: {
      index: {
        info: 'Zaznacz, które dane chcesz pobrać dla raportu w formacie CSV (archiwum ZIP)',
        options: {
          excm_case: 'Zlecenia (excm_case)',
          excm_case_type: 'Typy zleceń (excm_case_type)',
          excm_custom_field: 'Pola własne (excm_custom_field)',
          excm_custom_field_value: 'Opcje pól własnych (excm_custom_field_value)',
          excm_dailyplanitem: 'Plan dzienny (excm_dailyplanitem)',
          excm_documentfile: 'Dokumenty zlecenia (excm_documentfile)',
          excm_message: 'Wiadomości (excm_message)',
          excm_message_contentemail: 'Treść wiadomości (excm_message_contentemail)',
          excm_note: 'Notatki (excm_note)',
          excm_notification_message: 'Notyfikacje (excm_notification_message)',
          excm_pool_tasks: 'Pula zadań (excm_pool_tasks)',
          excm_region: 'Regiony (excm_region)',
          excm_region_userdata: 'Przypisanie osób do regionów (excm_region_userdata)',
          excm_status: 'Statusy zleceń (excm_status)',
          excm_tag: 'Tagi (excm_tag)',
          excm_task: 'Zadania (excm_task)',
          excm_task_type: 'Typy zadań (excm_task_type)',
          excm_team: 'Zespoły (excm_team)',
          excm_team_userdata: 'Przypisanie osób do zespołów (excm_team_userdata)',
          exsb_item_type: 'Typy towarów (exsb_item_type)',
          exsb_items: 'Towary (exsb_items)',
          exsb_items_brand: 'Producenci towarów (exsb_items_brand)',
          exsb_measure: 'Jednostki miary (exsb_measure)',
          exsb_order: 'Zamówienia (exsb_order)',
          exsb_order_status: 'Statusy zamówień (exsb_order_status)',
          exsb_order_tag: 'Tagi zamówień(exsb_order_tag)',
          exsb_position: 'Pozycje w zamówieniach (exsb_position)',
          exsb_vat_rate: 'Stawki vat(exsb_vat_rate)',
          fos_user: 'Użytkownicy systemowi (fos_user)',
          fos_user_data: 'Osoby w systemie i firmy(fos_user_data)',
          fos_user_data_address: 'Adresy osób i firm (fos_user_data_address)',
          userdata_employee: 'Przypisanie osób do firm (userdata_employee)',
          client_type: 'Role użytkowników systemowych (client_type)',
          document_type: 'Typy dokumentów/załączników (document_type)'
        }
      }
    },
    surveys: {
      list: {
        noSurveys: `Brak ankiet`,
        sendSurveyToContractor: 'Wyślij ankietę do kontrahenta',
        sendSurveyDocumentsInfo: 'Następujące dokumenty zostaną wysłane jako załączniki do wiadomości z ankietą'
      },
      form: {
        idSurvey: `Wybierz test lub ankietę z systemu`,
        isPublicOption: `Dostępność w systemie`,
        isPublic: `Dla wszystkich`,
        isNotPublic: `Dla wybranych użytkowników`,
        isPublicSurveyInfo: `"Ankieta dla wybranych użytkowników" pojawi się tylko dla osób należących do grup, zajęć i osób określonych w kroku 3. Użytkownicy. Natomiast "Ankieta dostępna dla wszystkich" jest publiczna i będzie widoczna dla wszystkich ${lang.studentPluralAccusative} i rodziców/opiekunów w systemie eduSky. Należy pamiętać o tym, że aby móc wypełnić ankietę w systemie, użytkownik musi posiadać konto systemowe.`,
        isPublicTestInfo: `"Test dla wybranych użytkowników" pojawi się tylko dla osób należących do grup, zajęć i osób określonych w kroku 3. Użytkownicy. Natomiast "Test dostępny dla wszystkich" jest publiczny i będzie widoczny dla wszystkich ${lang.studentPluralAccusative} i rodziców/opiekunów w systemie eduSky. Należy pamiętać o tym, że aby móc wypełnić test w systemie, użytkownik musi posiadać konto systemowe.`,
        isExternalSurvey: `Ankieta zewnętrzna`,
        isExternalTestQuiz: `Test/quiz zewnętrzny`,
        isExternalTest: `Test zewnętrzny`,
        isExternalQuiz: `Quiz zewnętrzny`,
        isNotExternalSurvey: `Ankieta nie jest zewnętrzna`,
        isNotExternalTest: `Test nie jest zewnętrzny`,
        surveyType: `Test/Quiz`,
        surveyTitle: `Tytuł`,
        surveyDescription: `Opis`,
        surveyPassword: `Hasło`,
        surveyTime: `Czas na wypełnienie w minutach`,
        randomOrderOfQuestions: `Losowa kolejność pytań przy rozwiązywaniu`,
        showPointsForGoodAndBadAnswer: `Wyświetl punkty za odpowiedzi`,
        activityToken: `Dotyczy zajęć`,
        dateFrom: `Data rozpoczęcia dostępności`,
        dateTo: `Data zakończenia dostępności`,
        daysAvailable: `Ilość dni dostępności`,
        surveyUserData: `Użytkownicy, którzy mogą wypełniać`,
        select: `Proszę wybrać`,
        surveyGroups: `Grupy, które mogą wypełniać`,
        surveyQuestions: `Pytania`,
        answers: `Odpowiedzi`,
        goodAnswer: `Odpowiedź poprawna`,
        badAnswer: `Odpowiedź błędna`,
        questionDescription: `Pytanie`,
        pointsForGoodAnswer: `Punkty za poprawną odpowiedź`,
        pointsForBadAnswer: `Punkty za złą odpowiedź`,
        answerDescription: `Odpowiedź`,
        isValid: `Poprawna`,
        questionType: `Rodzaj pytania`,
        questionTypeDescription: `Opisowe`,
        questionTypeOneAnswer: `Jednokrotnego wyboru`,
        questionTypeManyAnswers: `Wielokrotnego wyboru`,
        questionTypeFillGaps: `Uzupełnij luki`,
        questionTypeRatingStar: `Gwiazdki`,
        questionTypeRatingSlider: `Skala liniowa`,
        questionTypeAttachment: `Załącznik`,
        allowedExtensions: 'Dopuszczalne rozszerzenia plików',
        questionGroup: `Zakładka`,
        addQuestionGroup: `Dodaj zakładkę`,
        deleteQuestionGroup: `Usuń zakładkę`,
        addQuestion: `Dodaj pytanie`,
        deleteQuestion: `Usuń pytanie`,
        addAnswer: `Dodaj odpowiedź`,
        deleteAnswer: `Usuń odpowiedź`,
        question: `Pytanie`,
        activeSurvey: `Ankieta aktywna`,
        activeTest: `Test aktywny`,
        activeQuiz: `Quiz aktywny`,
        allowedDomain: `Domena na której będzie działać formularz`,
        allowedDomainExample: `Przykład: edusky.pl`,
        includeCSS: `Osadź w formularzu Bootstrap CSS`,
        includeJS: `Osadź w formularzu bibliotekę Bootstrap JS`,
        sendEmailToOwner: `Wyślij wiadomość po wypełnieniu do właściciela`,
        sendEmailToOffice: `Wyślij wiadomość po wypełnieniu do biura`,
        customEmail: `Własna treść wiadomości`,
        customEmailContent: `Treść własnej wiadomości`,
        sendEmailAfter: `Wyślij wiadomość po zatwierdzeniu`,
        surveyResults: `Ankiety wypełnione przez użytkowników`,
        displaySurveySetting: `Ustawienia podstawowe`,
        displayExternalSurveySetting: `Ustawienia dla ankiety zewnętrznej`,
        displayExternalTestSetting: `Ustawienia dla testu zewnętrznego`,
        mailFormSetting: `Ustawienia powiadomień`,
        allowedUsers: `Odbiorcy, którzy mają dostęp`,
        alreadyFilled: `Odpowiedzi zostały już udzielone. Z tego powodu nie można już zmienić pytań.`,
        validAnswer: `Prawidłowe odpowiedzi`,
        validAutoAnswer: `Prawidłowe odpowiedzi, które automatycznie zaliczą pytanie`,
        addValidAnswer: `Dodaj dopuszczalną odpowiedź`,
        addDocument: `Dodaj zawartość do pytania`,
        documentQuestion: `Zawartość do pytania`,
        addDocumentToGroupsQuestions: `Dodaj zawartość do zakładki`,
        groupsQuestionsTitle: `Tytuł zakładki`,
        groupsQuestionsDescription: `Opis zakładki`,
        buildQuestion: `Zbuduj pytanie do uzupełnienia`,
        buildQuestionInstruction: `Schemat budowania pytania: Treść pytania [odpowiedź] dalsza część pytania [kolejna odpowiedź]. Jeśli dopuszczalne jest więcej odpowiedzi w jednej luce, to należy rozdzielić je średnikiem.`,
        surveyPeriod: `Rodzaj testu`,
        surveyPeriodNone: `Brak`,
        surveyPeriodPartial: `Cząstkowy`,
        surveyPeriodSemester: `Semestralny`,
        surveyPeriodFinal: `Okresowy/końcowy`,
        surveyPeriodElearning: 'Dla lekcji w materiale nauczania',
        surveyPeriodPlacement: 'Poziomujący',
        exerciseType: `Typ ćwiczenia`,
        exerciseOnly: `Ćwiczenie`,
        testOnly: `Test/sprawdzian`,
        version: `Wersja formularza`,
        ratingScaleMaxStar: `Maksymalna wartość oceny (2-5)`,
        ratingScaleMaxSlider: `Maksymalna wartość oceny (2-10)`,
        ratingTypeStar: `Gwiazdki`,
        ratingTypeSlider: `Skala liniowa`,
        anonymous: `Ankieta anonimowa`,
        allowMultiComplete: `Zezwalaj na wielokrotne wypełnianie ankiety przez tego samego użytownika`
      }
    },
    surveyresults: {
      list: {
        createdAt: 'Utworzono',
        startedAt: 'Rozpoczęto',
        completedAt: 'Zakończono',
        linkToPage: 'Link do strony'
      },
      show: {
        noDocument: 'Nie załączono dokumentu do tego pytania'
      }
    },
    404: {
      title: `Strona nie znaleziona`,
      description: `Ups! Wygląda na to, że ta strona nie istnieje.`,
      navigateBack: `Możesz wrócić do`,
      linkBacktoHomePage: `strony głównej`
    },
    documenttype: {
      list: {
        title: 'Tytuł',
        subtitle: 'Podtytuł',
        specialInfo: 'Informacje dodatkowe',
        language: 'Język',
        version: 'Wersja',
        noDocuments: 'Brak dokumentów'
      },
      form: {
        title: 'Tytuł',
        subtitle: 'Podtytuł (opcjonalnie)',
        specialInfo: 'Informacje dodatkowe (opcjonalnie)',
        language: 'Język',
        version: 'Wersja',
        caseTypesAllowed: 'Typy zleceń, do których można dodać dokument tej kategorii',
        accessType: 'Widoczność',
        accessTypeOptions: {
          all: 'Wszyscy',
          byRoles: 'Tylko dla wybranych ról',
          self: 'Tylko swoje'
        },
        rolesToViewAllowed: 'Role, które mogą zobaczyć dokument'
      }
    }
  },
  fieldTypes: {
    input: `pole tekstowe`,
    select: `lista wyboru`,
    datetime: `data`,
    multiSelect: 'lista wielokrotnego wyboru',
    inputFormatted: `pole tekstowe sformatowane`,
    itemsCollection: `lista towarów`,
    idUserData: `osoba/firma z systemu do wyboru`
  }
}

export default pl_drogbruk // eslint-disable-line
